webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export byClassName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return qs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return qsa; });
/* unused harmony export getData */
/* unused harmony export inViewport */
/* harmony export (immutable) */ __webpack_exports__["d"] = isMobile;
/* unused harmony export isTablet */
/* harmony export (immutable) */ __webpack_exports__["e"] = lerp;
/* harmony export (immutable) */ __webpack_exports__["i"] = viewportSize;
/* harmony export (immutable) */ __webpack_exports__["h"] = roundDec;
/* unused harmony export degrees */
/* unused harmony export radians */
/* unused harmony export getRandom */
/* harmony export (immutable) */ __webpack_exports__["c"] = isDevice;
/* harmony export (immutable) */ __webpack_exports__["b"] = findAncestor;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(116);




var byClassName = function byClassName(selector) {
  var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

  Array.toArray(ctx.getElementsByClassName(selector));
};

var qs = function qs(selector) {
  var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return ctx.querySelector(selector);
};

var qsa = function qsa(selector) {
  var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(ctx.querySelectorAll(selector));
};

var getData = function getData(attr, ctx) {
  return ctx.hasAttribute('data-' + attr) ? ctx.getAttribute('data-' + attr) : '';
};

function inViewport(element) {
  var rect = element.getBoundingClientRect();
  var html = document.documentElement;

  return rect.top >= 0 && rect.top < html.clientHeight || rect.bottom >= 0 && rect.bottom < html.clientHeight;
}

var getDevice = function getDevice() {
  var device = window.getComputedStyle(document.body, '::after').getPropertyValue('content');
  device = device.replace(/('|")/g, '');

  return device;
};

function isMobile() {
  return !(getDevice() !== 'xxs' && getDevice() !== 'xs');
}

function isTablet() {
  return !(getDevice() !== 'sm' && getDevice() !== 'md');
}

function lerp(a, b, n) {
  return (1 - n) * a + n * b;
}

function viewportSize() {
  var coords = {
    width: window.innerWidth,
    height: window.innerHeight,
    ratio: window.innerWidth / window.innerHeight
  };

  return coords;
}

function roundDec(n) {
  return Math.round(n * 100) / 100;
}

function degrees(radians) {
  return radians * 180 / Math.PI;
};

function radians(degrees) {
  return degrees * Math.PI / 180;
};

function getRandom(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function isDevice() {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

function findAncestor(el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls)) {}
  return el;
}

function fetchData(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.lang !== to.params.lang) __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('CHANGE_LANG', to.params.lang);

  if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.eventsList !== null) {
    if (to.name === 'home') next();
  } else {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('FETCH_EVENTSLIST').then(function (res) {
      if (!res) __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/404');else if (to.name === 'home') next();
    });
  }

  if (to.name === 'event') {
    var currentEvent = to.params.event !== null ? __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.events.find(function (el) {
      return el.id === to.params.event;
    }) : undefined;

    if (currentEvent !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('SET_EVENT', currentEvent);
      next();
    } else {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('FETCH_EVENT', to.params.event).then(function (res) {
        if (!res) __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/404');else next();
      });
    }
  }
};

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state__ = __webpack_require__(251);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_5__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timelines_hover__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timelines_canvas__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timelines_loaderAnimation__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__timelines_cursor__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__timelines_eventsListTransitions__ = __webpack_require__(129);







var animations = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

animations.set('hover', __WEBPACK_IMPORTED_MODULE_1__timelines_hover__["a" /* default */]);
animations.set('canvasHover', __WEBPACK_IMPORTED_MODULE_2__timelines_canvas__["a" /* default */]);
animations.set('loader', __WEBPACK_IMPORTED_MODULE_3__timelines_loaderAnimation__["a" /* default */]);
animations.set('eventsListIn', __WEBPACK_IMPORTED_MODULE_5__timelines_eventsListTransitions__["a" /* eventsListIn */]);
animations.set('cursor', __WEBPACK_IMPORTED_MODULE_4__timelines_cursor__["a" /* default */]);
animations.set('eventsListIn', __WEBPACK_IMPORTED_MODULE_5__timelines_eventsListTransitions__["a" /* eventsListIn */]);
animations.set('eventsListOut', __WEBPACK_IMPORTED_MODULE_5__timelines_eventsListTransitions__["b" /* eventsListOut */]);

/* harmony default export */ __webpack_exports__["a"] = (animations);

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return museletLoaderIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return museletIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return museletOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_utils__ = __webpack_require__(4);



var museletLoaderIn = function museletLoaderIn(el) {
  var muselet = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.muselet__dot', el);
  var logo = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.logo-winary', el);

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]();

  tl.to(logo, 0.6, {
    autoAlpha: 0,
    delay: 0.3
  }).fromTo(muselet, 1.8, {
    scale: 0.3
  }, {
    scale: 1,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["f" /* Power4 */].easeInOut,
    clearProps: 'all'
  });

  return tl;
};

var museletIn = function museletIn(el) {
  var muselet = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.muselet__dot', el);

  var artwork = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.artwork', el);

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]();

  tl.add('start').to(muselet, 1.4, {
    scale: 1,
    x: 0,
    y: 0,
    xPercent: 0,
    yPercent: 0,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["f" /* Power4 */].easeInOut,
    clearProps: 'all'
  }, 'start').to(artwork, 1.4, {
    scale: 1,
    x: 0,
    y: 0,
    xPercent: -50,
    yPercent: -50,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["f" /* Power4 */].easeInOut
  }, 'start+=0.1');

  return tl;
};

var museletOut = function museletOut(el) {
  var view = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('[js-view]', el).getAttribute('js-view');

  var muselet = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.muselet__dot', el);
  var artwork = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.artwork', el);

  var contW = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('[js-pagecontainer]', el).getBoundingClientRect().width;
  var contH = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('[js-pagecontainer]', el).getBoundingClientRect().height;
  // const windowW = window.innerWidth;

  var tXm = !Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["d" /* isMobile */])() ? (contW - muselet.getBoundingClientRect().width * 0.8) / 2 : 0;
  var tYm = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["d" /* isMobile */])() ? (contH - muselet.getBoundingClientRect().height * 1.4) / 2 + muselet.getBoundingClientRect().height : 0; // eslint-disable-line
  var tXa = (contW - artwork.getBoundingClientRect().width * 0.8) / 2;
  var tYa = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["d" /* isMobile */])() ? (contH - artwork.getBoundingClientRect().height * 0.8) / 2 + artwork.getBoundingClientRect().height / 5.5 : 0; // eslint-disable-line

  // const tXmP = isMobile() ? 0 : ((100 * tXm) / windowW) + 20;
  // const tXaP = isMobile() ? -50 : ((100 * tXa) / windowW) - (0.8 * 50);

  var scaleM = 0.8;
  // let tYmP = 0;
  // let tYap = -50;

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]();

  if (Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["d" /* isMobile */])() && view === 'event') {
    //   tYmP = -120;
    scaleM = 1.4;

    //   tYap = -105;
  }

  tl.add('start').to(muselet, 1.4, {
    x: tXm,
    y: -tYm,
    scale: scaleM,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["f" /* Power4 */].easeInOut
  }, 'start').to(artwork, 1.4, {
    scale: 0.8,
    x: tXa,
    y: -tYa,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["f" /* Power4 */].easeInOut
  }, 'start+=0.1');

  return tl;
};

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cta_vue__ = __webpack_require__(134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5189649c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cta_vue__ = __webpack_require__(299);
function injectStyle (ssrContext) {
  __webpack_require__(297)
  __webpack_require__(298)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5189649c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5189649c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Paragraph_vue__ = __webpack_require__(136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d3a76e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Paragraph_vue__ = __webpack_require__(305);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1d3a76e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Paragraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d3a76e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Paragraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fontfaceobserver__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fontfaceobserver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fontfaceobserver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Header__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Muselet__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Artwork__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_utils_Cta__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Footer__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_BgNoise__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Pointer__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CircleSwitch__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Whistle__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__scripts_transitions__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__scripts_animations__ = __webpack_require__(39);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: {
    Header: __WEBPACK_IMPORTED_MODULE_5__components_Header__["a" /* default */],
    Muselet: __WEBPACK_IMPORTED_MODULE_6__components_Muselet__["a" /* default */],
    Artwork: __WEBPACK_IMPORTED_MODULE_7__components_Artwork__["a" /* default */],
    Cta: __WEBPACK_IMPORTED_MODULE_8__components_utils_Cta__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_9__components_Footer__["a" /* default */],
    BgNoise: __WEBPACK_IMPORTED_MODULE_10__components_BgNoise__["a" /* default */],
    Pointer: __WEBPACK_IMPORTED_MODULE_11__components_Pointer__["a" /* default */],
    CircleSwitch: __WEBPACK_IMPORTED_MODULE_12__components_CircleSwitch__["a" /* default */],
    Whistle: __WEBPACK_IMPORTED_MODULE_13__components_Whistle__["a" /* default */]
  },

  data: function data() {
    return {
      windowW: window.innerWidth,
      prevPage: 'loader',
      isMobile: __WEBPACK_IMPORTED_MODULE_2__scripts_utils__["d" /* isMobile */],

      loading: true,
      setted: false,
      isDevice: __WEBPACK_IMPORTED_MODULE_2__scripts_utils__["c" /* isDevice */],

      buttons: [{
        symbol: 'previous',
        link: '/',
        it: {
          textPrimary: false,
          textAlt: false
        },
        en: {
          textPrimary: false,
          textAlt: false
        }
      }, {
        symbol: 'next',
        link: '/',
        it: {
          textPrimary: false,
          textAlt: false
        },
        en: {
          textPrimary: false,
          textAlt: false
        }
      }]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    currentEvent: 'getEventName',

    eventsList: 'getEventsList',

    lang: 'getLang'
  }), {
    path: function path() {
      var path = this.currentEvent === null ? 'home' : this.currentEvent;
      return path;
    }
  }),

  watch: {
    currentEvent: function currentEvent(newVal) {
      if (newVal !== '' && !this.setted) this.updateBtnSlider();
    }
  },

  created: function created() {
    var _this = this;

    window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
      return _this.resize();
    }, 200));
  },
  mounted: function mounted() {
    var _this2 = this;

    var font = new __WEBPACK_IMPORTED_MODULE_4_fontfaceobserver___default.a('Playfair Display', {
      weight: 700
    });

    font.load(null, 5000).then(function () {
      if (!_this2.isMobile()) {
        __WEBPACK_IMPORTED_MODULE_15__scripts_animations__["a" /* default */].get('loader')(_this2.$el, _this2.stopLoading);
      } else {
        _this2.stopLoading();
      }
    });

    this.$eventHub.$on('windowResized', function () {
      if (_this2.windowW >= 1320 && window.innerWidth < 1320) _this2.$router.go();
      if (_this2.windowW >= 1024 && window.innerWidth < 1024) _this2.$router.go(); // eslint-disable-line
      if (_this2.windowW >= 768 && window.innerWidth < 768) _this2.$router.go(); // eslint-disable-line
      if (_this2.windowW >= 480 && window.innerWidth < 480) _this2.$router.go(); // eslint-disable-line

      if (_this2.windowW <= 1024 && window.innerWidth > 1024) _this2.$router.go(); // eslint-disable-line
      if (_this2.windowW <= 768 && window.innerWidth > 768) _this2.$router.go(); // eslint-disable-line
      if (_this2.windowW <= 480 && window.innerWidth > 480) _this2.$router.go(); // eslint-disable-line
    });
  },


  methods: {
    resize: function resize() {
      this.$eventHub.$emit('windowResized');
    },
    enter: function enter(el, done) {
      var _this3 = this;

      var page = el.getAttribute('js-page');

      var callback = function callback() {
        done();
        _this3.$store.commit('ALL_LOADED', true);
      };

      if (page === 'index') {
        __WEBPACK_IMPORTED_MODULE_14__scripts_transitions__["a" /* default */].get(page)(el, 'in', this.prevPage, callback);
      } else {
        __WEBPACK_IMPORTED_MODULE_14__scripts_transitions__["a" /* default */].get(page)(el, 'in', this.prevPage, page, callback);
      }
    },
    leave: function leave(el, done) {
      var _this4 = this;

      var page = el.getAttribute('js-page');
      var next = this.$route.name;

      var callback = function callback() {
        done();
        _this4.$store.commit('ALL_LOADED', true);
      };

      if (page === 'index') {
        __WEBPACK_IMPORTED_MODULE_14__scripts_transitions__["a" /* default */].get(page)(el, 'out', this.prevPage, callback);
      } else {
        __WEBPACK_IMPORTED_MODULE_14__scripts_transitions__["a" /* default */].get(page)(el, 'out', this.prevPage, next, callback);
      }

      this.prevPage = page;
    },
    stopLoading: function stopLoading() {
      this.loading = false;
    },
    updateBtnSlider: function updateBtnSlider() {
      var _this5 = this;

      this.setted = true;
      var currentIndex = void 0;

      this.eventsList[this.lang].forEach(function (event) {
        if (event.link === _this5.currentEvent) currentIndex = event.order;
      });

      // const current = this.events[currentIndex];
      var prev = currentIndex === 0 ? this.eventsList[this.lang].length - 1 : currentIndex - 1; // eslint-disable-line
      var next = currentIndex === this.eventsList[this.lang].length - 1 ? 0 : currentIndex + 1; // eslint-disable-line
      var eventInLang = this.eventsList[this.lang];

      if (this.buttons[0] === undefined || this.buttons[1] === undefined) {
        this.setted = false;
        return;
      }

      this.buttons[0].link = '/' + this.lang + '/' + eventInLang[prev].link;
      this.buttons[1].link = '/' + this.lang + '/' + eventInLang[next].link;

      this.setted = false;
    },
    avoidInteractions: function avoidInteractions() {
      Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["f" /* qs */])('.event__btns').classList.add('avoid');
    }
  }
});

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap_all__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Index__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Event__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(26);



 //eslint-disable-line







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',

  routes: [{
    path: '/:lang(it|en)',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Index__["a" /* default */]
  }, {
    path: '/',
    redirect: '/it'
  }, {
    path: '/:lang(it|en)/:event',
    name: 'event',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Event__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  var element = document.querySelector('.app__wrapper');
  if (element !== null) {
    element.classList.add('bg-hide');
    __WEBPACK_IMPORTED_MODULE_2_gsap_all__["a" /* TweenLite */].to(element, 1, { scrollTo: { y: 0, autoKill: false } }); //eslint-disable-line
  }

  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.lang = to.params.lang;
  Object(__WEBPACK_IMPORTED_MODULE_5__scripts_utils__["a" /* fetchData */])(to, from, next);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_DragImage__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_animations__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_EventList__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_utils_Cta__ = __webpack_require__(80);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Index',

  components: {
    EventList: __WEBPACK_IMPORTED_MODULE_7__components_EventList__["a" /* default */],
    Cta: __WEBPACK_IMPORTED_MODULE_8__components_utils_Cta__["a" /* default */]
  },

  data: function data() {
    return {
      ready: false,
      enterDone: false,
      isMobile: __WEBPACK_IMPORTED_MODULE_6__scripts_utils__["d" /* isMobile */],
      animationMus: null,
      classMouse: null,

      btn: {
        it: {
          textPrimary: 'scarica programma',
          textAlt: false
        },

        en: {
          textPrimary: 'download schedule',
          textAlt: false
        },

        symbol: 'download',

        link: 'https://festival.bersiserlini.it/static/pdf/BersiSerlini-FestivalFranciacorta2018-' + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getLang + '.pdf',
        external: true
      }
    };
  },


  watch: {
    lang: function lang(newVal, oldVal) {
      var _this = this;

      if (newVal !== oldVal) {
        this.$nextTick(function () {
          Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["f" /* qs */])('.events', _this.$el).classList.add('animating');

          var animateText = __WEBPACK_IMPORTED_MODULE_5__scripts_animations__["a" /* default */].get('eventsListIn')(Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["g" /* qsa */])('[js-anim="eventsList"]', _this.$el));
          animateText.play();

          _this.btn.link = 'https://festival.bersiserlini.it/static/pdf/BersiSerlini-FestivalFranciacorta2018-' + newVal + '.pdf';
        });
      }
    },
    mouseDown: function mouseDown(newVal, oldVal) {
      if (newVal && this.ready && !this.enterDone && !Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["d" /* isMobile */])()) {
        this.enterDone = true;
        this.dragImage.bindEvents();

        this.animationMuselet.play();

        var classMouse = this.o + '-drag';
        this.cursor.classList.replace(this.classMouse, classMouse);
        this.classMouse = classMouse;
      } else if (!newVal && oldVal && this.ready && this.enterDone && !Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["d" /* isMobile */])()) {
        this.dragImage.unbindEvents();

        document.querySelector('.cursor-hover').style.fill = '#ffd300';
        document.querySelector('.cursor-hover').style.stroke = '#ffd300';

        this.animationMuselet.reverse();
        this.enterDone = false;

        var _classMouse = this.o + '-hold';
        this.cursor.classList.replace(this.classMouse, _classMouse);
        this.classMouse = _classMouse;
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    eventsList: 'getEventsList',

    lang: 'getLang',

    mouseDown: 'getMouseDown'
  }), {
    checkWidth: function checkWidth() {
      var val = window.innerWidth > 1000;
      return val;
    }
  }),

  created: function created() {
    var _this2 = this;

    if (!this.isMobile()) this.$store.commit('SET_HOVEREVENT', false);
    this.animationMus = function () {
      return _this2.animationMuselet();
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["i" /* TweenLite */].set('.events', { autoAlpha: 0 });
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["d" /* isMobile */])()) {
      Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["f" /* qs */])('.events', this.$el).classList.add('animating');
      __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["j" /* TweenMax */].to('.composition-cont', 1, { autoAlpha: 0 });

      this.$store.commit('ADD_BUTTONS', this.$el);
      if (!this.isMobile()) {
        this.dragImage = new __WEBPACK_IMPORTED_MODULE_4__scripts_DragImage__["a" /* default */]();
        this.dragImage.init(this.$el);
      }

      setTimeout(function () {
        _this3.ready = true;
      }, 5200);

      this.animationMuselet = new __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["g" /* TimelineLite */]({ paused: true });
      this.animationMuselet.add('start').to('.index', 0.6, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["e" /* Power2 */].easeOut }, 'start').to('.muselet__dot', 1, { scale: 1.2, ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1) }, 'start+=0.1').to('.composition-cont', 1, { autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["e" /* Power2 */].easeOut }, 'start+=0.4').to('.logo', 0.8, { autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["e" /* Power2 */].easeOut }, 'start+=0.6');
    } else {
      // TweenLite.to('.muselet__dot', 1,
      // { scale: 1.2, ease: Elastic.easeOut.config(0.8, 1), delay: 0.6 });
      __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["i" /* TweenLite */].to('.logo', 0.8, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["e" /* Power2 */].easeOut, delay: 0.1 });
    }

    this.cursor = document.querySelector('.cursor');
  },


  methods: {
    hoverSections: function hoverSections(event) {
      if (window.innerWidth < 1024) return;

      this.o = event.target.getAttribute('js-position');
      var classMouse = this.$store.state.mouseDown ? this.o + '-drag' : this.o + '-hold';

      if (this.cursor.classList.contains(this.classMouse)) {
        this.cursor.classList.replace(this.classMouse, classMouse);
      } else {
        this.cursor.classList.add(classMouse);
      }

      this.classMouse = classMouse;
    },
    removeClass: function removeClass() {
      this.cursor.classList.remove(this.classMouse);
    }
  },

  beforeDestroy: function beforeDestroy() {
    var els = Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["g" /* qsa */])('.index__hover-sec', this.$el);
    els.forEach(function (el) {
      return el.style.pointerEvents = 'none';
    }); // eslint-disable-line
    if (this.cursor.classList.contains(this.classMouse)) this.cursor.classList.remove(this.classMouse); // eslint-disable-line
    if (!this.isMobile()) this.dragImage.destroy();
  }
});

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventsListIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventsListOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_lib_gsap_bonus_SplitText__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(4);

 //eslint-disable-line


var init = function init(ctx) {
  var split = new __WEBPACK_IMPORTED_MODULE_1__assets_lib_gsap_bonus_SplitText__["a" /* default */](ctx, { type: 'lines, words, chars', linesClass: 'js-splittedlines', wordsClass: 'js-splittedwords', charsClass: 'js-splittedchars' });

  split.lines.forEach(function (elem, index) {
    if (index < split.lines.length - 1 || split.lines.length === 1) {
      var el = elem;

      var line = document.createElement('div');
      line.setAttribute('data-line', '');
      line.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 18" preserveAspectRatio="none"><g fill="#1D1D1D"><path d="M999.8 12.7c.4-.2.1-.3-1.3-.1l-1 .5 2.3-.4zM989.8 13.1c-1.7.3-3.6.7-2.4.9 1.7-.4 2.1-.3 3.9-.8 1.4-.2 2.6-.1 2.3 0 .4-.1 2.3-.1 3-.4-2-.1-4.3.2-6.7.5-.6 0-.1-.1-.1-.2zM848.1 14.6h.9-.9zM760.1 13.3h1c-.6-.1-1.1-.1-1 0zM745.3 12.6h.9c-.5 0-.8-.1-.9 0zM848.1 14.6l-2.3-.1c-.3.1 1.1.1 2.3.1zM970.4 14.9c.4 0 .9-.1 1.3-.1-.4-.1-.9 0-1.3.1 0-.1 0-.1 0 0zM886.7 14.4h.7c.1 0 .4-.1.6-.1l-1.3.1zM916.6 14.2c-.7 0-.9.3-1.1.4.4-.1.9-.2 1.4-.2 0 0-.2-.1-.3-.2zM963.7 13.9l.9-.1c-.3.1-.6.1-.9.1zM865.5 14.4s-.1-.1-.3-.1c0 0 .1 0 .3.1zM34.7 17.2c-.3 0-.3 0 0 0zM.1 17.9h.4c0-.1.1-.1.1-.2l-.5.2zM717.8 11.4c.8 0 .5 0 0 0zM466 7.8c2.9.2-4.6.4-.3.6-.4-.1 3.9-.5.3-.6zM969.7 14.8h-1.3c.6.1 1 .1 1.3 0zM465.7 8.4h.4-.4zM654.7 8.7c.1.1.4.1.6.2 0-.1-.1-.1-.6-.2zM701.6 11.4l-1.1-.1c.5.1.8.1 1.1.1zM630.5 6.9c-.6-.1-.9-.2-1.7-.2.1 0 .1 0 .3.1.2 0 .7 0 1.4.1zM604.9 5.4c.1 0 .3 0 .4.1h.9l-1.3-.1zM111.8 13.3c-.6-.1-.9-.1-1.1-.2.4.2-3.3.4 1.1.2z"/><path d="M970.4 14.7c-.1.1-.4.1-.7.1h.9c-.1 0-.1-.1-.2-.1zM628.9 9c-1.3-.2-2.7-.4-4-.5 1.1.1 2.6.3 4 .5zM294.5 9.5h-1c.5.1.7 0 1 0zM613.2 7.7c-.7-.1-1.4-.2-2.3-.3-.1 0-.4 0-.4.1.8.1 1.8.2 2.7.2zM110.6 13.1z"/><path d="M84.1 14.9c3.9-.2 1.7-.4 2.6-.7 4.6-.3 2.1.2 3.7.3 2.9-.2 5-.7 7.1-.7.1.1.6.1.1.2 3-.4 9-.4 12.6-.9.3 0 .4 0 .4.1-.6-.2-.7-.4-.6-.6 1.7-.1 3.1-.4 3.9-.1-1 0-1.1.1-1.6.2l1.9-.2c1.7.3-2.4.2-2.4.5 3.6-.3 7.6-.7 10.3-.7.6.3-6.3.4-2.7.5h-4.1c3.3.4-2.6.1.4.5 5.6-.1 6.1-.4 11.7-.5 1.3-.2-.4-.3.9-.5 7.7-.6 6.1.6 11.8 0 1.4-.3 2-.7 6.1-.6l-1.4.4c5.3-.1 3-.7 8.6-.6-1 .2-4.1.3-3.4.3 3.6.2 2.6-.3 5.3-.4l.6.3c5.7-.2 11.8-.7 18.1-.9-.3.1-1.4.2 0 .3 7.9-.4 17-.4 24.6-.4l2.9-.4c.7 0 1.3.1.6.2 3 .1.1-.2 1.6-.3 1.7-.1 2.3.1 1.1.2 5.3-.4 15-.8 20.6-.6l-.9.2c4.3.1 4.9-.7 8.9-.4l-.7.1c9.4 0 19.7-.4 26.8 0 1.3-.4 9.3.1 9.9-.4 5.4.3 3.9.4 11.4.5 2 0 3-.4 5.4-.5v.3l3.4-.3 1.9.4 2.3-.1c-1 0-2-.1-1.9-.2 3.7-.1 8.9.3 9 .4l8.6-.2c-.1.1-1.6.2-2.7.2 4.6-.3.9.3 5 .1-.6-.1.3-.2.4-.2 2.1.2 6.9.2 10.4.2l-.7.2c6.4.2 13.4.1 20.7.2-2.6-.1-2-.5.1-.5l.9.3c1.4-.2-2.1-.2.6-.4 2.7.1 1.9.4.3.5l3.3-.1c.1.1-.6.1-.7.3 1.3-.2 5.6.4 7.6.1l.1.1c7.1.1 10.4.1 16.3.1.1-.3 2.4-.2 4.1-.4 4.3.1 9.1.4 14.3.4 3.7-.1 1-.2 2.7-.4.3.3 5.4.3 2.7.4 6.3 0 8 0 15.8-.3-.9-.1-1.9-.1-1.3-.2 1.4 0 3.3.1 3 .2h-.4c8.9-.4 20.4.6 27.4 0h-.4l7-.4c3.4 0-2 .2.4.3 7.9-.5 12.4-.1 18.8-.5 5 .7 17.8-.4 24.6-.1l-.4-.2c1.7-.2 2.1.1 3.4.1-.1-.1-1.9-.1-.9-.2 14.8-.5 30.6-.5 45.8-.7 5.6-.1 3.1-1 10.1-.8l-2 .4c11.1-.7 22.8-.6 33.8-1.1-.7.1-.7.2-1.7.2 2.3.2 8.6-.1 8.6-.3 1.7 0 .4.2 1.4.3 2.3.1 5.9-.3 7-.1.1 0-.7.1-1.1.1 1.6-.1 7 0 5.6-.3 4.1.1 7.9 0 11.1.1 2.1-.2 7 .4 7.7 0-.1.2 1.6.4 3.7.6 1 .1 2.1.2 3.3.3 1 .1 2 .2 2.7.2-.9 0 2.3.4 1.1.5 3 .4 5.7.5 5.3.3 5.3 1.1 11 .5 14 1.5 8.9.4 17 .7 25 1-.3.5-8.7-.4-8.4.1 7.6.3 12 .1 19.4.5 1.9.1-1.1.1-1.7.2 7.6.2 14.6.7 21.3.7 0 0-.7.1-1.4.1 1.3 0 3 .2 3 0h-1.3c-2.1-.4 5.3-.4 5.6-.6-2.3.5 6.6.4 3 1 .9 0 2-.1 1.7-.2 1.3.1 1.7.2.4.3 4.7 0 3-.2 7.3-.1 0 .1-.9.1-1.3.2 2.1-.1 4.4-.3 8-.1-.3.1.1.1-.9.1 6.3.2 10.6-.2 17.4.1-2 .4 2.3.2 2.7.6h3.7l-1.4-.2c3.1.1 6-.1 8.9.1l-2.4.1 6 .1-3.4-.2c3.3-.1-.3-.5 4-.3-.9 0 3.1.1 4.9.3 1.6-.1 3.3-.2 5.6 0 .6.1-.6.4-.1.5 1.6-.3 7.6.1 9.6-.2-.7.1-.7.3-.4.3l1.3-.2c1.4.1 1.7.1 1.4.3 4.4.1-1.4-.5 3.9-.2-.4 0-.3.1-1.1.1 5.3.2 10.3 0 15.3.2 1.4.4-4.3 0-2.6.4 7.1 0 14.7-.3 21.4-.1l-1.3-.1c1-.5 5.1.3 8.6.1-.9 0-1.1.3-.9.2 4.7.1 9.6 0 16.7-.2l-.9.1c2.7.1 7.3.1 10.3.2.9-.1 2.6-.1 1.6-.3 9.1.8 17.6-.4 25.7.3-1 0-2.3.1-1.6.1l7-.1c-.6-.2-.9-.1-2.4-.3.9-.1 2.9-.2 4.6-.3-3.1.2 0 .4 1.4.5-.3-.1.3-.1.1-.2 3.6.4.6-.5 5.6-.2l-.3.1c1.9-.1 3.6-.2 5.6-.2.9.3-2 .1-2.1.4 2.9 0 5.6-.5 8.1-.3-1.1.1-2.9.1-4.1.2 2.7.3 3.1.2 5.1.3h-.1l4.7.1-1.1-.1c3.6-.7 7.1-.2 11.8-.7-4.6.5-.7.3-1.1.6 1.1.1 3 .1 2.6.2 2.3-.3 3.7.1 6.9-.3.1.1 2.4 0 1.9.2 2.9-.1-.7-.2-.4-.3 4.4-.4 10.6.2 17-.3 5.6-.3 6.6-.7 11.7-1 1.7.1-1.4.4-1.4.4 2.9.1 5 0 7.6-.2-.6.1 0 .2.9.2 2.1-.1 1.4-.4 4.1-.4-.4.1-1.1.3-2.1.5 2.4-.2 5-.4 7.6-.7.7.1-1.6.3-2.4.5 2.9-.2 7.6-.5 8.4-.8h-1.9c1-.1.6.2-.1.3-2.4.3-3.6.1-3.7 0l1.9-.2c-2-.5-7.4.4-11.1.5l1.6-.5-3.9.5c-.9-.1-1.4-.3.4-.4-2.7-.1-2.3.2-4.7.1-.3 0-.1-.1.1-.1l-2.6.2c.6-.1-.4-.3 1.1-.3-4.7-.1-7.6.5-9.3.2h.4c-6.4.3-.6.3-5.4.8l-3.3-.7-.6.3c-.7 0-2 0-1.7-.1-2.4.3.4.1-1 .3-3.3-.2-8.9.3-9.6-.2-1.1.2 3.1.1-.3.3-1-.5-4 .2-6.9-.1.9-.3 3.7-.2.7-.4-1.7.5-5.7 0-8.1.1-.1.4-5.4.2-9.6.3.3-.1-7.9-.1-11.7-.3l.1-.1c-.7.4-4.7.3-7.7.4.1-.2.6-.3 2.1-.4h-2.7c-.7.1-1.4.2-3.3.2l.7-.3c-3.6 0-7.3.3-12 .1-.3.3 3.7.7-1.3.9-.1-.1-.4-.4 1-.4-.4 0-1.6.1-2.4.1l2-.2c-2.1-.1-1.1.2-2.9.2 0-.2-1.3-.1-1-.3.4 0 1.4.1 2.1 0-1.9 0-4.3-.2-5-.3.1.1 0 .3-1.4.3-3.6 0-1.3-.2-3.4-.3-.9.1-3.1 0-3.3.3-1 0-1.3-.1-1.7-.2-1.9.1-8.9 0-6.7.3h.4-.3c-6.1.3-12.8-.2-19-.2v-.1c-3.7.1-8.1 0-10.7.2-1.1 0-2.6-.2-2.1-.3-2.9 0-3.1.2-7.1-.1 2.9-.1-1-.2 2.9-.1-3.6-.1-4.4-.3-8.4-.1 1.3-.2-2.7-.4-4.4-.3l2.6.2c-2 0-3.6 0-5.4-.1l1-.3c-7.4-.5-13.4.5-19-.3-2 .2 4 .2 2.3.5-3.4-.1-7-.7-8-.7-4.7-.3-4.4.4-9.3.2.6.1 1.1.5-2.4.5-3.4-.1-4.1-.6-2-.6.9 0 1.3.1 1.1.1 1.1 0 2.6 0 1.1-.2l-.4.1c-1.7-.2-6.4-.2-5.3-.4-2.6.1-1.1.2.9.3-4.4-.3-6.9-.1-11.4-.4.7.1 1.4.2.7.2-6.6-.3-2.9.2-7.4.1-2.6-.2 1-.4-3.6-.4-2.7-.2-.6-.3.6-.4-4.1.1-7.7-.4-10-.5h2.1-3.4l1.3.3c-1.3-.1-2.3-.1-2.3-.2-1.3.1 1 .4-1.6.6-1.7-.2-5.1 0-5.7-.4 5.3.3-.6-.3 4-.2-.9 0-2 0-3.1-.1-.1 0 .1-.1.6-.1-5.1-.5-2.4.3-7.7.1.7-.2-1.1-.4-2-.4 2.1.1 1 .3-1 .4-3.4-.3-3.7 0-5.4-.1l2 .1c-.7.2-2.4.1-4.7 0-.1-.1 2.1 0 1.3-.1-2.7.2-5.9-.5-9.6-.5-1.7-.2-.1-.3-1.6-.5-4.1 0-4.4-.4-8.7-.4 1.3.3 1.4.3-1.6.3l7.1.2-4.6.1c2.1.1 4.6.1 5.9.1-2.1.1-2 0-1 .3-2.9-.5-5.9-.1-9.1-.5l.1-.6c-5-.5-9-.2-15.6-.7l2.1.2c-.9.2-4.1-.2-6.1-.3.3-.2-1.1-.3-2-.5.1.2-4.9-.3-5.4 0l-2.9-.5c-5.3-.5-6.1.1-11.1-.5 1.6-.1-.7-.4 2.7-.2-1.7-.2-3.1-.4-3.3-.2-.8-.1-2.1-.2-3.2-.2-1.3-.1-2.6-.2-3.3-.4-.7 0-1 .2-2.9-.1-.1-.1 0-.1 0-.1 0 .1-3-.2-1.4.2-1.3-.3-2.9-.5-4.6-.7s-3.6-.2-5.3-.3c-3.6-.2-7.1-.1-9.4-.4-3.7 0-8.3.1-11.7.1.3-.1 0-.1.7-.1-4.7-.1-2.9.6-8.3.4-2.7-.3 2.9-.2 1.1-.3-.7-.6-6.4.2-10-.1l.9-.1c-2.7-.2-6.7.4-11.1.4 0 0 .3-.1 0-.1-3 .4-8.9.6-13.1.8 1.3-.3 2-.2 1.1-.4-2 .1.6.4-3.3.6-1.3-.1-4-.2-4.4-.4l3.6-.1c-1.9-.3-4.7.1-6.6.1l.3-.2c-5.6.2-5.6.6-11.6.7l.6.1c-3.3.5-2.7-.1-6 .2l-1-.4c-2.1.2-7.6.6-11.4.7 2.1-.3 6.7-.6 9.6-.9-2.1.1-7.3.2-8.4.4.9-.1 2-.2 2.9-.1-2.6.4-6 .6-10.3.7.7-.8-11.1.1-14.3-.5-7.6.5-15 .2-23.7.4 3.1.5-2.6.1-2 .7-2 .1-2.9.1-3 0l-6.3-.3c-1.4-.2 2-.2 1.7-.3-4.4 0-1.9-.2-4.9-.4.6.2-1.6.3-4.1.3l3.6.2c-6.3.4-5.4-.4-11.7 0l2-.2c-3.3.2-12 .1-15.1.6-.6-.1-1.3-.2.1-.3-7.7 0-17.3.6-23.3.3l.6-.2c-1.4 0-2.6.3-4.3.1.1-.1.6-.2-.1-.2-.7.1-3.9.3-5.7.2l1.6-.2c-7.6-.2-11.6.3-18 .4 0-.4-5.9-.6-8.9-.7l.1-.1c-8.9-.2-15 .1-23.1.2-5-.6-17.1-.5-25.3-.9 1.3.1-.1.3-1.7.4-1.9-.1-5.3.2-5-.2h.7c-1.4-.4-5.4-.3-8.4-.3L310 7.6c-8-.8-21 .1-25.4-.5-2 .1-4.3.1-6.3.3l.1-.3c-5.4 0-8-.1-14.7 0l1.3-.2c-3.7 0-4.7.8-8.1.9l-1-.4c-6.6.1-13.1-.2-19.6.3.1-.1.3-.2 1.3-.2-3 0-11.8-.1-10.7.4-.1-.4-6.7.1-10.3.3l.6-.3c-3 .4-3 .5-7.1.7-1 0-.9-.2.4-.2-3.3-.1-2.6.3-6.6.2l1.4-.2c-3.4 0-3.1.1-5 .4-2.1.2-6.4.1-6.9-.2-.4.2-2.2.4-4.2.4-.3-.1.4-.2.9-.2-5.7 0-8.4.5-12.3.4-.1-.1-.3-.1-.7-.1 4.4-.1 8.1-.2 7.7-.2 0-.3-3.6-.2-.7-.6-2.9.3-7.9.8-11.4.8-.1 0-.3 0-.4-.1h.4c-.9 0-1.6 0-2.3.1h-2.9c-.4-.2-4.1 0-6 .1.1.3-2.1.3 0 .5-.3 0 .3 0 1.6-.1.3 0 .6 0 .7-.1h-.1c1.1 0 2.7-.1 4.4-.1-1.4.2-2.9.3-4.9.2-.9.2-1.9.4-2.4.5-2.4-.3-7.3-.4-8-.6-5.4.3-13 .5-16.4 1.2-1.6.1-1.9-.1-2.4-.1.9-.1 2-.1 2.4-.2-3.1.3-9.3.4-10 .8-4 0 2.1-.4-3.3-.2l.7-.1c-10.7-.2-17.3 1.6-29.1 1.4.9 0 1.3 0 1.4.1-6.7.1-13.7.5-20.6.9-6.9.4-13.7.7-20.4.8-3.7.1-4.1.3-6.4.6l-.9-.3-3.4.6c-5.6.6-9.7-.2-16.7.7l1 .1c-2.6.1-8 .6-7.6.3-.3.1-.9.3-1.9.2l-.1-.2-6.1.7c-4.9.2.7-.7-6.4-.3-2.6.2-7.4 1-6.4 1 1-.1 2.7-.1 2.9.1l-2.4.2c-.4.5-2.1 1.1 3.7 1l4-.6 1.3.1-3.4.2c2 .1 3.1-.2 4.6-.4.3.1 1 .1 1.7.1l4-.7c.6.2-1.7.5 1 .4 1.9-.3-1.9-.3 1.3-.6 2 .1 1.4.3 3.7 0 .3.1-.1.2-1 .3 2-.3 5.4-.4 6.4-.7 2 .1 6.9-.5 6.7 0 .6-.1 3.6-.5 5.4-.7-3.4.7 7-.4 6.1.3 2.4-.6 9.1-.7 13.6-1.2-.3.1-.7.2-1.1.1 2.6-.1 3.3 0 5 0 .3-.4 4.3-.7 6.3-1 3.1.2-1.9.5-.9.9-.1-.3 5.4-.6 4.3-.8 2.4.1 2 0 3.3.3.4-.5 2.1-.2 4.1-.6 3.4.1 1 .4 4.7.1 1.9.3-1.4.6-1.4.6zm89.9-4.1c-.7 0-1.4.1-1.9.1.4-.1.9-.1 1.9-.1zm7.6-.2c-.9 0-2 0-3.3.1-.3-.1 0-.2.7-.2-.4 0 1.5 0 2.6.1zM165.5 9c1.1-.1 1.6 0 1.7 0-.6 0-1.3.1-2.1.1h-.1s.2 0 .5-.1z"/><path d="M163.3 9.5h-.4.7c.1 0 .3-.1.4-.1-.2.1-.5.1-.7.1zM849.2 14.7h-.1.3-.2zM286 9.6h-.6zM890.9 15.7c.1 0 .3 0 .6.1-.2-.1-.3-.1-.6-.1zM908.9 15.7l2.6.1c-1.2-.1-2.1-.1-2.6-.1zM922.7 15.7c.1-.1.3-.1.3-.1l-.3.1zM702.4 13.3h-.6c-1.1 0-.2.1.6 0zM768 14.5c-.7 0-1.4.1-2.1.1 1.2 0 2.1.1 2.1-.1zM629.3 9c-.1 0-.3 0-.4-.1l.4.1zM762.8 14.5c1.1.1 2.1.1 3 .1-.8 0-2-.1-3-.1zM982.8 14.4H983.6h-.8zM983.5 14.3l.7-.1c-.2 0-.5.1-.7.1zM985.8 14.1l-1.6.1c.6 0 1.3 0 1.6-.1zM964.4 14.9l-.1.1s.1 0 .1-.1zM958.8 15.1c1.3 0 3.3.1 5.1 0l.1-.1c-.6.2-3.9-.1-5.2.1zM935.6 14.3h4.7c-.9-.1-1.9-.2.3-.3-6-.2 1.1.3-5 .3zM921 14.3c2.6-.1 0-.2.1-.2-1.5.1-1.9.1-.1.2zM816.5 14.2l.3-.3c-2 0-.2.1-.3.3zM796.4 15.3l2 .1.8-.2zM784.7 13.2h.8l-3.3.1zM609.5 5.2l.6.3c1.2 0 1.5-.4-.6-.3zM533.5 6.7c-.9-.1-3-.2-4.3 0h4.3zM306.2 7.2l1.5-.1-2.9.1z"/></g></svg>';

      el.appendChild(line);

      __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["i" /* TweenLite */].set(line, {
        webkitClipPath: 'inset(0% 100% 0% 0%)',
        clipPath: 'inset(0% 100% 0% 0%)'
      });
    }
  });
};

var eventsListIn = function eventsListIn(els) {
  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({
    paused: true,
    onStart: function onStart() {
      Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* qs */])('.events').classList.remove('animating');
      if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* isMobile */])()) els.forEach(function (li) {
        return li.classList.add('animating');
      });
    }
  });

  if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* isMobile */])()) {
    els.forEach(function (el) {
      return init(el);
    });
    var chars = '.js-splittedchars';

    tl.set('.events', { autoAlpha: 1 }).staggerFrom(chars, 1.2, {
      yPercent: 100,
      autoAlpha: 0,
      skewX: -20,
      ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1),
      onCompleteParams: ['{self}'],
      onComplete: function onComplete(tween) {
        if (tween.target.innerHTML === '—') {
          var a = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* findAncestor */])(tween.target, 'animating');
          a.classList.remove('animating');
        }
      }
    }, 0.014);
  } else {
    els.forEach(function (el) {
      return init(el);
    });
    tl.to('.events', 0.6, { autoAlpha: 1, delay: 0.4 });
  }
  return tl;
};

var eventsListOut = function eventsListOut(chars) {
  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({ paused: true });
  tl.add('start').staggerFrom(chars, 1.2, {
    yPercent: 100,
    autoAlpha: 0,
    skewX: -20,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1)
  }, 0.014);

  return tl;
};

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SplitText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SplitText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenLite_js__ = __webpack_require__(3);
/*!
 * VERSION: 0.6.0
 * DATE: 2018-05-30
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
 * SplitText is a Club GreenSock membership benefit; You must have a valid membership to use
 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
 * This work is subject to the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */



(function (window) {

	"use strict";

	var _globals = window.GreenSockGlobals || window,
	    _namespace = function _namespace(ns) {
		var a = ns.split("."),
		    p = _globals,
		    i;
		for (i = 0; i < a.length; i++) {
			p[a[i]] = p = p[a[i]] || {};
		}
		return p;
	},
	    pkg = _namespace("com.greensock.utils"),
	    _getText = function _getText(e) {
		var type = e.nodeType,
		    result = "";
		if (type === 1 || type === 9 || type === 11) {
			if (typeof e.textContent === "string") {
				return e.textContent;
			} else {
				for (e = e.firstChild; e; e = e.nextSibling) {
					result += _getText(e);
				}
			}
		} else if (type === 3 || type === 4) {
			return e.nodeValue;
		}
		return result;
	},
	    _doc = document,
	    _getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function () {},
	    _capsExp = /([A-Z])/g,
	    _getStyle = function _getStyle(t, p, cs, str) {
		var result;
		if (cs = cs || _getComputedStyle(t, null)) {
			t = cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
			result = t || cs.length ? t : cs[p]; //Opera behaves VERY strangely - length is usually 0 and cs[p] is the only way to get accurate results EXCEPT when checking for -o-transform which only works with cs.getPropertyValue()!
		} else if (t.currentStyle) {
			cs = t.currentStyle;
			result = cs[p];
		}
		return str ? result : parseInt(result, 10) || 0;
	},
	    _isArrayLike = function _isArrayLike(e) {
		return e.length && e[0] && (e[0].nodeType && e[0].style && !e.nodeType || e[0].length && e[0][0]) ? true : false; //could be an array of jQuery objects too, so accommodate that.
	},
	    _flattenArray = function _flattenArray(a) {
		var result = [],
		    l = a.length,
		    i,
		    e,
		    j;
		for (i = 0; i < l; i++) {
			e = a[i];
			if (_isArrayLike(e)) {
				j = e.length;
				for (j = 0; j < e.length; j++) {
					result.push(e[j]);
				}
			} else {
				result.push(e);
			}
		}
		return result;
	},

	//some characters are combining marks (think diacritics/accents in European languages) which involve 2 or 4 characters that combine in the browser to form a single character. Pass in the remaining text and an array of the special characters to search for and if the text starts with one of those special characters, it'll spit back the number of characters to retain (often 2 or 4). Used in the specialChars features that was introduced in 0.6.0.
	_findSpecialChars = function _findSpecialChars(text, chars) {
		var i = chars.length,
		    s;
		while (--i > -1) {
			s = chars[i];
			if (text.substr(0, s.length) === s) {
				return s.length;
			}
		}
	},
	    _stripExp = /(?:\r|\n|\t\t)/g,
	    //find carriage returns, new line feeds and double-tabs.
	_multipleSpacesExp = /(?:\s\s+)/g,
	    _emojiStart = 0xD800,
	    _emojiEnd = 0xDBFF,
	    _emojiLowStart = 0xDC00,
	    _emojiRegionStart = 0x1F1E6,
	    _emojiRegionEnd = 0x1F1FF,
	    _emojiModStart = 0x1f3fb,
	    _emojiModEnd = 0x1f3ff,
	    _emojiPairCode = function _emojiPairCode(s) {
		return (s.charCodeAt(0) - _emojiStart << 10) + (s.charCodeAt(1) - _emojiLowStart) + 0x10000;
	},
	    _isOldIE = _doc.all && !_doc.addEventListener,
	    _divStart = " style='position:relative;display:inline-block;" + (_isOldIE ? "*display:inline;*zoom:1;'" : "'"),
	    //note: we must use both display:inline-block and *display:inline for IE8 and earlier, otherwise it won't flow correctly (and if we only use display:inline, IE won't render most of the property tweens - very odd).
	_cssClassFunc = function _cssClassFunc(cssClass, tag) {
		cssClass = cssClass || "";
		var iterate = cssClass.indexOf("++") !== -1,
		    num = 1;
		if (iterate) {
			cssClass = cssClass.split("++").join("");
		}
		return function () {
			return "<" + tag + _divStart + (cssClass ? " class='" + cssClass + (iterate ? num++ : "") + "'>" : ">");
		};
	},
	    SplitText = pkg.SplitText = _globals.SplitText = function (element, vars) {
		if (typeof element === "string") {
			element = SplitText.selector(element);
		}
		if (!element) {
			throw "cannot split a null element.";
		}
		this.elements = _isArrayLike(element) ? _flattenArray(element) : [element];
		this.chars = [];
		this.words = [];
		this.lines = [];
		this._originals = [];
		this.vars = vars || {};
		this.split(vars);
	},
	    _swapText = function _swapText(element, oldText, newText) {
		var type = element.nodeType;
		if (type === 1 || type === 9 || type === 11) {
			for (element = element.firstChild; element; element = element.nextSibling) {
				_swapText(element, oldText, newText);
			}
		} else if (type === 3 || type === 4) {
			element.nodeValue = element.nodeValue.split(oldText).join(newText);
		}
	},
	    _pushReversed = function _pushReversed(a, merge) {
		var i = merge.length;
		while (--i > -1) {
			a.push(merge[i]);
		}
	},
	    _slice = function _slice(a) {
		//don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
		var b = [],
		    l = a.length,
		    i;
		for (i = 0; i !== l; b.push(a[i++])) {}
		return b;
	},
	    _isBeforeWordDelimiter = function _isBeforeWordDelimiter(e, root, wordDelimiter) {
		var next;
		while (e && e !== root) {
			next = e._next || e.nextSibling;
			if (next) {
				return next.textContent.charAt(0) === wordDelimiter;
			}
			e = e.parentNode || e._parent;
		}
		return false;
	},
	    _deWordify = function _deWordify(e) {
		var children = _slice(e.childNodes),
		    l = children.length,
		    i,
		    child;
		for (i = 0; i < l; i++) {
			child = children[i];
			if (child._isSplit) {
				_deWordify(child);
			} else {
				if (i && child.previousSibling.nodeType === 3) {
					child.previousSibling.nodeValue += child.nodeType === 3 ? child.nodeValue : child.firstChild.nodeValue;
				} else if (child.nodeType !== 3) {
					e.insertBefore(child.firstChild, child);
				}
				e.removeChild(child);
			}
		}
	},
	    _setPositionsAfterSplit = function _setPositionsAfterSplit(element, vars, allChars, allWords, allLines, origWidth, origHeight) {
		var cs = _getComputedStyle(element),
		    paddingLeft = _getStyle(element, "paddingLeft", cs),
		    lineOffsetY = -999,
		    borderTopAndBottom = _getStyle(element, "borderBottomWidth", cs) + _getStyle(element, "borderTopWidth", cs),
		    borderLeftAndRight = _getStyle(element, "borderLeftWidth", cs) + _getStyle(element, "borderRightWidth", cs),
		    padTopAndBottom = _getStyle(element, "paddingTop", cs) + _getStyle(element, "paddingBottom", cs),
		    padLeftAndRight = _getStyle(element, "paddingLeft", cs) + _getStyle(element, "paddingRight", cs),
		    lineThreshold = _getStyle(element, "fontSize") * 0.2,
		    textAlign = _getStyle(element, "textAlign", cs, true),
		    charArray = [],
		    wordArray = [],
		    lineArray = [],
		    wordDelimiter = vars.wordDelimiter || " ",
		    tag = vars.span ? "span" : "div",
		    types = vars.type || vars.split || "chars,words,lines",
		    lines = allLines && types.indexOf("lines") !== -1 ? [] : null,
		    words = types.indexOf("words") !== -1,
		    chars = types.indexOf("chars") !== -1,
		    absolute = vars.position === "absolute" || vars.absolute === true,
		    linesClass = vars.linesClass,
		    iterateLine = (linesClass || "").indexOf("++") !== -1,
		    spaceNodesToRemove = [],
		    i,
		    j,
		    l,
		    node,
		    nodes,
		    isChild,
		    curLine,
		    addWordSpaces,
		    style,
		    lineNode,
		    lineWidth,
		    offset;
		if (lines && element.children.length === 1 && element.children[0]._isSplit) {
			//lines are always split on the main element (not inside nested elements), so if there's only one child, bust apart lines inside that rather than forcing it all into one big line. Like <div><div>lots of stuff</div></div> - if they split the outer one, it'd all be in one line.
			element = element.children[0];
		}
		if (iterateLine) {
			linesClass = linesClass.split("++").join("");
		}

		//copy all the descendant nodes into an array (we can't use a regular nodeList because it's live and we may need to renest things)
		j = element.getElementsByTagName("*");
		l = j.length;
		nodes = [];
		for (i = 0; i < l; i++) {
			nodes[i] = j[i];
		}

		//for absolute positioning, we need to record the x/y offsets and width/height for every <div>. And even if we're not positioning things absolutely, in order to accommodate lines, we must figure out where the y offset changes so that we can sense where the lines break, and we populate the lines array.
		if (lines || absolute) {
			for (i = 0; i < l; i++) {
				node = nodes[i];
				isChild = node.parentNode === element;
				if (isChild || absolute || chars && !words) {
					offset = node.offsetTop;
					if (lines && isChild && Math.abs(offset - lineOffsetY) > lineThreshold && (node.nodeName !== "BR" || i === 0)) {
						//we found some rare occasions where a certain character like &#8209; could cause the offsetTop to be off by 1 pixel, so we build in a threshold.
						curLine = [];
						lines.push(curLine);
						lineOffsetY = offset;
					}
					if (absolute) {
						//record offset x and y, as well as width and height so that we can access them later for positioning. Grabbing them at once ensures we don't trigger a browser paint & we maximize performance.
						node._x = node.offsetLeft;
						node._y = offset;
						node._w = node.offsetWidth;
						node._h = node.offsetHeight;
					}
					if (lines) {
						if (node._isSplit && isChild || !chars && isChild || words && isChild || !words && node.parentNode.parentNode === element && !node.parentNode._isSplit) {
							curLine.push(node);
							node._x -= paddingLeft;
							if (_isBeforeWordDelimiter(node, element, wordDelimiter)) {
								node._wordEnd = true;
							}
						}
						if (node.nodeName === "BR" && (node.nextSibling && node.nextSibling.nodeName === "BR" || i === 0)) {
							//two consecutive <br> tags signify a new [empty] line. Also, if the entire block of content STARTS with a <br>, add a line.
							lines.push([]);
						}
					}
				}
			}
		}

		for (i = 0; i < l; i++) {
			node = nodes[i];
			isChild = node.parentNode === element;
			if (node.nodeName === "BR") {
				if (lines || absolute) {
					if (node.parentNode) {
						node.parentNode.removeChild(node);
					}
					nodes.splice(i--, 1);
					l--;
				} else if (!words) {
					element.appendChild(node);
				}
				continue;
			}

			if (absolute) {
				style = node.style;
				if (!words && !isChild) {
					node._x += node.parentNode._x;
					node._y += node.parentNode._y;
				}
				style.left = node._x + "px";
				style.top = node._y + "px";
				style.position = "absolute";
				style.display = "block";
				//if we don't set the width/height, things collapse in older versions of IE and the origin for transforms is thrown off in all browsers.
				style.width = node._w + 1 + "px"; //IE is 1px short sometimes. Avoid wrapping
				style.height = node._h + "px";
			}

			if (!words && chars) {
				//we always start out wrapping words in their own <div> so that line breaks happen correctly, but here we'll remove those <div> tags if necessary and renest the characters directly into the element rather than inside the word <div>
				if (node._isSplit) {
					node._next = node.nextSibling;
					node.parentNode.appendChild(node); //put it at the end to keep the order correct.
				} else if (node.parentNode._isSplit) {
					node._parent = node.parentNode;
					if (!node.previousSibling && node.firstChild) {
						node.firstChild._isFirst = true;
					}
					if (node.nextSibling && node.nextSibling.textContent === " " && !node.nextSibling.nextSibling) {
						//if the last node inside a nested element is just a space (like T<span>nested </span>), remove it otherwise it'll get placed in the wrong order. Don't remove it right away, though, because we need to sense when words/characters are before a space like _isBeforeWordDelimiter(). Removing it now would make that a false negative.
						spaceNodesToRemove.push(node.nextSibling);
					}
					node._next = node.nextSibling && node.nextSibling._isFirst ? null : node.nextSibling;
					node.parentNode.removeChild(node);
					nodes.splice(i--, 1);
					l--;
				} else if (!isChild) {
					offset = !node.nextSibling && _isBeforeWordDelimiter(node.parentNode, element, wordDelimiter); //if this is the last letter in the word (and we're not breaking by lines and not positioning things absolutely), we need to add a space afterwards so that the characters don't just mash together
					if (node.parentNode._parent) {
						node.parentNode._parent.appendChild(node);
					}
					if (offset) {
						node.parentNode.appendChild(_doc.createTextNode(" "));
					}
					if (vars.span) {
						node.style.display = "inline"; //so that word breaks are honored properly.
					}
					charArray.push(node);
				}
			} else if (node.parentNode._isSplit && !node._isSplit && node.innerHTML !== "") {
				wordArray.push(node);
			} else if (chars && !node._isSplit) {
				if (vars.span) {
					node.style.display = "inline";
				}
				charArray.push(node);
			}
		}

		i = spaceNodesToRemove.length;
		while (--i > -1) {
			spaceNodesToRemove[i].parentNode.removeChild(spaceNodesToRemove[i]);
		}

		if (lines) {
			//the next 7 lines just give us the line width in the most reliable way and figure out the left offset (if position isn't relative or absolute). We must set the width along with text-align to ensure everything works properly for various alignments.
			if (absolute) {
				lineNode = _doc.createElement(tag);
				element.appendChild(lineNode);
				lineWidth = lineNode.offsetWidth + "px";
				offset = lineNode.offsetParent === element ? 0 : element.offsetLeft;
				element.removeChild(lineNode);
			}
			style = element.style.cssText;
			element.style.cssText = "display:none;"; //to improve performance, set display:none on the element so that the browser doesn't have to worry about reflowing or rendering while we're renesting things. We'll revert the cssText later.
			//we can't use element.innerHTML = "" because that causes IE to literally delete all the nodes and their content even though we've stored them in an array! So we must loop through the children and remove them.
			while (element.firstChild) {
				element.removeChild(element.firstChild);
			}
			addWordSpaces = wordDelimiter === " " && (!absolute || !words && !chars);
			for (i = 0; i < lines.length; i++) {
				curLine = lines[i];
				lineNode = _doc.createElement(tag);
				lineNode.style.cssText = "display:block;text-align:" + textAlign + ";position:" + (absolute ? "absolute;" : "relative;");
				if (linesClass) {
					lineNode.className = linesClass + (iterateLine ? i + 1 : "");
				}
				lineArray.push(lineNode);
				l = curLine.length;
				for (j = 0; j < l; j++) {
					if (curLine[j].nodeName !== "BR") {
						node = curLine[j];
						lineNode.appendChild(node);
						if (addWordSpaces && node._wordEnd) {
							lineNode.appendChild(_doc.createTextNode(" "));
						}
						if (absolute) {
							if (j === 0) {
								lineNode.style.top = node._y + "px";
								lineNode.style.left = paddingLeft + offset + "px";
							}
							node.style.top = "0px";
							if (offset) {
								node.style.left = node._x - offset + "px";
							}
						}
					}
				}
				if (l === 0) {
					//if there are no nodes in the line (typically meaning there were two consecutive <br> tags, just add a non-breaking space so that things display properly.
					lineNode.innerHTML = "&nbsp;";
				} else if (!words && !chars) {
					_deWordify(lineNode);
					_swapText(lineNode, String.fromCharCode(160), " ");
				}
				if (absolute) {
					lineNode.style.width = lineWidth;
					lineNode.style.height = node._h + "px";
				}
				element.appendChild(lineNode);
			}
			element.style.cssText = style;
		}

		//if everything shifts to being position:absolute, the container can collapse in terms of height or width, so fix that here.
		if (absolute) {
			if (origHeight > element.clientHeight) {
				element.style.height = origHeight - padTopAndBottom + "px";
				if (element.clientHeight < origHeight) {
					//IE8 and earlier use a different box model - we must include padding and borders
					element.style.height = origHeight + borderTopAndBottom + "px";
				}
			}
			if (origWidth > element.clientWidth) {
				element.style.width = origWidth - padLeftAndRight + "px";
				if (element.clientWidth < origWidth) {
					//IE8 and earlier use a different box model - we must include padding and borders
					element.style.width = origWidth + borderLeftAndRight + "px";
				}
			}
		}
		_pushReversed(allChars, charArray);
		_pushReversed(allWords, wordArray);
		_pushReversed(allLines, lineArray);
	},
	    _splitRawText = function _splitRawText(element, vars, wordStart, charStart) {
		var tag = vars.span ? "span" : "div",
		    types = vars.type || vars.split || "chars,words,lines",

		//words = (types.indexOf("words") !== -1),
		chars = types.indexOf("chars") !== -1,
		    absolute = vars.position === "absolute" || vars.absolute === true,
		    wordDelimiter = vars.wordDelimiter || " ",
		    space = wordDelimiter !== " " ? "" : absolute ? "&#173; " : " ",
		    wordEnd = vars.span ? "</span>" : "</div>",
		    wordIsOpen = true,
		    specialChars = vars.specialChars ? typeof vars.specialChars === "function" ? vars.specialChars : _findSpecialChars : null,
		    //specialChars can be an array or a function. For performance reasons, we always set this local "specialChars" to a function to which we pass the remaining text and whatever the original vars.specialChars was so that if it's an array, it works with the _findSpecialChars() function.
		text,
		    splitText,
		    i,
		    j,
		    l,
		    character,
		    hasTagStart,
		    emojiPair1,
		    emojiPair2,
		    testResult,
		    container = _doc.createElement("div"),
		    parent = element.parentNode;

		parent.insertBefore(container, element);
		container.textContent = element.nodeValue;
		parent.removeChild(element);
		element = container;
		text = _getText(element);
		hasTagStart = text.indexOf("<") !== -1;

		if (vars.reduceWhiteSpace !== false) {
			text = text.replace(_multipleSpacesExp, " ").replace(_stripExp, "");
		}
		if (hasTagStart) {
			text = text.split("<").join("{{LT}}"); //we can't leave "<" in the string, or when we set the innerHTML, it can be interpreted as a node
		}
		l = text.length;
		splitText = (text.charAt(0) === " " ? space : "") + wordStart();
		for (i = 0; i < l; i++) {
			character = text.charAt(i);
			if (specialChars && (testResult = specialChars(text.substr(i), vars.specialChars))) {
				// look for any specialChars that were declared. Remember, they can be passed in like {specialChars:["मी", "पा", "है"]} or a function could be defined instead. Either way, the function should return the number of characters that should be grouped together for this "character".
				character = text.substr(i, testResult || 1);
				splitText += chars && character !== " " ? charStart() + character + "</" + tag + ">" : character;
				i += testResult - 1;
			} else if (character === wordDelimiter && text.charAt(i - 1) !== wordDelimiter && i) {
				splitText += wordIsOpen ? wordEnd : "";
				wordIsOpen = false;
				while (text.charAt(i + 1) === wordDelimiter) {
					//skip over empty spaces (to avoid making them words)
					splitText += space;
					i++;
				}
				if (i === l - 1) {
					splitText += space;
				} else if (text.charAt(i + 1) !== ")") {
					splitText += space + wordStart();
					wordIsOpen = true;
				}
			} else if (character === "{" && text.substr(i, 6) === "{{LT}}") {
				splitText += chars ? charStart() + "{{LT}}" + "</" + tag + ">" : "{{LT}}";
				i += 5;
			} else if (character.charCodeAt(0) >= _emojiStart && character.charCodeAt(0) <= _emojiEnd || text.charCodeAt(i + 1) >= 0xFE00 && text.charCodeAt(i + 1) <= 0xFE0F) {
				//special emoji characters use 2 or 4 unicode characters that we must keep together.
				emojiPair1 = _emojiPairCode(text.substr(i, 2));
				emojiPair2 = _emojiPairCode(text.substr(i + 2, 2));
				j = emojiPair1 >= _emojiRegionStart && emojiPair1 <= _emojiRegionEnd && emojiPair2 >= _emojiRegionStart && emojiPair2 <= _emojiRegionEnd || emojiPair2 >= _emojiModStart && emojiPair2 <= _emojiModEnd ? 4 : 2;
				splitText += chars && character !== " " ? charStart() + text.substr(i, j) + "</" + tag + ">" : text.substr(i, j);
				i += j - 1;
			} else {
				splitText += chars && character !== " " ? charStart() + character + "</" + tag + ">" : character;
			}
		}
		element.outerHTML = splitText + (wordIsOpen ? wordEnd : "");
		if (hasTagStart) {
			_swapText(parent, "{{LT}}", "<"); //note: don't perform this on "element" because that gets replaced with all new elements when we set element.outerHTML.
		}
	},
	    _split = function _split(element, vars, wordStart, charStart) {
		var children = _slice(element.childNodes),
		    l = children.length,
		    absolute = vars.position === "absolute" || vars.absolute === true,
		    i,
		    child;

		if (element.nodeType !== 3 || l > 1) {
			vars.absolute = false;
			for (i = 0; i < l; i++) {
				child = children[i];
				if (child.nodeType !== 3 || /\S+/.test(child.nodeValue)) {
					if (absolute && child.nodeType !== 3 && _getStyle(child, "display", null, true) === "inline") {
						//if there's a child node that's display:inline, switch it to inline-block so that absolute positioning works properly (most browsers don't report offsetTop/offsetLeft properly inside a <span> for example)
						child.style.display = "inline-block";
						child.style.position = "relative";
					}
					child._isSplit = true;
					_split(child, vars, wordStart, charStart); //don't split lines on child elements
				}
			}
			vars.absolute = absolute;
			element._isSplit = true;
			return;
		}

		_splitRawText(element, vars, wordStart, charStart);
	},
	    p = SplitText.prototype;

	p.split = function (vars) {
		if (this.isSplit) {
			this.revert();
		}
		this.vars = vars = vars || this.vars;
		this._originals.length = this.chars.length = this.words.length = this.lines.length = 0;
		var i = this.elements.length,
		    tag = vars.span ? "span" : "div",
		    wordStart = _cssClassFunc(vars.wordsClass, tag),
		    charStart = _cssClassFunc(vars.charsClass, tag),
		    origHeight,
		    origWidth,
		    e;
		//we split in reversed order so that if/when we position:absolute elements, they don't affect the position of the ones after them in the document flow (shifting them up as they're taken out of the document flow).
		while (--i > -1) {
			e = this.elements[i];
			this._originals[i] = e.innerHTML;
			origHeight = e.clientHeight;
			origWidth = e.clientWidth;
			_split(e, vars, wordStart, charStart);
			_setPositionsAfterSplit(e, vars, this.chars, this.words, this.lines, origWidth, origHeight);
		}
		this.chars.reverse();
		this.words.reverse();
		this.lines.reverse();
		this.isSplit = true;
		return this;
	};

	p.revert = function () {
		if (!this._originals) {
			throw "revert() call wasn't scoped properly.";
		}
		var i = this._originals.length;
		while (--i > -1) {
			this.elements[i].innerHTML = this._originals[i];
		}
		this.chars = [];
		this.words = [];
		this.lines = [];
		this.isSplit = false;
		return this;
	};

	SplitText.selector = window.$ || window.jQuery || function (e) {
		var selector = window.$ || window.jQuery;
		if (selector) {
			SplitText.selector = selector;
			return selector(e);
		}
		return typeof document === "undefined" ? e : document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById(e.charAt(0) === "#" ? e.substr(1) : e);
	};
	SplitText.version = "0.6.0";
})(__WEBPACK_IMPORTED_MODULE_0_gsap_TweenLite_js__["k" /* _gsScope */]);

var SplitText = __WEBPACK_IMPORTED_MODULE_0_gsap_TweenLite_js__["k" /* _gsScope */].SplitText;


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_animations__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_typo_Title__ = __webpack_require__(132);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventList',

  components: {
    Title: __WEBPACK_IMPORTED_MODULE_5__components_typo_Title__["a" /* default */]
  },

  props: ['event'],

  data: function data() {
    return {
      hoverStatus: 1,
      hover: false,
      click: false
    };
  },


  watch: {
    hoverEvent: function hoverEvent(newVal) {
      this.hoverStatus = !newVal || newVal === this.event.id ? 1 : 0.2;
      this.hover = newVal === this.event.id;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    hoverEvent: 'getHoverEvent',
    lang: 'getLang'
  })),

  mounted: function mounted() {
    this.$el.addEventListener('click', this.setClick);
  },


  methods: {
    setHover: function setHover(event) {
      if (!this.click) {
        if (!this.hover) {
          this.targetEvent = event.target;
          this.targetEvent.style.zIndex = 20;
          this.$el.classList.add('hover');
          var animation = __WEBPACK_IMPORTED_MODULE_3__scripts_animations__["a" /* default */].get('hover')(this.$el);

          animation.play();
          this.$store.commit('SET_HOVEREVENT', this.event.id);
        } else {
          this.targetEvent.style.zIndex = 0;
          this.$store.commit('SET_HOVEREVENT', false);

          this.killLine(this.$el);
          this.$el.classList.remove('hover');
        }
        this.hover = this.hover ? !this.hover : true;
      } else {
        this.hover = false;
      }
    },
    setClick: function setClick() {
      this.click = true;

      Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["f" /* qs */])('.events', this.$parent.$el).classList.add('animating');
      this.killLine(this.$el);

      this.hover = false;
    },
    killLine: function killLine() {
      var lines = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["g" /* qsa */])('[data-line]', this.$el);
      lines.forEach(function (line) {
        __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite__["i" /* TweenLite */].killTweensOf(lines);

        __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite__["i" /* TweenLite */].set(line, {
          webkitClipPath: 'inset(0% 100% 0% 0%)',
          clipPath: 'inset(0% 100% 0% 0%)'
        });
      });
    }
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Title_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65245a73_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Title_vue__ = __webpack_require__(295);
function injectStyle (ssrContext) {
  __webpack_require__(294)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65245a73"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65245a73_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Title',

  props: ['text']
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap_TweenLite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_utils__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Cta',

  props: ['btn'],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    lang: 'getLang'
  })),

  mounted: function mounted() {
    this.$el.style.opacity = 0;
    var border = Object(__WEBPACK_IMPORTED_MODULE_3__scripts_utils__["f" /* qs */])('.btn__border', this.$el);

    this.setDashoffset(border);
  },


  methods: {
    setDashoffset: function setDashoffset(line) {
      var path = Object(__WEBPACK_IMPORTED_MODULE_3__scripts_utils__["f" /* qs */])('svg path', line);

      var dashoffset = Math.ceil(path.getTotalLength());
      var dasharray = Math.ceil(path.getTotalLength());

      __WEBPACK_IMPORTED_MODULE_2_gsap_TweenLite__["i" /* TweenLite */].set(path, {
        strokeDashoffset: dashoffset,
        strokeDasharray: dasharray
      });
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_typo_Title__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_typo_Paragraph__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_typo_Details__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_typo_Number__ = __webpack_require__(309);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Event',

  components: {
    Title: __WEBPACK_IMPORTED_MODULE_4__components_typo_Title__["a" /* default */],
    Paragraph: __WEBPACK_IMPORTED_MODULE_5__components_typo_Paragraph__["a" /* default */],
    Details: __WEBPACK_IMPORTED_MODULE_6__components_typo_Details__["a" /* default */],
    Number: __WEBPACK_IMPORTED_MODULE_7__components_typo_Number__["a" /* default */]
  },

  data: function data() {
    return {
      isMobile: __WEBPACK_IMPORTED_MODULE_3__scripts_utils__["d" /* isMobile */],

      label: {
        it: {
          info: 'Info & prenotazioni',
          phone: 'Tel',
          mail: 'Mail'
        },
        en: {
          info: 'Info & booking',
          phone: 'Tel',
          mail: 'Mail'
        }
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    eventData: 'getEventData',

    hoverEvent: 'getHoverEvent',

    lang: 'getLang'
  })),

  mounted: function mounted() {
    this.$el.style.opacity = 0;
    this.$store.commit('ADD_BUTTONS', Object(__WEBPACK_IMPORTED_MODULE_3__scripts_utils__["f" /* qs */])('.event__btns'));

    this.$store.commit('SET_HOVEREVENT', this.eventData.artwork);
    if (Object(__WEBPACK_IMPORTED_MODULE_3__scripts_utils__["d" /* isMobile */])()) __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["i" /* TweenLite */].to('.logo', 0.4, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["e" /* Power2 */].easeOut, delay: 0.2 });
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Paragraph',

  props: ['text']
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Details',

  props: ['info', 'title'],

  data: function data() {
    return {
      lang: this.$store.state.lang,
      label: {
        it: {
          '0_when': 'Quando',
          '1_time': 'Ore',
          '2_price': 'Prezzo',
          '3_dresscode': 'Dresscode',
          '4_language': 'Lingua',
          '5_note': 'Note',
          '6_extra': 'Note'
        },
        en: {
          '0_when': 'When',
          '1_time': 'Time',
          '2_price': 'Price',
          '3_dresscode': 'Dresscode',
          '4_language': 'Languages',
          '5_note': 'Notes',
          '6_extra': 'Notes'
        }
      }
    };
  },


  computed: {
    titleFix: function titleFix() {
      return this.label[this.lang][this.title];
    }
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Number',

  data: function data() {
    return {
      svg: {
        event00: {
          d0: 'M201.84,137.6c14.52,4.71,17.44,16.26,15.85,35.18-1.33,19-7.09,43.89-7.26,77,.14,33.12,6,58.33,7.41,77.28,1.65,18.91-1.47,30.2-16,34.9-14.09,4.53-33.49-.12-53.77-18.87-19.82-18.55-37.47-50.41-37.6-93.31.16-42.9,17.66-74.4,37.41-93C168.11,138,187.75,133.07,201.84,137.6Zm-22.48,33.55c-14.7-3.83-43.25,20.34-44.87,78.64,1.62,58.3,30.17,82.46,44.87,78.63,17.54-3.79,8.24-28.28,7-78.63C187.6,199.43,196.9,174.94,179.36,171.15Z',
          dn: 'M308.79,138.87l9.53-8.56a184,184,0,0,1,0,239l-21.84-19.62a153.79,153.79,0,0,0,27.73-152,138,138,0,0,1-23.92,29.63,121.24,121.24,0,0,0-10.48-31.36A142,142,0,0,0,308.79,138.87Z',
          n0: 'M187.74,168.17c18.93,0,33.29,7.29,43.55,21.65s15.28,34.2,15.28,60-5,45.83-15.28,60.19-24.62,21.43-43.55,21.43S154.46,324.34,144.2,310s-15.28-34.43-15.28-60.19,5-45.6,15.28-60S168.82,168.17,187.74,168.17Zm0,26.44c-20.29,0-30.55,18.47-30.55,55.18S167.45,305,187.74,305s30.55-18.46,30.55-55.17S208,194.61,187.74,194.61Z',
          nn: 'M320,170h12.54v159.6H303.8V210.12l-30.55,18.24v-31Z'
        },
        event01: {
          d0: 'M190.84,130.6c14.52,4.71,17.44,16.26,15.85,35.18-1.33,19-7.09,43.89-7.26,77,.14,33.12,6,58.33,7.41,77.28,1.65,18.91-1.47,30.2-16,34.9-14.09,4.53-33.49-.12-53.77-18.87-19.82-18.55-37.47-50.41-37.6-93.31.16-42.9,17.66-74.4,37.41-93C157.11,131,176.75,126.07,190.84,130.6Zm-22.48,33.55c-14.7-3.83-43.25,20.34-44.87,78.64,1.62,58.3,30.17,82.46,44.87,78.63,17.54-3.79,8.24-28.28,7-78.63C176.6,192.43,185.9,167.94,168.36,164.15Z',
          dn: 'M265.44,321.78a124.53,124.53,0,0,0,7.73-10.06c31.09-11,61.37-37.36,79.09-76.62,7.72-16.37,8.88-34,4.6-48.33-6.43-21.32-19.59-30.14-30.73-23.91-10.45,5.7-11.56,18.3-8.26,35.72q-13.71.69-27.21,2.53a93.23,93.23,0,0,1-2.88-38.41c1.71-13.43,5.91-25.63,16-34.58,20.74-21.47,63.32-5.07,80.23,48.12,7.56,24.64,5.77,50.29-4.1,71.82-14,30.26-34.48,54.3-57.63,70.8l50.27,26.28A228.46,228.46,0,0,1,342.59,390Z',
          n0: 'M176.74,161.17c18.93,0,33.29,7.29,43.55,21.65s15.28,34.2,15.28,60-5,45.83-15.28,60.19-24.62,21.43-43.55,21.43S143.46,317.34,133.2,303s-15.28-34.43-15.28-60.19,5-45.6,15.28-60S157.82,161.17,176.74,161.17Zm0,26.44c-20.29,0-30.55,18.47-30.55,55.18S156.45,298,176.74,298s30.55-18.46,30.55-55.17S197,187.61,176.74,187.61Z',
          nn: 'M265.44,322.59v-11.4l57-73.65c8.21-10.26,12.32-20.06,12.32-28.95,0-13-6.84-21-19.61-21-11.63,0-18.93,7.53-20.75,21l-26.45-5a42.86,42.86,0,0,1,14.6-30.32c8.89-8,20.06-12.08,33.28-12.08,29.87,0,47.65,18.69,47.65,46.28,0,13.22-4.56,25.76-13.68,37.85l-39,50.84h56.08v26.45Z'
        },
        event02: {
          d0: 'M183.84,138.6c14.52,4.71,17.44,16.26,15.85,35.18-1.33,19-7.09,43.89-7.26,77,.14,33.12,6,58.33,7.41,77.28,1.65,18.91-1.47,30.2-16,34.9-14.09,4.53-33.49-.12-53.77-18.87-19.82-18.55-37.47-50.41-37.6-93.31.16-42.9,17.66-74.4,37.41-93C150.11,139,169.75,134.07,183.84,138.6Zm-22.48,33.55c-14.7-3.83-43.25,20.34-44.87,78.64,1.62,58.29,30.17,82.46,44.87,78.63,17.54-3.79,8.24-28.28,7-78.63C169.6,200.43,178.9,175.94,161.36,172.15Z',
          dn: 'M309.68,291.7c-1.7,20.47-.12,34.15,12,40.69,12.78,7.4,32-4.25,39.09-32.61,7.18-31.63-5-49.44-19.57-48.78a24.91,24.91,0,0,0-14.07,4.88,145.35,145.35,0,0,0-12.38-21.16,152.66,152.66,0,0,0,11.43-66.06l-45.56,23.79a131,131,0,0,0-17.18-25.7L333,105.4q6.72,7.86,12.59,16.15c9.59,35.52,8.61,69.49.77,98.5a63.94,63.94,0,0,1,6.21-1.87c23.14-6.19,49.4,30.07,36.57,87.69-7.6,32-25.17,54.4-44.14,64.52-19.26,10.25-34.91,7.55-46.67-3-11.09-9.86-15.86-23.15-18.12-37.52a117.83,117.83,0,0,1,1.6-42Q295.65,290.25,309.68,291.7Z',
          n0: 'M164.74,169.17c18.93,0,33.29,7.29,43.55,21.65s15.28,34.2,15.28,60-5,45.83-15.28,60.19-24.62,21.43-43.55,21.43S131.46,325.34,121.2,311s-15.28-34.43-15.28-60.19,5-45.6,15.28-60S145.82,169.17,164.74,169.17Zm0,26.44c-20.29,0-30.55,18.47-30.55,55.18S144.45,306,164.74,306s30.55-18.46,30.55-55.17S185,195.61,164.74,195.61Z',
          nn: 'M280.34,282.71c3.88,15.5,12.31,23.25,25.76,23.25,14.82,0,25.31-10.48,25.31-26.67,0-18-10.26-28.05-25.08-28.05a29.9,29.9,0,0,0-13.91,3.42l-11.4-16,30.1-41.26H260.28V171H351.7v10l-37.62,50.84c2.74-.22,4.79-.45,6.39-.45,24.39,0,39.67,19.15,39.67,47.42,0,16.19-5,29.19-15.28,39s-23,14.59-38.76,14.59c-14.59,0-26.9-4.33-36.7-12.77-9.81-8.66-15.28-19.83-16.65-33.28Z'
        },
        event03: {
          d0: 'M139.38,157.15c21.57-8.32,34.4-10.17,39.24-1.62,5.34,8.49,2.31,27.39,3.82,58.83,1.73,31.47,8.54,59.1,10.84,77.11,2.51,18.26-.73,25.53-15.85,24.85-14.78-.77-34-8.31-53.65-20.92C104.32,282.71,87,265.74,78.87,243.75c-7.86-22-3.3-38.58,8.62-53S118.08,165.61,139.38,157.15Zm-8.72,21.28c-20.33,8.41-36.62,25.85-27.47,60.26,10.74,34.52,36.59,52.05,51.88,51.13,17.16-.61,7.75-23.94,1.79-66.41C153.27,181.49,153.11,170.35,130.66,178.43Z',
          dn: 'M297.56,311.09a155.22,155.22,0,0,0,23.52-25.65,577.85,577.85,0,0,0-65.6-24.78A117.69,117.69,0,0,0,261.73,249c37.61-25.32,65.56-62.36,72.1-100.31q17.81.24,35.79,1.29c17,38.19,14.05,82.46-5.07,120.26q8.63,3.54,17.06,7.32a168.66,168.66,0,0,1-19.48,28.56q-7.53-4.21-15.32-8.23a169,169,0,0,1-26.9,26.9Q309.11,317.71,297.56,311.09ZM302,248.41q17.35,5,34.23,11a134.35,134.35,0,0,0,11.94-65.73C337.18,213.94,321.23,232.67,302,248.41Z',
          n0: 'M171.74,158.17c18.93,0,33.29,7.29,43.55,21.65s15.28,34.2,15.28,60-5,45.83-15.28,60.19-24.62,21.43-43.55,21.43S138.46,314.34,128.2,300s-15.28-34.43-15.28-60.19,5-45.6,15.28-60S152.82,158.17,171.74,158.17Zm0,26.44c-20.29,0-30.55,18.47-30.55,55.18S151.45,295,171.74,295s30.55-18.46,30.55-55.17S192,184.61,171.74,184.61Z',
          nn: 'M326.1,319.59V290H257.47V275.36L324.73,160h30.1V263.5h17.78V290H354.83v29.64ZM292.36,263.5H326.1V202.62Z'
        },
        event04: {
          d0: 'M183.84,135.6c14.52,4.71,17.44,16.26,15.85,35.18-1.33,19-7.09,43.89-7.26,77,.14,33.12,6,58.33,7.41,77.28,1.65,18.91-1.47,30.2-16,34.9-14.09,4.53-33.49-.12-53.77-18.87-19.82-18.55-37.47-50.41-37.6-93.31.16-42.9,17.66-74.4,37.41-93C150.11,136,169.75,131.07,183.84,135.6Zm-22.48,33.55c-14.7-3.83-43.25,20.34-44.87,78.64,1.62,58.29,30.17,82.46,44.87,78.63,17.54-3.79,8.24-28.28,7-78.63C169.6,197.43,178.9,172.94,161.36,169.15Z',
          dn: 'M312,290c-2.52,19.28-.9,32,10.84,38.32,13.28,7.64,30.46-3.94,38-35.18,6.57-31-4.41-47.64-20.32-46.85-10.41.16-19.66,7.38-29.36,18.3q-8.78-3.28-17.68-6a129.81,129.81,0,0,0-23.17-98.08l62.41-55.12a221,221,0,0,1,29,43.36l-52.51,27.44a156.4,156.4,0,0,1,11.12,44.44c5.62-6.35,12.23-11.17,20.51-13.19,15.5-3.9,30.15,1.34,40.25,17.61,9.92,15.93,15.3,42.88,8,74.68-7.16,31.52-24.2,54.19-42.89,65.28-18.75,10.86-34.65,8.44-46.39-2.13-10.42-9.24-15.14-21.54-17.41-35.33a105.65,105.65,0,0,1,1.8-40.11Q298,289.33,312,290Z',
          n0: 'M169.74,166.17c18.93,0,33.29,7.29,43.55,21.65s15.28,34.2,15.28,60-5,45.83-15.28,60.19-24.62,21.43-43.55,21.43S136.46,322.34,126.2,308s-15.28-34.43-15.28-60.19,5-45.6,15.28-60S150.82,166.17,169.74,166.17Zm0,26.44c-20.29,0-30.55,18.47-30.55,55.18S149.45,303,169.74,303s30.55-18.46,30.55-55.17S190,192.61,169.74,192.61Z',
          nn: 'M288.08,280.85C291,295.67,299,303,312,303c15.5,0,23.71-10,23.71-28.27,0-18-8.89-27.59-25.08-27.59-10.26,0-19.84,4.79-28.27,14.37l-18-3.65L273.26,168h82.08v26.45h-58.6l-3.65,33.28a43.92,43.92,0,0,1,22.57-5.92c32.15,0,48.8,20.29,48.8,52.89q0,24.29-14.37,39.67c-9.57,10-22.34,15.05-38.07,15.05-13.68,0-25.31-3.87-34.89-11.86-9.34-8-14.82-18.69-16.18-31.69Z'
        },
        event05: {
          d0: 'M183.84,144.6c14.52,4.71,17.44,16.26,15.85,35.18-1.33,19-7.09,43.89-7.26,77,.14,33.12,6,58.33,7.41,77.28,1.65,18.91-1.47,30.2-16,34.9-14.09,4.53-33.49-.12-53.77-18.87-19.82-18.55-37.47-50.41-37.6-93.31.16-42.9,17.66-74.4,37.41-93C150.11,145,169.75,140.07,183.84,144.6Zm-22.48,33.55c-14.7-3.83-43.25,20.34-44.87,78.64,1.62,58.3,30.17,82.46,44.87,78.63,17.54-3.79,8.24-28.28,7-78.63C169.6,206.43,178.9,181.94,161.36,178.15Z',
          dn: 'M338.83,223.21l3.6-.71c14.51-2.95,28.55,2.2,39.79,19.84,11,17,15.66,43.22,8,73.07-7.42,28.94-24.19,50.34-43.12,60.36-19.16,10.13-34.85,7.88-46.27-2.36S285,348.86,283,333s-.78-29.91,3.17-45.13a123.09,123.09,0,0,1,11.74-29.28c16-30.83,21.25-74,3.64-119l24.28-21.43C341.78,154.93,344.61,191.59,338.83,223.21ZM324.19,338.53c12,7,31-4,38-30.54,6.77-27.32-4.22-45-18.46-44.94-14.66-.08-24.58,12.6-29.58,32.23C309.3,314.29,312.05,331.61,324.19,338.53Z',
          n0: 'M169.74,175.17c18.93,0,33.29,7.29,43.55,21.65s15.28,34.2,15.28,60-5,45.83-15.28,60.19-24.62,21.43-43.55,21.43S136.46,331.34,126.2,317s-15.28-34.43-15.28-60.19,5-45.6,15.28-60S150.82,175.17,169.74,175.17Zm0,26.44c-20.29,0-30.55,18.47-30.55,55.18S149.45,312,169.74,312s30.55-18.46,30.55-55.17S190,201.61,169.74,201.61Z',
          nn: 'M311.79,234.44h3.65c14.82,0,26.9,4.79,36.71,14.6C362,258.61,367,271.15,367,286.43c0,14.82-5,27.36-15.27,37.16s-22.8,14.82-38.08,14.82c-15,0-27.81-5-38.07-14.82s-15.28-22.34-15.28-37.16A54.31,54.31,0,0,1,268,258.38l46.52-83.21h31.92ZM313.61,312c13.91,0,24.63-10.26,24.63-25.53,0-15.73-10.26-25.54-24.63-25.54S289,270.7,289,286.43C289,301.7,299.93,312,313.61,312Z'
        },
        event06: {
          d0: 'M200.84,133.6c14.52,4.71,17.44,16.26,15.85,35.18-1.33,19-7.09,43.89-7.26,77,.14,33.12,6,58.33,7.41,77.28,1.65,18.91-1.47,30.2-16,34.9-14.09,4.53-33.49-.12-53.77-18.87-19.82-18.55-37.47-50.41-37.6-93.31.16-42.9,17.66-74.4,37.41-93C167.11,134,186.75,129.07,200.84,133.6Zm-22.48,33.55c-14.7-3.83-43.25,20.34-44.87,78.64,1.62,58.3,30.17,82.46,44.87,78.63,17.54-3.79,8.24-28.28,7-78.63C186.6,195.43,195.9,170.94,178.36,167.15Z',
          dn: 'M343.7,101.78a223.62,223.62,0,0,1,14.61,19.1c39.21,94.79,2,188.05-60.38,228.44l-21.5-19c48.5-27.52,83.1-93.4,66.16-168.58L286.31,191a122,122,0,0,0-16.12-24.19Z',
          n0: 'M186.74,164.17c18.93,0,33.29,7.29,43.55,21.65s15.28,34.2,15.28,60-5,45.83-15.28,60.19-24.62,21.43-43.55,21.43S153.46,320.34,143.2,306s-15.28-34.43-15.28-60.19,5-45.6,15.28-60S167.82,164.17,186.74,164.17Zm0,26.44c-20.29,0-30.55,18.47-30.55,55.18S166.45,301,186.74,301s30.55-18.46,30.55-55.17S207,190.61,186.74,190.61Z',
          nn: 'M366.86,166v11.85L306.67,325.59H278.4l54.49-133.15h-62.7V166Z'
        },
        event07: {
          d0: 'M186.84,135.6c14.52,4.71,17.44,16.26,15.85,35.18-1.33,19-7.09,43.89-7.26,77,.14,33.12,6,58.33,7.41,77.28,1.65,18.91-1.47,30.2-16,34.9-14.09,4.53-33.49-.12-53.77-18.87-19.82-18.55-37.47-50.41-37.6-93.31.16-42.9,17.66-74.4,37.41-93C153.11,136,172.75,131.07,186.84,135.6Zm-22.48,33.55c-14.7-3.83-43.25,20.34-44.87,78.64,1.62,58.29,30.17,82.46,44.87,78.63,17.54-3.79,8.24-28.28,7-78.63C172.6,197.43,181.9,172.94,164.36,169.15Z',
          dn: 'M374.4,236.81c14.87,13.17,22.4,39.83,13.05,73.72-8.12,28.92-25,48.76-42.91,56.91-18,8.42-32.82,5.71-43.57-3.93-10.93-9.72-15.47-23.25-18-38.23-2.27-15-.75-28.48,3.6-43.84,4.92-17.87,12-30.48,25.58-41.29-10.43-9.16-16.81-19.83-21.56-34.1a94.14,94.14,0,0,1-4.86-38.7c1.19-13.86,5-26.18,15.19-35.28,10.07-9,23.58-11.06,39.62-2.78,16.05,8.06,30,24.25,37.51,46.52C386.39,200.65,383.73,222.15,374.4,236.81Zm-31.28,24.78c-6.66-.52-12.55,2.07-17.59,7.05s-8.54,11.87-11,20.84-3.16,16.75-1.51,23.82,5.26,12.47,11.18,15.6,12.57,2.94,19.4-1.59,12.72-13,16-24.82,2.66-22.07-.79-29.39S349.75,262.1,343.12,261.59Zm-1.39-40c11.52-1.42,17.65-16.43,11.16-36.28-6.53-19.43-20.36-27.76-30.39-21.82-10.23,6-11.21,19.27-6.21,34.31C321.36,213.18,330,223.11,341.73,221.63Z',
          n0: 'M172.74,166.17c18.93,0,33.29,7.29,43.55,21.65s15.28,34.2,15.28,60-5,45.83-15.28,60.19-24.62,21.43-43.55,21.43S139.46,322.34,129.2,308s-15.28-34.43-15.28-60.19,5-45.6,15.28-60S153.82,166.17,172.74,166.17Zm0,26.44c-20.29,0-30.55,18.47-30.55,55.18S152.45,303,172.74,303s30.55-18.46,30.55-55.17S193,192.61,172.74,192.61Z',
          nn: 'M344.2,241.63q21.21,12,21.2,38.31c0,15-5,27.13-15.27,36-10,8.89-22.34,13.45-36.71,13.45s-26.67-4.56-36.93-13.45c-10-8.89-15.05-21-15.05-36,0-17.56,7.07-30.33,21-38.31-9.8-7.75-14.82-18.47-14.82-31.92a42,42,0,0,1,12.77-30.78c8.67-8.43,19.61-12.76,33.06-12.76s24.4,4.33,32.83,12.76a41.34,41.34,0,0,1,13,30.78C359.25,223.16,354.23,233.65,344.2,241.63Zm-30.78,15.28c-6.61,0-12.31,2-16.64,6.15s-6.61,9.81-6.61,16.88,2.28,12.76,6.61,16.87,10,6.15,16.64,6.15,12.31-2,16.64-6.15,6.62-9.81,6.62-16.87-2.28-12.77-6.62-16.88S320,256.91,313.42,256.91Zm0-26.45c11.63,0,19.15-8.21,19.15-20.29,0-11.86-7.52-19.84-19.15-19.84s-19.15,8-19.15,19.84C294.27,222.25,301.79,230.46,313.42,230.46Z'
        }
      }
    };
  },


  props: ['data'],

  mounted: function mounted() {
    this.$el.style.opacity = 0;
  }
});

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_header_Weather__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_header_Social__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_header_SwitchLang__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utils_Cta__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scripts_utils__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Header',

  components: {
    Weather: __WEBPACK_IMPORTED_MODULE_3__components_header_Weather__["a" /* default */],
    Social: __WEBPACK_IMPORTED_MODULE_4__components_header_Social__["a" /* default */],
    SwitchLang: __WEBPACK_IMPORTED_MODULE_5__components_header_SwitchLang__["a" /* default */],
    Cta: __WEBPACK_IMPORTED_MODULE_6__components_utils_Cta__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    lang: 'getLang',
    loaded: 'getPageLoaded'
  }), {
    text: function text() {
      var text = this.lang === 'it' ? 'tieni premuto' : 'hold on';

      return text;
    }
  }),

  data: function data() {
    return {
      isMobile: __WEBPACK_IMPORTED_MODULE_7__scripts_utils__["d" /* isMobile */],
      isDevice: __WEBPACK_IMPORTED_MODULE_7__scripts_utils__["c" /* isDevice */],
      bg: false,

      btn: {
        symbol: 'close',
        link: '/' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.lang,
        it: {
          textPrimary: 'torna',
          textAlt: 'indietro'
        },
        en: {
          textPrimary: 'back',
          textAlt: 'home'
        }
      }
    };
  },


  watch: {
    lang: function lang(newVal) {
      if (newVal) {
        this.btn.link = '/' + newVal;
      }
    }
  },

  mounted: function mounted() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["d" /* isMobile */])()) this.$el.style.opacity = 0;
    this.bgHide();

    this.$eventHub.$on('windowResized', this.bgHide);
    if (Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["d" /* isMobile */])()) Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["f" /* qs */])('.app__wrapper').addEventListener('scroll', this.bgHide);

    this.$store.commit('ADD_BUTTONS', this.$el);
  },


  methods: {
    bgHide: function bgHide() {
      this.bg = Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["f" /* qs */])('.app__wrapper').scrollTop <= 40;
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_typo_Paragraph__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_utils__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Weather',

  components: {
    Paragraph: __WEBPACK_IMPORTED_MODULE_2__components_typo_Paragraph__["a" /* default */]
  },

  data: function data() {
    return {
      text: '',
      isMobile: __WEBPACK_IMPORTED_MODULE_3__scripts_utils__["d" /* isMobile */]
    };
  },


  watch: {
    weatherData: function weatherData(newVal) {
      if (newVal) this.changeTime(parseInt(newVal.id, 10));
    },
    lang: function lang(newVal, oldVal) {
      if (newVal && oldVal) {
        this.changeTime(parseInt(this.weatherData.id, 10));
      }
    }
  },
  created: function created() {
    this.$store.dispatch('FETCH_WEATHER');
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    weatherData: 'getWeatherData',
    lang: 'getLang'
  })),

  methods: {
    changeTime: function changeTime(id) {
      switch (true) {// eslint-disable-line
        case id < 299:
          // Thunderstorm
          if (this.lang === 'it') {
            this.text = 'Festeggiamo sfidando la tempesta.';
          } else {
            this.text = 'In the storm, we party.';
          }
          break;

        case id < 399:
          // Drizzle
          if (this.lang === 'it') {
            this.text = 'Non saranno due gocce a fermare la nostra festa.';
          } else {
            this.text = 'Drizzle won\'t stop us';
          }
          break;

        case id < 599:
          // Rain
          if (this.lang === 'it') {
            this.text = 'Qui danziamo nella pioggia!';
          } else {
            this.text = 'We\'re dancing in the rain!';
          }
          break;

        case id < 699:
          // Snow
          if (this.lang === 'it') {
            this.text = 'Guerra a palle di neve dietro l\'angolo!';
          } else {
            this.text = 'Snowball war incoming!';
          }
          break;

        case id < 799:
          // Atmosphere
          if (this.lang === 'it') {
            this.text = 'Nebbia o sabbia, l\'importante è che si veda il calice!';
          } else {
            this.text = 'Sand or fog, what matters is to see your glass!';
          }
          break;

        case id >= 800:
          // Clear
          if (this.lang === 'it') {
            this.text = 'Il cielo terso chiama Festa!';
          } else {
            this.text = 'A crystal clear sky calls for a party!';
          }
          break;

        // case (id > 800): // Clear
        //   this.text = 'Remember there\'s only a cloud between you and the sun.';
        //   break;
      }
    }
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_typo_Paragraph__ = __webpack_require__(81);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Social',

  components: {
    Paragraph: __WEBPACK_IMPORTED_MODULE_0__components_typo_Paragraph__["a" /* default */]
  },

  data: function data() {
    return {
      socials: [{
        name: 'ig',
        alt: 'Instagram link',
        url: 'https://www.instagram.com/bersiserlini_franciacorta/'
      }, {
        name: 'fb',
        alt: 'Facebook link',
        url: 'https://www.facebook.com/bersiserlini.franciacorta/'
      }]
    };
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_utils__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SwitchLang',

  data: function data() {
    return {
      isMobile: __WEBPACK_IMPORTED_MODULE_4__scripts_utils__["d" /* isMobile */],

      languages: {
        it: {
          name: 'It',
          slug: 'it',
          active: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getLang === 'it'
        },

        en: {
          name: 'En',
          slug: 'en',
          active: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getLang === 'en'
        }
      },
      scale: 0
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    lang: 'getLang'
  }), {
    active: function active() {
      return this.lang === 'it' ? 'en' : 'it';
    }
  }),

  mounted: function mounted() {
    this.setScale();
  },


  methods: {
    switchLang: function switchLang(lang) {
      var _this = this;

      var circleSwitch = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["f" /* qs */])('.el-transition');
      this.setScale();

      circleSwitch.classList.add('active');

      this.$store.commit('IS_CHANGING_LANG', true);

      __WEBPACK_IMPORTED_MODULE_3_gsap_TweenMax__["i" /* TweenLite */].to(circleSwitch, 2, {
        scale: this.scale,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap_TweenMax__["b" /* Expo */].easeInOut,
        onComplete: function onComplete() {
          _this.$store.commit('CHANGE_LANG', lang);

          if (_this.$store.state.route.name === 'home') {
            _this.$router.push('/' + lang);
          } else {
            _this.$router.push('/' + lang + '/' + _this.$store.state.currentEventData.translate);
          }

          __WEBPACK_IMPORTED_MODULE_3_gsap_TweenMax__["i" /* TweenLite */].to(circleSwitch, 2, {
            scale: 0,
            ease: __WEBPACK_IMPORTED_MODULE_3_gsap_TweenMax__["b" /* Expo */].easeInOut,
            onComplete: function onComplete() {
              circleSwitch.classList.remove('active');

              _this.$store.commit('IS_CHANGING_LANG', false);
            }
          });
        }
      });
    },
    setScale: function setScale() {
      var ratio = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["i" /* viewportSize */])().ratio;
      var width = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["i" /* viewportSize */])().width;
      var height = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["i" /* viewportSize */])().height;

      var refWidth = this.$el.getBoundingClientRect().width;
      var refHeight = this.$el.getBoundingClientRect().height;

      var ref = ratio >= 1 ? width : height;
      var refDelta = ratio >= 1 ? refWidth : refHeight;

      this.scale = ref / refDelta * 5;
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_lib_gsap_bonus_MorphSVGPlugin__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Logo__ = __webpack_require__(347);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 //eslint-disable-line






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Muselet',

  data: function data() {
    return {
      isMobile: __WEBPACK_IMPORTED_MODULE_4__scripts_utils__["d" /* isMobile */]
    };
  },


  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_5__components_Logo__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    loaded: 'getPageLoaded'
  })),

  mounted: function mounted() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["d" /* isMobile */])()) __WEBPACK_IMPORTED_MODULE_1_gsap_TweenMax__["j" /* TweenMax */].set('.muselet__dot', { scale: 0.3 });

    this.morphMuslet();

    this.$eventHub.$on('windowResized', this.setPosition);
  },


  methods: {
    morphMuslet: function morphMuslet() {
      var first = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["g" /* qsa */])('.muselet__path--first', this.$el);
      var last = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["f" /* qs */])('.muselet__path--last', this.$el);

      __WEBPACK_IMPORTED_MODULE_1_gsap_TweenMax__["j" /* TweenMax */].to(first, 4, {
        morphSVG: last,
        repeat: -1,
        yoyo: true,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap_TweenMax__["d" /* Power1 */].easeInOut,
        delay: 6
      });

      __WEBPACK_IMPORTED_MODULE_1_gsap_TweenMax__["j" /* TweenMax */].to(first, 50, {
        rotation: '360',
        repeat: -1,
        transformOrigin: '50% 50%',
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap_TweenMax__["c" /* Linear */].easeNone,
        delay: 6
      });
    },
    setPosition: function setPosition() {
      // if (window.innerWidth > 1280) return;
      if (!this.loaded) return;

      var muselet = this.$refs.musletdot;

      var contW = document.querySelector('[js-pagecontainer]').getBoundingClientRect().width;
      var contH = document.querySelector('[js-pagecontainer]').getBoundingClientRect().height;
      var windowW = window.innerWidth;

      var tXa = windowW <= 767 || this.$store.state.route.name === 'home' ? 0 : (contW - muselet.getBoundingClientRect().width) / 2;

      var tYa = windowW <= 767 && this.$store.state.route.name !== 'home' ? (contH - muselet.getBoundingClientRect().height * 1.4) / 2 + muselet.getBoundingClientRect().height : 0; // eslint-disable-line

      var scaleP = 1;
      if (this.$store.state.route.name !== 'home') {
        scaleP = windowW <= 767 ? 1.4 : 0.8;
      }

      __WEBPACK_IMPORTED_MODULE_1_gsap_TweenMax__["j" /* TweenMax */].to(muselet, 0.8, {
        x: tXa,
        y: -tYa,
        scale: scaleP,
        transformOrigin: '50% 50%',
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap_TweenMax__["d" /* Power1 */].easeInOut
      });
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MorphSVGPlugin */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite_js__ = __webpack_require__(3);

/*!
 * VERSION: 0.8.11
 * DATE: 2018-05-30
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
 * MorphSVGPlugin is a Club GreenSock membership benefit; You must have a valid membership to use
 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
 * This work is subject to the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */



var _DEG2RAD = Math.PI / 180,
    _RAD2DEG = 180 / Math.PI,
    _svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
    _numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
    _selectorExp = /(^[#\.][a-z]|[a-y][a-z])/gi,
    _commands = /[achlmqstvz]/ig,
    _scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig,

//_attrExp = /(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?/gi, //finds all the attribute name/value pairs in an HTML element
//_outerTagExp = /^<([A-Za-z0-9_\-]+)((?:\s+[A-Za-z0-9_\-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/i, //takes the outerHTML and pulls out [0] - the first tag, [1] - the tag name, and [2] - the attribute name/value pairs (space-delimited)
//_wrappingQuotesExp = /^["']|["']$/g,
TweenLite = __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite_js__["k" /* _gsScope */]._gsDefine.globals.TweenLite,

//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,

_log = function _log(message) {
	if (__WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite_js__["k" /* _gsScope */].console) {
		console.log(message);
	}
},


// translates an arc into a normalized array of cubic beziers excluding the starting x/y. The circle the arc follows will be centered at 0,0 and have a radius of 1 (hence normalized). Each bezier covers no more than 90 degrees; the arc will be divided evenly into a maximum of four curves.
_normalizedArcToBeziers = function _normalizedArcToBeziers(angleStart, angleExtent) {
	var segments = Math.ceil(Math.abs(angleExtent) / 90),
	    l = 0,
	    a = [],
	    angleIncrement,
	    controlLength,
	    angle,
	    dx,
	    dy,
	    i;
	angleStart *= _DEG2RAD;
	angleExtent *= _DEG2RAD;
	angleIncrement = angleExtent / segments;
	controlLength = 4 / 3 * Math.sin(angleIncrement / 2) / (1 + Math.cos(angleIncrement / 2));
	for (i = 0; i < segments; i++) {
		angle = angleStart + i * angleIncrement;
		dx = Math.cos(angle);
		dy = Math.sin(angle);
		a[l++] = dx - controlLength * dy;
		a[l++] = dy + controlLength * dx;
		angle += angleIncrement;
		dx = Math.cos(angle);
		dy = Math.sin(angle);
		a[l++] = dx + controlLength * dy;
		a[l++] = dy - controlLength * dx;
		a[l++] = dx;
		a[l++] = dy;
	}
	return a;
},


// translates SVG arc data into an array of cubic beziers
_arcToBeziers = function _arcToBeziers(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y) {
	if (lastX === x && lastY === y) {
		return;
	}
	rx = Math.abs(rx);
	ry = Math.abs(ry);
	var angleRad = angle % 360 * _DEG2RAD,
	    cosAngle = Math.cos(angleRad),
	    sinAngle = Math.sin(angleRad),
	    dx2 = (lastX - x) / 2,
	    dy2 = (lastY - y) / 2,
	    x1 = cosAngle * dx2 + sinAngle * dy2,
	    y1 = -sinAngle * dx2 + cosAngle * dy2,
	    rx_sq = rx * rx,
	    ry_sq = ry * ry,
	    x1_sq = x1 * x1,
	    y1_sq = y1 * y1,
	    radiiCheck = x1_sq / rx_sq + y1_sq / ry_sq;
	if (radiiCheck > 1) {
		rx = Math.sqrt(radiiCheck) * rx;
		ry = Math.sqrt(radiiCheck) * ry;
		rx_sq = rx * rx;
		ry_sq = ry * ry;
	}
	var sign = largeArcFlag === sweepFlag ? -1 : 1,
	    sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
	if (sq < 0) {
		sq = 0;
	}
	var coef = sign * Math.sqrt(sq),
	    cx1 = coef * (rx * y1 / ry),
	    cy1 = coef * -(ry * x1 / rx),
	    sx2 = (lastX + x) / 2,
	    sy2 = (lastY + y) / 2,
	    cx = sx2 + (cosAngle * cx1 - sinAngle * cy1),
	    cy = sy2 + (sinAngle * cx1 + cosAngle * cy1),
	    ux = (x1 - cx1) / rx,
	    uy = (y1 - cy1) / ry,
	    vx = (-x1 - cx1) / rx,
	    vy = (-y1 - cy1) / ry,
	    n = Math.sqrt(ux * ux + uy * uy),
	    p = ux;
	sign = uy < 0 ? -1 : 1;
	var angleStart = sign * Math.acos(p / n) * _RAD2DEG;

	n = Math.sqrt((ux * ux + uy * uy) * (vx * vx + vy * vy));
	p = ux * vx + uy * vy;
	sign = ux * vy - uy * vx < 0 ? -1 : 1;
	var angleExtent = sign * Math.acos(p / n) * _RAD2DEG;
	if (!sweepFlag && angleExtent > 0) {
		angleExtent -= 360;
	} else if (sweepFlag && angleExtent < 0) {
		angleExtent += 360;
	}
	angleExtent %= 360;
	angleStart %= 360;

	var bezierPoints = _normalizedArcToBeziers(angleStart, angleExtent),
	    a = cosAngle * rx,
	    b = sinAngle * rx,
	    c = sinAngle * -ry,
	    d = cosAngle * ry,
	    l = bezierPoints.length - 2,
	    i,
	    px,
	    py;
	//translate all the bezier points according to the matrix...
	for (i = 0; i < l; i += 2) {
		px = bezierPoints[i];
		py = bezierPoints[i + 1];
		bezierPoints[i] = px * a + py * c + cx;
		bezierPoints[i + 1] = px * b + py * d + cy;
	}
	bezierPoints[bezierPoints.length - 2] = x; //always set the end to exactly where it's supposed to be
	bezierPoints[bezierPoints.length - 1] = y;
	return bezierPoints;
},


//Spits back an array of cubic Bezier segments that use absolute coordinates. Each segment starts with a "moveTo" command (x coordinate, then y) and then 2 control points (x, y, x, y), then anchor. The goal is to minimize memory and maximize speed.
_pathDataToBezier = function _pathDataToBezier(d) {
	var a = (d + "").replace(_scientific, function (m) {
		var n = +m;return n < 0.0001 && n > -0.0001 ? 0 : n;
	}).match(_svgPathExp) || [],
	    //some authoring programs spit out very small numbers in scientific notation like "1e-5", so make sure we round that down to 0 first.
	path = [],
	    relativeX = 0,
	    relativeY = 0,
	    elements = a.length,
	    l = 2,
	    points = 0,
	    i,
	    j,
	    x,
	    y,
	    command,
	    isRelative,
	    segment,
	    startX,
	    startY,
	    difX,
	    difY,
	    beziers,
	    prevCommand;
	if (!d || !isNaN(a[0]) || isNaN(a[1])) {
		_log("ERROR: malformed path data: " + d);
		return path;
	}
	for (i = 0; i < elements; i++) {
		prevCommand = command;
		if (isNaN(a[i])) {
			command = a[i].toUpperCase();
			isRelative = command !== a[i]; //lower case means relative
		} else {
			//commands like "C" can be strung together without any new command characters between.
			i--;
		}
		x = +a[i + 1];
		y = +a[i + 2];
		if (isRelative) {
			x += relativeX;
			y += relativeY;
		}
		if (i === 0) {
			startX = x;
			startY = y;
		}

		// "M" (move)
		if (command === "M") {
			if (segment && segment.length < 8) {
				//if the path data was funky and just had a M with no actual drawing anywhere, skip it.
				path.length -= 1;
				l = 0;
			}
			relativeX = startX = x;
			relativeY = startY = y;
			segment = [x, y];
			points += l;
			l = 2;
			path.push(segment);
			i += 2;
			command = "L"; //an "M" with more than 2 values gets interpreted as "lineTo" commands ("L").

			// "C" (cubic bezier)
		} else if (command === "C") {
			if (!segment) {
				segment = [0, 0];
			}
			segment[l++] = x;
			segment[l++] = y;
			if (!isRelative) {
				relativeX = relativeY = 0;
			}
			segment[l++] = relativeX + a[i + 3] * 1; //note: "*1" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.
			segment[l++] = relativeY + a[i + 4] * 1;
			segment[l++] = relativeX = relativeX + a[i + 5] * 1;
			segment[l++] = relativeY = relativeY + a[i + 6] * 1;
			//if (y === segment[l-1] && y === segment[l-3] && x === segment[l-2] && x === segment[l-4]) { //if all the values are the same, eliminate the waste.
			//	segment.length = l = l-6;
			//}
			i += 6;

			// "S" (continuation of cubic bezier)
		} else if (command === "S") {
			if (prevCommand === "C" || prevCommand === "S") {
				difX = relativeX - segment[l - 4];
				difY = relativeY - segment[l - 3];
				segment[l++] = relativeX + difX;
				segment[l++] = relativeY + difY;
			} else {
				segment[l++] = relativeX;
				segment[l++] = relativeY;
			}
			segment[l++] = x;
			segment[l++] = y;
			if (!isRelative) {
				relativeX = relativeY = 0;
			}
			segment[l++] = relativeX = relativeX + a[i + 3] * 1;
			segment[l++] = relativeY = relativeY + a[i + 4] * 1;
			//if (y === segment[l-1] && y === segment[l-3] && x === segment[l-2] && x === segment[l-4]) { //if all the values are the same, eliminate the waste.
			//	segment.length = l = l-6;
			//}
			i += 4;

			// "Q" (quadratic bezier)
		} else if (command === "Q") {
			difX = x - relativeX;
			difY = y - relativeY;
			segment[l++] = relativeX + difX * 2 / 3;
			segment[l++] = relativeY + difY * 2 / 3;
			if (!isRelative) {
				relativeX = relativeY = 0;
			}
			relativeX = relativeX + a[i + 3] * 1;
			relativeY = relativeY + a[i + 4] * 1;
			difX = x - relativeX;
			difY = y - relativeY;
			segment[l++] = relativeX + difX * 2 / 3;
			segment[l++] = relativeY + difY * 2 / 3;
			segment[l++] = relativeX;
			segment[l++] = relativeY;

			i += 4;

			// "T" (continuation of quadratic bezier)
		} else if (command === "T") {
			difX = relativeX - segment[l - 4];
			difY = relativeY - segment[l - 3];
			segment[l++] = relativeX + difX;
			segment[l++] = relativeY + difY;
			difX = relativeX + difX * 1.5 - x;
			difY = relativeY + difY * 1.5 - y;
			segment[l++] = x + difX * 2 / 3;
			segment[l++] = y + difY * 2 / 3;
			segment[l++] = relativeX = x;
			segment[l++] = relativeY = y;

			i += 2;

			// "H" (horizontal line)
		} else if (command === "H") {
			y = relativeY;
			//if (x !== relativeX) {
			segment[l++] = relativeX + (x - relativeX) / 3;
			segment[l++] = relativeY + (y - relativeY) / 3;
			segment[l++] = relativeX + (x - relativeX) * 2 / 3;
			segment[l++] = relativeY + (y - relativeY) * 2 / 3;
			segment[l++] = relativeX = x;
			segment[l++] = y;
			//}
			i += 1;

			// "V" (horizontal line)
		} else if (command === "V") {
			y = x; //adjust values because the first (and only one) isn't x in this case, it's y.
			x = relativeX;
			if (isRelative) {
				y += relativeY - relativeX;
			}
			//if (y !== relativeY) {
			segment[l++] = x;
			segment[l++] = relativeY + (y - relativeY) / 3;
			segment[l++] = x;
			segment[l++] = relativeY + (y - relativeY) * 2 / 3;
			segment[l++] = x;
			segment[l++] = relativeY = y;
			//}
			i += 1;

			// "L" (line) or "Z" (close)
		} else if (command === "L" || command === "Z") {
			if (command === "Z") {
				x = startX;
				y = startY;
				segment.closed = true;
			}
			if (command === "L" || Math.abs(relativeX - x) > 0.5 || Math.abs(relativeY - y) > 0.5) {
				segment[l++] = relativeX + (x - relativeX) / 3;
				segment[l++] = relativeY + (y - relativeY) / 3;
				segment[l++] = relativeX + (x - relativeX) * 2 / 3;
				segment[l++] = relativeY + (y - relativeY) * 2 / 3;
				segment[l++] = x;
				segment[l++] = y;
				if (command === "L") {
					i += 2;
				}
			}
			relativeX = x;
			relativeY = y;

			// "A" (arc)
		} else if (command === "A") {
			beziers = _arcToBeziers(relativeX, relativeY, a[i + 1] * 1, a[i + 2] * 1, a[i + 3] * 1, a[i + 4] * 1, a[i + 5] * 1, (isRelative ? relativeX : 0) + a[i + 6] * 1, (isRelative ? relativeY : 0) + a[i + 7] * 1);
			if (beziers) {
				for (j = 0; j < beziers.length; j++) {
					segment[l++] = beziers[j];
				}
			}
			relativeX = segment[l - 2];
			relativeY = segment[l - 1];
			i += 7;
		} else {
			_log("Error: malformed path data: " + d);
		}
	}
	path.totalPoints = points + l;
	return path;
},


//adds a certain number of Beziers while maintaining the path shape (so that the start/end values can have a matching quantity of points to animate). Only pass in ONE segment of the Bezier at a time. Format: [xAnchor, yAnchor, xControlPoint1, yControlPoint1, xControlPoint2, yControlPoint2, xAnchor, yAnchor, xControlPoint1, etc...]
_subdivideBezier = function _subdivideBezier(bezier, quantity) {
	var tally = 0,
	    max = 0.999999,
	    l = bezier.length,
	    newPointsPerSegment = quantity / ((l - 2) / 6),
	    ax,
	    ay,
	    cp1x,
	    cp1y,
	    cp2x,
	    cp2y,
	    bx,
	    by,
	    x1,
	    y1,
	    x2,
	    y2,
	    i,
	    t;
	for (i = 2; i < l; i += 6) {
		tally += newPointsPerSegment;
		while (tally > max) {
			//compare with 0.99999 instead of 1 in order to prevent rounding errors
			ax = bezier[i - 2];
			ay = bezier[i - 1];
			cp1x = bezier[i];
			cp1y = bezier[i + 1];
			cp2x = bezier[i + 2];
			cp2y = bezier[i + 3];
			bx = bezier[i + 4];
			by = bezier[i + 5];
			t = 1 / (Math.floor(tally) + 1); //progress along the bezier (value between 0 and 1)

			x1 = ax + (cp1x - ax) * t;
			x2 = cp1x + (cp2x - cp1x) * t;
			x1 += (x2 - x1) * t;
			x2 += (cp2x + (bx - cp2x) * t - x2) * t;

			y1 = ay + (cp1y - ay) * t;
			y2 = cp1y + (cp2y - cp1y) * t;
			y1 += (y2 - y1) * t;
			y2 += (cp2y + (by - cp2y) * t - y2) * t;

			bezier.splice(i, 4, ax + (cp1x - ax) * t, //first control point
			ay + (cp1y - ay) * t, x1, //second control point
			y1, x1 + (x2 - x1) * t, //new fabricated anchor on line
			y1 + (y2 - y1) * t, x2, //third control point
			y2, cp2x + (bx - cp2x) * t, //fourth control point
			cp2y + (by - cp2y) * t);
			i += 6;
			l += 6;
			tally--;
		}
	}
	return bezier;
},
    _bezierToPathData = function _bezierToPathData(beziers) {
	var data = "",
	    l = beziers.length,
	    rnd = 100,
	    sl,
	    s,
	    i,
	    segment;
	for (s = 0; s < l; s++) {
		segment = beziers[s];
		data += "M" + segment[0] + "," + segment[1] + " C";
		sl = segment.length;
		for (i = 2; i < sl; i++) {
			data += (segment[i++] * rnd | 0) / rnd + "," + (segment[i++] * rnd | 0) / rnd + " " + (segment[i++] * rnd | 0) / rnd + "," + (segment[i++] * rnd | 0) / rnd + " " + (segment[i++] * rnd | 0) / rnd + "," + (segment[i] * rnd | 0) / rnd + " ";
		}
		if (segment.closed) {
			data += "z";
		}
	}
	return data;
},
    _reverseBezier = function _reverseBezier(bezier) {
	var a = [],
	    i = bezier.length - 1,
	    l = 0;
	while (--i > -1) {
		a[l++] = bezier[i];
		a[l++] = bezier[i + 1];
		i--;
	}
	for (i = 0; i < l; i++) {
		bezier[i] = a[i];
	}
	bezier.reversed = bezier.reversed ? false : true;
},
    _getAverageXY = function _getAverageXY(bezier) {
	var l = bezier.length,
	    x = 0,
	    y = 0,
	    i;
	for (i = 0; i < l; i++) {
		x += bezier[i++];
		y += bezier[i];
	}
	return [x / (l / 2), y / (l / 2)];
},
    _getSize = function _getSize(bezier) {
	//rough estimate of the bounding box (based solely on the anchors) of a single segment. sets "size", "centerX", and "centerY" properties on the bezier array itself, and returns the size (width * height)
	var l = bezier.length,
	    xMax = bezier[0],
	    xMin = xMax,
	    yMax = bezier[1],
	    yMin = yMax,
	    x,
	    y,
	    i;
	for (i = 6; i < l; i += 6) {
		x = bezier[i];
		y = bezier[i + 1];
		if (x > xMax) {
			xMax = x;
		} else if (x < xMin) {
			xMin = x;
		}
		if (y > yMax) {
			yMax = y;
		} else if (y < yMin) {
			yMin = y;
		}
	}
	bezier.centerX = (xMax + xMin) / 2;
	bezier.centerY = (yMax + yMin) / 2;
	return bezier.size = (xMax - xMin) * (yMax - yMin);
},
    _getTotalSize = function _getTotalSize(bezier) {
	//rough estimate of the bounding box of the entire list of Bezier segments (based solely on the anchors). sets "size", "centerX", and "centerY" properties on the bezier array itself, and returns the size (width * height)
	var segment = bezier.length,
	    xMax = bezier[0][0],
	    xMin = xMax,
	    yMax = bezier[0][1],
	    yMin = yMax,
	    l,
	    x,
	    y,
	    i,
	    b;
	while (--segment > -1) {
		b = bezier[segment];
		l = b.length;
		for (i = 6; i < l; i += 6) {
			x = b[i];
			y = b[i + 1];
			if (x > xMax) {
				xMax = x;
			} else if (x < xMin) {
				xMin = x;
			}
			if (y > yMax) {
				yMax = y;
			} else if (y < yMin) {
				yMin = y;
			}
		}
	}
	bezier.centerX = (xMax + xMin) / 2;
	bezier.centerY = (yMax + yMin) / 2;
	return bezier.size = (xMax - xMin) * (yMax - yMin);
},
    _sortByComplexity = function _sortByComplexity(a, b) {
	return b.length - a.length;
},
    _sortBySize = function _sortBySize(a, b) {
	var sizeA = a.size || _getSize(a),
	    sizeB = b.size || _getSize(b);
	return Math.abs(sizeB - sizeA) < (sizeA + sizeB) / 20 ? b.centerX - a.centerX || b.centerY - a.centerY : sizeB - sizeA; //if the size is within 10% of each other, prioritize position from left to right, then top to bottom.
},
    _offsetBezier = function _offsetBezier(bezier, shapeIndex) {
	var a = bezier.slice(0),
	    l = bezier.length,
	    wrap = l - 2,
	    i,
	    index;
	shapeIndex = shapeIndex | 0;
	for (i = 0; i < l; i++) {
		index = (i + shapeIndex) % wrap;
		bezier[i++] = a[index];
		bezier[i] = a[index + 1];
	}
},
    _getTotalMovement = function _getTotalMovement(sb, eb, shapeIndex, offsetX, offsetY) {
	var l = sb.length,
	    d = 0,
	    wrap = l - 2,
	    index,
	    i,
	    x,
	    y;
	shapeIndex *= 6;
	for (i = 0; i < l; i += 6) {
		index = (i + shapeIndex) % wrap;
		y = sb[index] - (eb[i] - offsetX);
		x = sb[index + 1] - (eb[i + 1] - offsetY);
		d += Math.sqrt(x * x + y * y);
	}
	return d;
},
    _getClosestShapeIndex = function _getClosestShapeIndex(sb, eb, checkReverse) {
	//finds the index in a closed cubic bezier array that's closest to the angle provided (angle measured from the center or average x/y).
	var l = sb.length,
	    sCenter = _getAverageXY(sb),
	    //when comparing distances, adjust the coordinates as if the shapes are centered with each other.
	eCenter = _getAverageXY(eb),
	    offsetX = eCenter[0] - sCenter[0],
	    offsetY = eCenter[1] - sCenter[1],
	    min = _getTotalMovement(sb, eb, 0, offsetX, offsetY),
	    minIndex = 0,
	    copy,
	    d,
	    i;
	for (i = 6; i < l; i += 6) {
		d = _getTotalMovement(sb, eb, i / 6, offsetX, offsetY);
		if (d < min) {
			min = d;
			minIndex = i;
		}
	}
	if (checkReverse) {
		copy = sb.slice(0);
		_reverseBezier(copy);
		for (i = 6; i < l; i += 6) {
			d = _getTotalMovement(copy, eb, i / 6, offsetX, offsetY);
			if (d < min) {
				min = d;
				minIndex = -i;
			}
		}
	}
	return minIndex / 6;
},
    _getClosestAnchor = function _getClosestAnchor(bezier, x, y) {
	//finds the x/y of the anchor that's closest to the provided x/y coordinate (returns an array, like [x, y]). The bezier should be the top-level type that contains an array for each segment.
	var j = bezier.length,
	    closestDistance = 99999999999,
	    closestX = 0,
	    closestY = 0,
	    b,
	    dx,
	    dy,
	    d,
	    i,
	    l;
	while (--j > -1) {
		b = bezier[j];
		l = b.length;
		for (i = 0; i < l; i += 6) {
			dx = b[i] - x;
			dy = b[i + 1] - y;
			d = Math.sqrt(dx * dx + dy * dy);
			if (d < closestDistance) {
				closestDistance = d;
				closestX = b[i];
				closestY = b[i + 1];
			}
		}
	}
	return [closestX, closestY];
},
    _getClosestSegment = function _getClosestSegment(bezier, pool, startIndex, sortRatio, offsetX, offsetY) {
	//matches the bezier to the closest one in a pool (array) of beziers, assuming they are in order of size and we shouldn't drop more than 20% of the size, otherwise prioritizing location (total distance to the center). Extracts the segment out of the pool array and returns it.
	var l = pool.length,
	    index = 0,
	    minSize = Math.min(bezier.size || _getSize(bezier), pool[startIndex].size || _getSize(pool[startIndex])) * sortRatio,
	    //limit things based on a percentage of the size of either the bezier or the next element in the array, whichever is smaller.
	min = 999999999999,
	    cx = bezier.centerX + offsetX,
	    cy = bezier.centerY + offsetY,
	    size,
	    i,
	    dx,
	    dy,
	    d;
	for (i = startIndex; i < l; i++) {
		size = pool[i].size || _getSize(pool[i]);
		if (size < minSize) {
			break;
		}
		dx = pool[i].centerX - cx;
		dy = pool[i].centerY - cy;
		d = Math.sqrt(dx * dx + dy * dy);
		if (d < min) {
			index = i;
			min = d;
		}
	}
	d = pool[index];
	pool.splice(index, 1);
	return d;
},
    _equalizeSegmentQuantity = function _equalizeSegmentQuantity(start, end, shapeIndex, map) {
	//returns an array of shape indexes, 1 for each segment.
	var dif = end.length - start.length,
	    longer = dif > 0 ? end : start,
	    shorter = dif > 0 ? start : end,
	    added = 0,
	    sortMethod = map === "complexity" ? _sortByComplexity : _sortBySize,
	    sortRatio = map === "position" ? 0 : typeof map === "number" ? map : 0.8,
	    i = shorter.length,
	    shapeIndices = (typeof shapeIndex === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(shapeIndex)) === "object" && shapeIndex.push ? shapeIndex.slice(0) : [shapeIndex],
	    reverse = shapeIndices[0] === "reverse" || shapeIndices[0] < 0,
	    log = shapeIndex === "log",
	    eb,
	    sb,
	    b,
	    x,
	    y,
	    offsetX,
	    offsetY;
	if (!shorter[0]) {
		return;
	}
	if (longer.length > 1) {
		start.sort(sortMethod);
		end.sort(sortMethod);
		offsetX = longer.size || _getTotalSize(longer); //ensures centerX and centerY are defined (used below).
		offsetX = shorter.size || _getTotalSize(shorter);
		offsetX = longer.centerX - shorter.centerX;
		offsetY = longer.centerY - shorter.centerY;
		if (sortMethod === _sortBySize) {
			for (i = 0; i < shorter.length; i++) {
				longer.splice(i, 0, _getClosestSegment(shorter[i], longer, i, sortRatio, offsetX, offsetY));
			}
		}
	}
	if (dif) {
		if (dif < 0) {
			dif = -dif;
		}
		if (longer[0].length > shorter[0].length) {
			//since we use shorter[0] as the one to map the origination point of any brand new fabricated segments, do any subdividing first so that there are more points to choose from (if necessary)
			_subdivideBezier(shorter[0], (longer[0].length - shorter[0].length) / 6 | 0);
		}
		i = shorter.length;
		while (added < dif) {
			x = longer[i].size || _getSize(longer[i]); //just to ensure centerX and centerY are calculated which we use on the next line.
			b = _getClosestAnchor(shorter, longer[i].centerX, longer[i].centerY);
			x = b[0];
			y = b[1];
			shorter[i++] = [x, y, x, y, x, y, x, y];
			shorter.totalPoints += 8;
			added++;
		}
	}
	for (i = 0; i < start.length; i++) {
		eb = end[i];
		sb = start[i];
		dif = eb.length - sb.length;
		if (dif < 0) {
			_subdivideBezier(eb, -dif / 6 | 0);
		} else if (dif > 0) {
			_subdivideBezier(sb, dif / 6 | 0);
		}
		if (reverse && !sb.reversed) {
			_reverseBezier(sb);
		}
		shapeIndex = shapeIndices[i] || shapeIndices[i] === 0 ? shapeIndices[i] : "auto";
		if (shapeIndex) {
			//if start shape is closed, find the closest point to the start/end, and re-organize the bezier points accordingly so that the shape morphs in a more intuitive way.
			if (sb.closed || Math.abs(sb[0] - sb[sb.length - 2]) < 0.5 && Math.abs(sb[1] - sb[sb.length - 1]) < 0.5) {
				if (shapeIndex === "auto" || shapeIndex === "log") {
					shapeIndices[i] = shapeIndex = _getClosestShapeIndex(sb, eb, i === 0);
					if (shapeIndex < 0) {
						reverse = true;
						_reverseBezier(sb);
						shapeIndex = -shapeIndex;
					}
					_offsetBezier(sb, shapeIndex * 6);
				} else if (shapeIndex !== "reverse") {
					if (i && shapeIndex < 0) {
						//only happens if an array is passed as shapeIndex and a negative value is defined for an index beyond 0. Very rare, but helpful sometimes.
						_reverseBezier(sb);
					}
					_offsetBezier(sb, (shapeIndex < 0 ? -shapeIndex : shapeIndex) * 6);
				}
				//otherwise, if it's not a closed shape, consider reversing it if that would make the overall travel less
			} else if (!reverse && (shapeIndex === "auto" && Math.abs(eb[0] - sb[0]) + Math.abs(eb[1] - sb[1]) + Math.abs(eb[eb.length - 2] - sb[sb.length - 2]) + Math.abs(eb[eb.length - 1] - sb[sb.length - 1]) > Math.abs(eb[0] - sb[sb.length - 2]) + Math.abs(eb[1] - sb[sb.length - 1]) + Math.abs(eb[eb.length - 2] - sb[0]) + Math.abs(eb[eb.length - 1] - sb[1]) || shapeIndex % 2)) {
				_reverseBezier(sb);
				shapeIndices[i] = -1;
				reverse = true;
			} else if (shapeIndex === "auto") {
				shapeIndices[i] = 0;
			} else if (shapeIndex === "reverse") {
				shapeIndices[i] = -1;
			}
			if (sb.closed !== eb.closed) {
				//if one is closed and one isn't, don't close either one otherwise the tweening will look weird (but remember, the beginning and final states will honor the actual values, so this only affects the inbetween state)
				sb.closed = eb.closed = false;
			}
		}
	}
	if (log) {
		_log("shapeIndex:[" + shapeIndices.join(",") + "]");
	}
	return shapeIndices;
},
    _pathFilter = function _pathFilter(a, shapeIndex, map, precompile) {
	var start = _pathDataToBezier(a[0]),
	    end = _pathDataToBezier(a[1]);
	if (!_equalizeSegmentQuantity(start, end, shapeIndex || shapeIndex === 0 ? shapeIndex : "auto", map)) {
		return; //malformed path data or null target
	}
	a[0] = _bezierToPathData(start);
	a[1] = _bezierToPathData(end);
	if (precompile === "log" || precompile === true) {
		_log('precompile:["' + a[0] + '","' + a[1] + '"]');
	}
},
    _buildPathFilter = function _buildPathFilter(shapeIndex, map, precompile) {
	return map || precompile || shapeIndex || shapeIndex === 0 ? function (a) {
		_pathFilter(a, shapeIndex, map, precompile);
	} : _pathFilter;
},
    _offsetPoints = function _offsetPoints(text, offset) {
	if (!offset) {
		return text;
	}
	var a = text.match(_numbersExp) || [],
	    l = a.length,
	    s = "",
	    inc,
	    i,
	    j;
	if (offset === "reverse") {
		i = l - 1;
		inc = -2;
	} else {
		i = ((parseInt(offset, 10) || 0) * 2 + 1 + l * 100) % l;
		inc = 2;
	}
	for (j = 0; j < l; j += 2) {
		s += a[i - 1] + "," + a[i] + " ";
		i = (i + inc) % l;
	}
	return s;
},

//adds a certain number of points while maintaining the polygon/polyline shape (so that the start/end values can have a matching quantity of points to animate). Returns the revised string.
_equalizePointQuantity = function _equalizePointQuantity(a, quantity) {
	var tally = 0,
	    x = parseFloat(a[0]),
	    y = parseFloat(a[1]),
	    s = x + "," + y + " ",
	    max = 0.999999,
	    newPointsPerSegment,
	    i,
	    l,
	    j,
	    factor,
	    nextX,
	    nextY;
	l = a.length;
	newPointsPerSegment = quantity * 0.5 / (l * 0.5 - 1);
	for (i = 0; i < l - 2; i += 2) {
		tally += newPointsPerSegment;
		nextX = parseFloat(a[i + 2]);
		nextY = parseFloat(a[i + 3]);
		if (tally > max) {
			//compare with 0.99999 instead of 1 in order to prevent rounding errors
			factor = 1 / (Math.floor(tally) + 1);
			j = 1;
			while (tally > max) {
				s += (x + (nextX - x) * factor * j).toFixed(2) + "," + (y + (nextY - y) * factor * j).toFixed(2) + " ";
				tally--;
				j++;
			}
		}
		s += nextX + "," + nextY + " ";
		x = nextX;
		y = nextY;
	}
	return s;
},
    _pointsFilter = function _pointsFilter(a) {
	var startNums = a[0].match(_numbersExp) || [],
	    endNums = a[1].match(_numbersExp) || [],
	    dif = endNums.length - startNums.length;
	if (dif > 0) {
		a[0] = _equalizePointQuantity(startNums, dif);
	} else {
		a[1] = _equalizePointQuantity(endNums, -dif);
	}
},
    _buildPointsFilter = function _buildPointsFilter(shapeIndex) {
	return !isNaN(shapeIndex) ? function (a) {
		_pointsFilter(a);
		a[1] = _offsetPoints(a[1], parseInt(shapeIndex, 10));
	} : _pointsFilter;
},
    _createPath = function _createPath(e, ignore) {
	var path = __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite_js__["k" /* _gsScope */].document.createElementNS("http://www.w3.org/2000/svg", "path"),
	    attr = Array.prototype.slice.call(e.attributes),
	    i = attr.length,
	    name;
	ignore = "," + ignore + ",";
	while (--i > -1) {
		name = attr[i].nodeName.toLowerCase(); //in Microsoft Edge, if you don't set the attribute with a lowercase name, it doesn't render correctly! Super weird.
		if (ignore.indexOf("," + name + ",") === -1) {
			path.setAttributeNS(null, name, attr[i].nodeValue);
		}
	}
	return path;
},
    _convertToPath = function _convertToPath(e, swap) {
	var type = e.tagName.toLowerCase(),
	    circ = 0.552284749831,
	    data,
	    x,
	    y,
	    r,
	    ry,
	    path,
	    rcirc,
	    rycirc,
	    points,
	    w,
	    h,
	    x2,
	    x3,
	    x4,
	    x5,
	    x6,
	    y2,
	    y3,
	    y4,
	    y5,
	    y6;
	if (type === "path" || !e.getBBox) {
		return e;
	}
	path = _createPath(e, "x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points");
	if (type === "rect") {
		r = +e.getAttribute("rx") || 0;
		ry = +e.getAttribute("ry") || 0;
		x = +e.getAttribute("x") || 0;
		y = +e.getAttribute("y") || 0;
		w = (+e.getAttribute("width") || 0) - r * 2;
		h = (+e.getAttribute("height") || 0) - ry * 2;
		if (r || ry) {
			//if there are rounded corners, render cubic beziers
			x2 = x + r * (1 - circ);
			x3 = x + r;
			x4 = x3 + w;
			x5 = x4 + r * circ;
			x6 = x4 + r;
			y2 = y + ry * (1 - circ);
			y3 = y + ry;
			y4 = y3 + h;
			y5 = y4 + ry * circ;
			y6 = y4 + ry;
			data = "M" + x6 + "," + y3 + " V" + y4 + " C" + [x6, y5, x5, y6, x4, y6, x4 - (x4 - x3) / 3, y6, x3 + (x4 - x3) / 3, y6, x3, y6, x2, y6, x, y5, x, y4, x, y4 - (y4 - y3) / 3, x, y3 + (y4 - y3) / 3, x, y3, x, y2, x2, y, x3, y, x3 + (x4 - x3) / 3, y, x4 - (x4 - x3) / 3, y, x4, y, x5, y, x6, y2, x6, y3].join(",") + "z";
		} else {
			data = "M" + (x + w) + "," + y + " v" + h + " h" + -w + " v" + -h + " h" + w + "z";
		}
	} else if (type === "circle" || type === "ellipse") {
		if (type === "circle") {
			r = ry = +e.getAttribute("r") || 0;
			rycirc = r * circ;
		} else {
			r = +e.getAttribute("rx") || 0;
			ry = +e.getAttribute("ry") || 0;
			rycirc = ry * circ;
		}
		x = +e.getAttribute("cx") || 0;
		y = +e.getAttribute("cy") || 0;
		rcirc = r * circ;
		data = "M" + (x + r) + "," + y + " C" + [x + r, y + rycirc, x + rcirc, y + ry, x, y + ry, x - rcirc, y + ry, x - r, y + rycirc, x - r, y, x - r, y - rycirc, x - rcirc, y - ry, x, y - ry, x + rcirc, y - ry, x + r, y - rycirc, x + r, y].join(",") + "z";
	} else if (type === "line") {
		data = _bezierToPathData(_pathDataToBezier("M" + (e.getAttribute("x1") || 0) + "," + (e.getAttribute("y1") || 0) + " L" + (e.getAttribute("x2") || 0) + "," + (e.getAttribute("y2") || 0))); //previously, we just converted to "Mx,y Lx,y" but Safari has bugs that cause that not to render properly when using a stroke-dasharray that's not fully visible! Using a cubic bezier fixes that issue.
	} else if (type === "polyline" || type === "polygon") {
		points = (e.getAttribute("points") + "").match(_numbersExp) || [];
		x = points.shift();
		y = points.shift();
		data = "M" + x + "," + y + " L" + points.join(",");
		if (type === "polygon") {
			data += "," + x + "," + y + "z";
		}
	}
	path.setAttribute("d", data);
	if (swap && e.parentNode) {
		e.parentNode.insertBefore(path, e);
		e.parentNode.removeChild(e);
	}

	return path;
},
    _parseShape = function _parseShape(shape, forcePath, target) {
	var isString = typeof shape === "string",
	    e,
	    type;
	if (!isString || _selectorExp.test(shape) || (shape.match(_numbersExp) || []).length < 3) {
		e = isString ? TweenLite.selector(shape) : shape && shape[0] ? shape : [shape]; //allow array-like objects like jQuery objects.
		if (e && e[0]) {
			e = e[0];
			type = e.nodeName.toUpperCase();
			if (forcePath && type !== "PATH") {
				//if we were passed an element (or selector text for an element) that isn't a path, convert it.
				e = _convertToPath(e, false);
				type = "PATH";
			}
			shape = e.getAttribute(type === "PATH" ? "d" : "points") || "";
			if (e === target) {
				//if the shape matches the target element, the user wants to revert to the original which should have been stored in the data-original attribute
				shape = e.getAttributeNS(null, "data-original") || shape;
			}
		} else {
			_log("WARNING: invalid morph to: " + shape);
			shape = false;
		}
	}
	return shape;
},
    _morphMessage = "Use MorphSVGPlugin.convertToPath(elementOrSelectorText) to convert to a path before morphing.",
    MorphSVGPlugin = __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite_js__["k" /* _gsScope */]._gsDefine.plugin({
	propName: "morphSVG",
	API: 2,
	global: true,
	version: "0.8.11",

	//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
	init: function init(target, value, tween, index) {
		var type, p, pt, shape, isPoly;
		if (typeof target.setAttribute !== "function") {
			return false;
		}
		if (typeof value === "function") {
			value = value(index, target);
		}
		type = target.nodeName.toUpperCase();
		isPoly = type === "POLYLINE" || type === "POLYGON";
		if (type !== "PATH" && !isPoly) {
			_log("WARNING: cannot morph a <" + type + "> SVG element. " + _morphMessage);
			return false;
		}
		p = type === "PATH" ? "d" : "points";
		if (typeof value === "string" || value.getBBox || value[0]) {
			value = { shape: value };
		}
		shape = _parseShape(value.shape || value.d || value.points || "", p === "d", target);
		if (isPoly && _commands.test(shape)) {
			_log("WARNING: a <" + type + "> cannot accept path data. " + _morphMessage);
			return false;
		}
		if (shape) {
			this._target = target;
			if (!target.getAttributeNS(null, "data-original")) {
				target.setAttributeNS(null, "data-original", target.getAttribute(p)); //record the original state in a data-original attribute so that we can revert to it later.
			}
			pt = this._addTween(target, "setAttribute", target.getAttribute(p) + "", shape + "", "morphSVG", false, p, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value.precompile) === "object" ? function (a) {
				a[0] = value.precompile[0];a[1] = value.precompile[1];
			} : p === "d" ? _buildPathFilter(value.shapeIndex, value.map || MorphSVGPlugin.defaultMap, value.precompile) : _buildPointsFilter(value.shapeIndex));
			if (pt) {
				this._overwriteProps.push("morphSVG");
				pt.end = shape;
				pt.endProp = p;
			}
		}
		return true;
	},

	set: function set(ratio) {
		var pt;
		this._super.setRatio.call(this, ratio);
		if (ratio === 1) {
			pt = this._firstPT;
			while (pt) {
				if (pt.end) {
					this._target.setAttribute(pt.endProp, pt.end); //make sure the end value is exactly as specified (in case we had to add fabricated points during the tween)
				}
				pt = pt._next;
			}
		}
	}

});

MorphSVGPlugin.pathFilter = _pathFilter;
MorphSVGPlugin.pointsFilter = _pointsFilter;
MorphSVGPlugin.subdivideRawBezier = _subdivideBezier;
MorphSVGPlugin.defaultMap = "size";
MorphSVGPlugin.pathDataToRawBezier = function (data) {
	return _pathDataToBezier(_parseShape(data, true));
};
MorphSVGPlugin.equalizeSegmentQuantity = _equalizeSegmentQuantity;

MorphSVGPlugin.convertToPath = function (targets, swap) {
	if (typeof targets === "string") {
		targets = TweenLite.selector(targets);
	}
	var a = !targets || targets.length === 0 ? [] : targets.length && targets[0] && targets[0].nodeType ? Array.prototype.slice.call(targets, 0) : [targets],
	    i = a.length;
	while (--i > -1) {
		a[i] = _convertToPath(a[i], swap !== false);
	}
	return a;
};

MorphSVGPlugin.pathDataToBezier = function (data, vars) {
	//converts SVG path data into an array of {x, y} objects that can be plugged directly into a bezier tween. You can optionally pass in a 2D matrix like [a, b, c, d, tx, ty] containing numbers that should transform each point.
	var bezier = _pathDataToBezier(_parseShape(data, true))[0] || [],
	    prefix = 0,
	    a,
	    i,
	    l,
	    matrix,
	    offsetX,
	    offsetY,
	    bbox,
	    e;
	vars = vars || {};
	e = vars.align || vars.relative;
	matrix = vars.matrix || [1, 0, 0, 1, 0, 0];
	offsetX = vars.offsetX || 0;
	offsetY = vars.offsetY || 0;
	if (e === "relative" || e === true) {
		offsetX -= bezier[0] * matrix[0] + bezier[1] * matrix[2];
		offsetY -= bezier[0] * matrix[1] + bezier[1] * matrix[3];
		prefix = "+=";
	} else {
		offsetX += matrix[4];
		offsetY += matrix[5];
		if (e) {
			e = typeof e === "string" ? TweenLite.selector(e) : e && e[0] ? e : [e]; //allow array-like objects like jQuery objects.
			if (e && e[0]) {
				bbox = e[0].getBBox() || { x: 0, y: 0 };
				offsetX -= bbox.x;
				offsetY -= bbox.y;
			}
		}
	}
	a = [];
	l = bezier.length;
	if (matrix && matrix.join(",") !== "1,0,0,1,0,0") {
		for (i = 0; i < l; i += 2) {
			a.push({ x: prefix + (bezier[i] * matrix[0] + bezier[i + 1] * matrix[2] + offsetX), y: prefix + (bezier[i] * matrix[1] + bezier[i + 1] * matrix[3] + offsetY) });
		}
	} else {
		for (i = 0; i < l; i += 2) {
			a.push({ x: prefix + (bezier[i] + offsetX), y: prefix + (bezier[i + 1] + offsetY) });
		}
	}
	return a;
};



/***/ }),
/* 149 */,
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenLite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_utils__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logo',

  data: function data() {
    return {
      isMobile: __WEBPACK_IMPORTED_MODULE_1__scripts_utils__["d" /* isMobile */]
    };
  },
  mounted: function mounted() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["d" /* isMobile */])()) {
      this.$el.style.opacity = 0;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_gsap_TweenLite__["l" /* default */].set(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('.cls-2', this.$el), {
        strokeDashoffset: 0,
        stroke: '#454545',
        strokeWidth: 15
      });
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_animations__ = __webpack_require__(39);


//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Artwork',

  data: function data() {
    return {
      lang: this.$store.state.lang,
      app: null,
      sprites: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(),
      displacement: null,
      dmap: null,
      ArtworkLoader: null,
      setted: false,
      isMobile: __WEBPACK_IMPORTED_MODULE_5__scripts_utils__["d" /* isMobile */],

      container: null,
      prevWidth: 0,

      pixiReady: false,
      PIXI: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    hoverEvent: 'getHoverEvent',

    currentEvent: 'getEventName',

    eventsList: 'getEventsList',

    loaded: 'getPageLoaded'
  })),

  watch: {
    hoverEvent: function hoverEvent(newVal, oldVal) {
      var _this = this;

      var newValString = newVal.toString();
      var oldValString = !oldVal ? oldVal : oldVal.toString();

      if (newVal) {
        this.firstEnter = false;
        var newSprite = this.sprites.get(newValString);

        if (this.setted) {
          var delay = 0.1;
          if (oldValString) delay = 0.2;

          __WEBPACK_IMPORTED_MODULE_6__scripts_animations__["a" /* default */].get('canvasHover')(newSprite, this.displacement, delay).play().timeScale(0.75);
        } else {
          var intervalEvent = setInterval(function () {
            if (_this.setted) {
              var _delay = 0.1;
              if (oldValString) _delay = 0.2;

              __WEBPACK_IMPORTED_MODULE_6__scripts_animations__["a" /* default */].get('canvasHover')(newSprite, _this.displacement, _delay).play().timeScale(0.75);
              clearTimeout(intervalEvent);
            }
          }, 500);
        }
      }

      if (oldValString) {
        var oldSprite = this.sprites.get(oldValString);
        var speed = newVal !== null ? 0.25 : 0.75;

        __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["j" /* TweenMax */].killTweensOf(oldSprite);
        __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["j" /* TweenMax */].to(oldSprite, speed, {
          alpha: 0,
          y: 35
        });
      }
    },
    eventsList: function eventsList(newVal) {
      if (newVal && !this.setted) {
        if (this.pixiReady) this.init();
      }
    }
  },

  mounted: function mounted() {
    this.pixiReady = true;
    this.PIXI = __WEBPACK_IMPORTED_MODULE_4_pixi_js__;
    this.PIXI.utils.skipHello();

    var xPercent = window.innerWidth < 1024 && window.innerWidth > 767 ? -40 : -50;

    __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["j" /* TweenMax */].set(this.$el, {
      yPercent: -50,
      xPercent: xPercent
    });
    console.log(__WEBPACK_IMPORTED_MODULE_4_pixi_js__);

    this.init();

    if (this.setted) this.$eventHub.$on('windowResized', this.setPosArtwork);
    if (this.setted) this.$eventHub.$on('windowResized', this.refreshCanvas);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.app = new this.PIXI.Application({
        width: Math.min(800, Object(__WEBPACK_IMPORTED_MODULE_5__scripts_utils__["i" /* viewportSize */])().width),
        height: Math.min(800, Object(__WEBPACK_IMPORTED_MODULE_5__scripts_utils__["i" /* viewportSize */])().width),
        transparent: true
      });

      this.prevWidth = this.app.renderer.width;

      this.$el.appendChild(this.app.view);

      this.ArtworkLoader = new this.PIXI.loaders.Loader();

      this.eventsList[this.lang].forEach(function (event) {
        if (event.id === 'event02' || event.id === 'event04' || event.id === 'event05' || event.id === 'event07') {
          _this2.ArtworkLoader.add(event.id + '_01', '/static/img/artwork/' + event.id + '_01.png');
          _this2.ArtworkLoader.add(event.id + '_02', '/static/img/artwork/' + event.id + '_02.png');
        } else {
          _this2.ArtworkLoader.add(event.id, '/static/img/artwork/' + event.id + '.png');
        }
      });

      this.ArtworkLoader.add('dmap', '/static/img/artwork/dmap.jpg');

      this.ArtworkLoader.load(function () {
        _this2.setted = true;
        _this2.setup();
      });
    },
    setup: function setup() {
      var _this3 = this;

      this.container = new this.PIXI.Container();

      this.eventsList[this.lang].forEach(function (event) {
        var permalink = event.id;
        var sprite = void 0;
        var sprite2 = null;

        if (event.id === 'event02' || event.id === 'event04' || event.id === 'event05' || event.id === 'event07') {
          sprite = new _this3.PIXI.Sprite(_this3.ArtworkLoader.resources[permalink + '_01'].texture);
          sprite2 = new _this3.PIXI.Sprite(_this3.ArtworkLoader.resources[permalink + '_02'].texture);
          sprite.name = event.id + '_01';
          sprite.name2 = event.id + '_02';
        } else {
          sprite = new _this3.PIXI.Sprite(_this3.ArtworkLoader.resources[permalink].texture);
          sprite.name = event.id;
        }

        var containerSprite = new _this3.PIXI.Container();

        var width = sprite.width;

        sprite.scale.set(_this3.app.renderer.width / width);
        if (sprite2 !== null) sprite2.scale.set(_this3.app.renderer.width / width);

        sprite.x = _this3.app.renderer.width / 2 - sprite.width / 2;
        sprite.y = _this3.app.renderer.height / 2 - sprite.height / 2;

        if (sprite2 !== null) {
          sprite2.x = _this3.app.renderer.width / 2 - sprite.width / 2;
          sprite2.y = _this3.app.renderer.height / 2 - sprite.height / 2;
        }

        containerSprite.addChild(sprite);
        if (sprite2 !== null) containerSprite.addChild(sprite2);

        __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["j" /* TweenMax */].set(containerSprite, { alpha: 0 });

        __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["j" /* TweenMax */].fromTo(sprite, 5, {
          x: '+=20'
        }, {
          x: '-=15',
          repeat: -1,
          yoyo: true,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["d" /* Power1 */].easeInOut
        });

        __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["j" /* TweenMax */].fromTo(sprite, 3.2, {
          y: '+=10'
        }, {
          y: '-=7',
          repeat: -1,
          yoyo: true,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["d" /* Power1 */].easeInOut
        });

        if (sprite2 !== null) {
          __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["j" /* TweenMax */].fromTo(sprite2, 3, {
            x: '-=4'
          }, {
            x: '+=14',
            yoyo: true,
            repeat: -1,
            ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["d" /* Power1 */].easeInOut
          });

          __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["j" /* TweenMax */].fromTo(sprite2, 4.8, {
            y: '-=22'
          }, {
            y: '+=12',
            yoyo: true,
            repeat: -1,
            ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["d" /* Power1 */].easeInOut
          });
        }

        _this3.sprites.set(permalink, containerSprite);

        _this3.container.addChild(containerSprite);
      });

      this.ArtworkLoader.resources.dmap.texture.wrapMode = this.PIXI.WRAP_MODES.REPEAT;

      this.dmap = new this.PIXI.Sprite(this.ArtworkLoader.resources.dmap.texture);
      this.dmap.name = 'dmap';

      this.displacement = new this.PIXI.filters.DisplacementFilter(this.dmap);

      this.displacement.autoFit = true;
      this.container.filters = [this.displacement];
      this.app.stage.addChild(this.container);
    },
    setPosArtwork: function setPosArtwork() {
      if (!this.loaded) return;
      var artwork = this.$el;

      var contW = document.querySelector('[js-pagecontainer]').getBoundingClientRect().width;
      var contH = document.querySelector('[js-pagecontainer]').getBoundingClientRect().height;
      var windowW = window.innerWidth;
      var artworkW = artwork.getBoundingClientRect().width;

      var tXa = windowW <= 767 && this.$store.state.route.name !== 'home' ? 0 : contW - artworkW * 0.8;
      var tXaF = this.$store.state.route.name === 'home' ? 0 : tXa / 2;

      // const tYaP = (windowW <= 767 && this.$store.state.route.name !== 'home') ? -105 : -50;
      var scaleP = this.$store.state.route.name !== 'home' ? 0.8 : 1;
      var tYa = windowW <= 767 ? (contH - artwork.getBoundingClientRect().height * 0.8) / 2 + artwork.getBoundingClientRect().height / 5.5 : 0; // eslint-disable-line

      __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["j" /* TweenMax */].to(artwork, 0.8, {
        x: tXaF,
        xPercent: -50,
        yPercent: -50,
        y: -tYa,
        scale: scaleP,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap_TweenMax__["d" /* Power1 */].easeInOut
      });
    },
    refreshCanvas: function refreshCanvas() {
      this.app.renderer.resize(Math.min(800, Object(__WEBPACK_IMPORTED_MODULE_5__scripts_utils__["i" /* viewportSize */])().width), Math.min(800, Object(__WEBPACK_IMPORTED_MODULE_5__scripts_utils__["i" /* viewportSize */])().width));

      this.container.scale.set(this.app.renderer.width / this.prevWidth);
    }
  }
});

/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fontfaceobserver__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fontfaceobserver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fontfaceobserver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_lib_marquee3k__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_utils__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer',

  props: ['hideMobile'],

  data: function data() {
    return {
      windowW: innerWidth,
      isMobile: __WEBPACK_IMPORTED_MODULE_4__scripts_utils__["d" /* isMobile */]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    lang: 'getLang'
  })),

  watch: {
    lang: function lang(newVal) {
      if (newVal) {
        Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["f" /* qs */])('.marquee3k').classList.remove('is-init');
        Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["f" /* qs */])('.marquee3k__wrapper', this.$el).remove();

        this.init();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (!Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["d" /* isMobile */])()) this.$el.style.opacity = 0;

    var font = new __WEBPACK_IMPORTED_MODULE_2_fontfaceobserver___default.a('Apercu', {
      weight: 400
    });

    font.load(null, 5000).then(function () {
      _this.init();
    });

    this.$eventHub.$on('windowResized', function () {
      if (_this.windowW < 768 && window.innerWidth > 767 && _this.$store.state.route.name === 'event') {
        _this.$el.style.opacity = 1;
      }
    });
  },


  methods: {
    init: function init() {
      var p = document.createElement('p');
      p.classList.add('marquee_text');
      p.innerHTML = this.$refs[this.lang].innerHTML;
      Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["f" /* qs */])('.marquee3k').appendChild(p);

      __WEBPACK_IMPORTED_MODULE_3__assets_lib_marquee3k__["a" /* default */].init();
      __WEBPACK_IMPORTED_MODULE_3__assets_lib_marquee3k__["a" /* default */].refreshAll();
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BgNoise',

  mounted: function mounted() {
    this.init();
    this.setup();

    this.$eventHub.$on('windowResized', this.setup);
  },


  methods: {
    init: function init() {
      this.canvas = this.$refs.noise;
      this.ctx = this.canvas.getContext('2d');

      this.noiseData = [];
      this.frame = 0;

      this.loopTimeout = null;
      this.resizeThrottle = null;

      this.setup();
    },
    setup: function setup() {
      this.noiseData = [];
      this.canvas.width = window.innerWidth;
      this.canvas.height = window.innerHeight;

      for (var i = 0; i < 10; i += 1) {
        this.createNoise();
      }

      this.loop();
    },
    createNoise: function createNoise() {
      var idata = this.ctx.createImageData(window.innerWidth, window.innerHeight);
      var buffer32 = new Uint32Array(idata.data.buffer);
      var len = buffer32.length;

      for (var i = 0; i < len; i += 1) {
        if (Math.random() < 0.5) {
          buffer32[i] = 0xff000000;
        }
      }

      this.noiseData.push(idata);
    },
    paintNoise: function paintNoise() {
      if (this.frame === 9) {
        this.frame = 0;
      } else {
        this.frame = this.frame + 1;
      }

      this.ctx.putImageData(this.noiseData[this.frame], 0, 0);
    },
    loop: function loop() {
      var _this = this;

      this.paintNoise(this.frame);

      this.loopTimeout = window.setTimeout(function () {
        _this.loop = _this.loop.bind(_this);
        window.requestAnimationFrame(_this.loop);
      }, 3000 / 25);
    },
    destroy: function destroy() {
      this.reset();

      this.loopTimeout = 0;

      document.removeChild(this.$el);
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap_TweenLite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raf_loop__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raf_loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raf_loop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_eventer_js__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_eventer_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_eventer_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_animations__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scripts_utils__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pointer',

  props: ['isCursorReady', 'loading'],

  data: function data() {
    return {
      buttons: [],

      mouse: { x: 0, y: 0 },
      interMouse: { x: 0, y: 0 },
      norm: { x: 0, y: 0 },

      magnetism: 5,
      attraction: 30,

      isLerp: true,
      lerp: __WEBPACK_IMPORTED_MODULE_7__scripts_utils__["e" /* lerp */],
      roundDec: __WEBPACK_IMPORTED_MODULE_7__scripts_utils__["h" /* roundDec */],
      isMobile: __WEBPACK_IMPORTED_MODULE_7__scripts_utils__["d" /* isMobile */],

      oldCtx: null,
      newCtx: null,

      visible: true,

      timer: null,
      played: false,

      checkSwitch: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    stateCtx: 'getCtxButtons',

    page: 'getRouteName',

    changeLang: 'getChangeLang'
  })),

  watch: {
    page: function page(newCtx, oldCtx) {
      if (newCtx === 'home') {
        this.addMouseDown();
      } else if (oldCtx === 'home') {
        this.removeMouseDown();
      }
    },
    stateCtx: function stateCtx(newCtx, oldCtx) {
      if (oldCtx !== null && !this.isMobile() && !oldCtx.hasAttribute('js-noremove')) {
        var els = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(oldCtx.querySelectorAll('[data-mouse]'));
        this.removeButtonsEvents(els);
      }
      if (!this.isMobile()) {
        var _els = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(newCtx.querySelectorAll('[data-mouse]'));
        this.addButtonsEvents(_els);
      }
    },
    loading: function loading(newVal) {
      if (!newVal && !Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["d" /* isMobile */])()) {
        this.buttons = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('[data-mouse]'));
        this.init();

        if (this.$store.state.route.name === 'home') this.addMouseDown();
      }
    },
    changeLang: function changeLang(newVal) {
      if (newVal) {
        __WEBPACK_IMPORTED_MODULE_3_gsap_TweenLite__["i" /* TweenLite */].set(this.switchTrans, {
          top: this.interMouse.y,
          left: this.interMouse.x
        });

        this.checkSwitch = true;
      } else {
        this.checkSwitch = false;
      }
    }
  },

  mounted: function mounted() {
    this.eventer = new __WEBPACK_IMPORTED_MODULE_5_eventer_js___default.a(true);
    this.init();

    this.animateMdown = __WEBPACK_IMPORTED_MODULE_6__scripts_animations__["a" /* default */].get('cursor')(this.$refs.pathmdown);
  },


  methods: {
    init: function init() {
      this.switchTrans = Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["f" /* qs */])('.el-transition');
      this.bindEvents();

      __WEBPACK_IMPORTED_MODULE_3_gsap_TweenLite__["i" /* TweenLite */].to(this.$el, 0.4, { opacity: 1 });
      this.engine = __WEBPACK_IMPORTED_MODULE_4_raf_loop___default()(this.renderer.bind(this)).start();
    },
    mousePosition: function mousePosition(event) {
      this.mouse = {
        x: event.clientX,
        y: event.clientY
      };
    },
    bindEvents: function bindEvents() {
      window.addEventListener('mousemove', this.mousePosition.bind(this));
      // this.eventer.bindEvent('mousemove', window, this.mousePosition.bind(this));

      this.addButtonsEvents(this.buttons);
    },
    addButtonsEvents: function addButtonsEvents(btns) {
      var _this = this;

      if (btns.length === 0) return;

      btns.forEach(function (btn) {
        var state = btn.getAttribute('data-mouse-attractionstate');
        var attraction = btn.getAttribute('data-mouse-attractionval');

        _this.handleMouseMove = _this.setButtonPosition.bind(_this);

        if (state === 'active' || state === true) _this.eventer.bindEvent('mousemove', btn, function (event) {
          return _this.handleMouseMove(event, btn, attraction);
        });
        _this.eventer.bindEvent('mouseenter', btn, _this.setHoverMouse.bind(_this, btn));
        _this.eventer.bindEvent('mouseleave', btn, _this.resetButton.bind(_this, btn, state));
      });
    },
    addMouseDown: function addMouseDown() {
      var _this2 = this;

      this.handleMouseDown = function (event) {
        return _this2.mouseDown(event);
      };
      this.handleMouseUp = this.mouseUp.bind(this);

      document.body.addEventListener('mousedown', this.handleMouseDown);
      document.body.addEventListener('mouseup', this.handleMouseUp);
    },
    removeMouseDown: function removeMouseDown() {
      document.body.removeEventListener('mousedown', this.handleMouseDown);
      document.body.removeEventListener('mouseup', this.handleMouseUp);
    },
    mouseDown: function mouseDown(event) {
      var _this3 = this;

      if (event.target.hasAttribute('data-line') || event.target.classList.contains('js-splittedlines') || event.target.classList.contains('event') || event.target.classList.contains('event__title')) return;

      this.$el.setAttribute('data-hover', 'mdown');
      this.animateMdown.timeScale(2.8).play();

      this.timer = setTimeout(function () {
        // this.played = true;

        _this3.$store.commit('TOGGLE_MOUSEDOWN', true);
        _this3.$el.setAttribute('data-hover', '');

        // this.sound.play();
        // this.sound.fade(0, 0.5, 2000);
      }, 400);
    },
    mouseUp: function mouseUp() {
      this.$el.setAttribute('data-hover', '');
      this.animateMdown.pause().timeScale(2.5).reverse();

      // if (this.played) {
      //   this.sound.fade(0.5, 0, 1500);
      //   this.played = false;
      // }

      this.$store.commit('TOGGLE_MOUSEDOWN', false);
      clearTimeout(this.timer);
    },
    removeButtonsEvents: function removeButtonsEvents(btns) {
      var _this4 = this;

      btns.forEach(function (btn) {
        return _this4.eventer.clearAll(btn);
      });
    },
    renderer: function renderer() {
      this.setPos();
    },
    setPos: function setPos() {
      var lerpedX = Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["e" /* lerp */])(this.mouse.x, this.interMouse.x, 0.75);
      var lerpedY = Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["e" /* lerp */])(this.mouse.y, this.interMouse.y, 0.75);

      this.interMouse.x = this.isLerp ? lerpedX - this.norm.x / this.magnetism : this.mouse.x;
      this.interMouse.y = this.isLerp ? lerpedY - this.norm.y / this.magnetism : this.mouse.y;

      __WEBPACK_IMPORTED_MODULE_3_gsap_TweenLite__["i" /* TweenLite */].set(this.$el, {
        x: this.interMouse.x,
        y: this.interMouse.y
      });

      if (this.checkSwitch) {
        __WEBPACK_IMPORTED_MODULE_3_gsap_TweenLite__["i" /* TweenLite */].set(this.switchTrans, {
          top: this.interMouse.y,
          left: this.interMouse.x
        });
      }
    },
    setHoverMouse: function setHoverMouse(el) {
      this.$el.setAttribute('data-hover', el.getAttribute('data-hover-type'));
    },
    setButtonPosition: function setButtonPosition(event, el, attraction) {
      this.dim = {
        x: el.clientWidth / 2,
        y: el.clientHeight / 2
      };

      this.norm = {
        x: Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["h" /* roundDec */])((event.offsetX - this.dim.x) / this.dim.x) * attraction,
        y: Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["h" /* roundDec */])((event.offsetY - this.dim.y) / this.dim.y) * attraction
      };

      this.animateButton(el);
    },
    animateButton: function animateButton(el) {
      __WEBPACK_IMPORTED_MODULE_3_gsap_TweenLite__["i" /* TweenLite */].to(el, 0.5, {
        xPercent: this.norm.x,
        yPercent: this.norm.y
      });
    },
    resetButton: function resetButton(el, state) {
      this.$el.setAttribute('data-hover', '');

      if (state === 'active' || state) {
        this.norm = { x: 0, y: 0 };
        this.animateButton(el);
      }
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CircleSwitch'
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Whistle',

  data: function data() {
    return {
      ps: [],
      mic: null,
      threshold: 0.15,
      colors: ['#DDDDDF', '#FADF63', '#FFE3DC', '#FFDDA1']
    };
  },
  created: function created() {
    // Promise.all([
    //   import('p5'),
    //   import('p5/lib/addons/p5.dom'),
    //   import('p5/lib/addons/p5.sound'),
    // ]).then((p5) => {
    //   const sketch = function(p) {
    //     p.x = 100;
    //     p.y = 100;

    //     p.setup = function() {
    //       p.createCanvas(200, 200);
    //       p.background(51);
    //     }

    //     p.draw = function() {
    //       p.x = p.x + p.random(-10, 10);
    //       p.y = p.y + p.random(-10, 10);
    //     }
    //   }

    //   console.log('p5: ', p5.prototype);
    //   // this.myp5 = p5(sketch.bind(this));
    // });
  },


  methods: {
    // setup(p5) {
    //   createCanvas(window.innerWidth, window.innerHeight);
    //   this.ps = new p5.ParticleSystem(createVector(window.innerWidth
    // / 2, window.innerHeight / 2));
    //   this.mic = new p5.AudioIn();
    //   this.mic.start();
    // },

    // draw() {
    //   background("#000000");
    //   const micLevel = mic.getLevel();
    //   if(micLevel > threshold) for(let i=0; i<30; i++) this.ps.addParticle();
    //   this.ps.run();
    // },

    //   Particle(pos) {
    //     this.pos = pos.copy();
    //     this.col=random(colors);
    //     this.size=random(5,30);
    //     this.fill=random([0,1]);
    //     this.velocity = createVector(0, 0);
    //     this.acceleration = createVector(10*random(-1,1), 10*random(-1,1));
    //     this.offset = createVector(random(2000,10000), random(2000,10000));
    //     // this.f=this.acceleration.copy();
    //     // this.f.normalize();
    //     // this.f.mult(-.1);
    //     // console.log("a: "+this.acceleration);
    //     // console.log("f: "+this.f);


    //     this.update = () => {
    //       this.velocity.add(this.acceleration);
    //       this.pos.add(this.velocity);
    //       this.pos.add(createVector(10*(noise(this.offset.x)-.5),10*(noise(this.offset.y)-.5)));
    //       this.offset.x = this.offset.x + 0.01;
    //       this.offset.y = this.offset.y + 0.01;
    //       // var n = noise(xoff) * width;
    //       this.size=this.size*.95;
    //       this.acceleration.mult(0);
    //       if(this.velocity.mag() > 1) this.velocity.mult(.95);
    //       // this.acceleration.add(this.f);
    //     }

    //     this.isDead = () => {
    //       if(this.size<1) return true;
    //       else return false;
    //     }

    //     this.render = () => {
    //       if(this.fill==1) { noStroke(); fill(this.col) }
    //       else { noFill(); stroke(this.col); }
    //       ellipse (this.pos.x, this.pos.y, this.size, this.size);
    //     }
    //   },

    //   ParticleSystem(pos) {
    //     this.origin = pos.copy();
    //     this.particles = [];

    //     this.addParticle = function addParticle() {
    //         this.particles.push(new Particle(this.origin));
    //     };

    //     this.run = () => {
    //       for (var i = this.particles.length-1; i >= 0; i--) {
    //         var p = this.particles[i];
    //         p.update();
    //         p.render();
    //         if (p.isDead()) {
    //           this.particles.splice(i, 1);
    //         }
    //       }
    //     };
    //   }
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buttonIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buttonOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_utils__ = __webpack_require__(4);




var buttonIn = function buttonIn(el) {
  var btns = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('.btn-js[js-refPage="' + el.getAttribute('js-page') + '"]');

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({ paused: true });

  btns.forEach(function (btn, index) {
    var text = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('.btn__wrapper__text > bdi', btn);

    var symbol = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.btn__img', btn);

    var tlBtn = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]();

    tlBtn.add('start').set(btn, { autoAlpha: 1, clearProps: 'all' }).staggerFrom(text, 0.75, {
      yPercent: 100,
      autoAlpha: 0,
      skewX: -20,
      ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1),
      clearProps: 'all'
    }, 0.25).from(symbol, 0.7, {
      y: -14,
      autoAlpha: 0,
      clearProps: 'all',
      ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1)
    }, 'start+=0.2').to(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.btn__border svg path', btn), 0.5, {
      strokeDashoffset: 0,
      ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Expo */].easeNone,
      clearProps: 'all'
    }, 'start+=0.4');

    tl.add(tlBtn, 0.4 * index);
  });

  return tl;
};

var buttonOut = function buttonOut(el) {
  var btns = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('.btn-js[js-refPage="' + el.getAttribute('js-page') + '"]');

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({ paused: true });

  btns.forEach(function (btn) {
    var symbol = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.btn__img', btn);
    var path = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.btn__border svg path', btn);

    var dashoffset = Math.ceil(path.getTotalLength());
    var dasharray = Math.ceil(path.getTotalLength());

    var text = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('.btn__wrapper__text > bdi', btn);

    var tlBtn = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["i" /* TweenLite */].set(el, { autoAlpha: 0 });
        __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["i" /* TweenLite */].set(symbol, { clearProps: 'all' });
        __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["i" /* TweenLite */].set(text, { clearProps: 'all' });
      }
    });

    tl.add('start').to(path, 0.5, {
      strokeDashoffset: dashoffset,
      strokeDasharray: dasharray,
      ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Expo */].easeNone
    }).to(symbol, 0.7, {
      y: -14,
      autoAlpha: 0,
      ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1)
    }, 'start+=0.2').staggerTo(text, 0.75, {
      yPercent: 100,
      autoAlpha: 0,
      skewX: -20,
      ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1)
    }, -0.25, 'start+=0.4');

    tl.add(tlBtn);
  });

  return tl;
};

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return uiIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return uiOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_utils__ = __webpack_require__(4);




var uiIn = function uiIn(el) {
  var els = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('[data-anim]', el);

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({ paused: true });

  tl.set(el, { autoAlpha: 1 }).staggerFrom(els, 1, {
    yPercent: 100,
    autoAlpha: 0,
    skewX: -20,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1),
    clearProps: 'all'
  }, 0.2);

  return tl;
};

var uiOut = function uiOut(el) {
  var els = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('[data-anim]', el);

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({ paused: true });

  tl.staggerTo(els, 1, {
    yPercent: 100,
    autoAlpha: 0,
    skewX: -20,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1),
    clearProps: 'all'
  }, 0.2).set(el, { autoAlpha: 0 });

  return tl;
};

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modernizr__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modernizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modernizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__custom_modernizr__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__custom_modernizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__custom_modernizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(26);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
Object(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

var bg = ['background: linear-gradient(135deg, rgba(235, 235, 235, 1) 0%, rgba(245, 245, 245, 1) 100%);', 'color: #BE9B19', 'padding: 5px 20px', 'line-height: 25px'].join(';');
console.log('%c🍾 Coded by Andrea & Tommaso @ Adoratorio 🍾', bg);

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports) {

/*! modernizr 3.6.0 (Custom Build) | MIT *
* https://modernizr.com/download/?-pointerevents-smil-touchevents-addtest-setclasses-testprop-teststyles !*/
!function(e,t,n){function o(e,t){return typeof e===t}function r(){var e,t,n,r,i,s,a;for(var l in g)if(g.hasOwnProperty(l)){if(e=[],t=g[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(r=o(t.fn,"function")?t.fn():t.fn,i=0;i<e.length;i++)s=e[i],a=s.split("."),1===a.length?Modernizr[a[0]]=r:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=r),v.push((r?"":"no-")+a.join("-"))}}function i(e){var t=_.className,n=Modernizr._config.classPrefix||"";if(C&&(t=t.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(o,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),C?_.className.baseVal=t:_.className=t)}function s(e,t){if("object"==typeof e)for(var n in e)w(e,n)&&s(n,e[n]);else{e=e.toLowerCase();var o=e.split("."),r=Modernizr[o[0]];if(2==o.length&&(r=r[o[1]]),"undefined"!=typeof r)return Modernizr;t="function"==typeof t?t():t,1==o.length?Modernizr[o[0]]=t:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=t),i([(t&&0!=t?"":"no-")+o.join("-")]),Modernizr._trigger(e,t)}return Modernizr}function a(e,t){return!!~(""+e).indexOf(t)}function l(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):C?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function u(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function f(){var e=t.body;return e||(e=l(C?"svg":"body"),e.fake=!0),e}function c(e,n,o,r){var i,s,a,u,c="modernizr",d=l("div"),p=f();if(parseInt(o,10))for(;o--;)a=l("div"),a.id=r?r[o]:c+(o+1),d.appendChild(a);return i=l("style"),i.type="text/css",i.id="s"+c,(p.fake?p:d).appendChild(i),p.appendChild(d),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),d.id=c,p.fake&&(p.style.background="",p.style.overflow="hidden",u=_.style.overflow,_.style.overflow="hidden",_.appendChild(p)),s=n(d,e),p.fake?(p.parentNode.removeChild(p),_.style.overflow=u,_.offsetHeight):d.parentNode.removeChild(d),!!s}function d(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function p(t,n,o){var r;if("getComputedStyle"in e){r=getComputedStyle.call(e,t,n);var i=e.console;if(null!==r)o&&(r=r.getPropertyValue(o));else if(i){var s=i.error?"error":"log";i[s].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else r=!n&&t.currentStyle&&t.currentStyle[o];return r}function m(t,o){var r=t.length;if("CSS"in e&&"supports"in e.CSS){for(;r--;)if(e.CSS.supports(d(t[r]),o))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];r--;)i.push("("+d(t[r])+":"+o+")");return i=i.join(" or "),c("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"==p(e,null,"position")})}return n}function h(e,t,r,i){function s(){c&&(delete N.style,delete N.modElem)}if(i=o(i,"undefined")?!1:i,!o(r,"undefined")){var f=m(e,r);if(!o(f,"undefined"))return f}for(var c,d,p,h,v,g=["modernizr","tspan","samp"];!N.style&&g.length;)c=!0,N.modElem=l(g.shift()),N.style=N.modElem.style;for(p=e.length,d=0;p>d;d++)if(h=e[d],v=N.style[h],a(h,"-")&&(h=u(h)),N.style[h]!==n){if(i||o(r,"undefined"))return s(),"pfx"==t?h:!0;try{N.style[h]=r}catch(y){}if(N.style[h]!=v)return s(),"pfx"==t?h:!0}return s(),!1}var v=[],g=[],y={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){g.push({name:e,fn:t,options:n})},addAsyncTest:function(e){g.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=y,Modernizr=new Modernizr;var w,_=t.documentElement,C="svg"===_.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;w=o(e,"undefined")||o(e.call,"undefined")?function(e,t){return t in e&&o(e.constructor.prototype[t],"undefined")}:function(t,n){return e.call(t,n)}}(),y._l={},y.on=function(e,t){this._l[e]||(this._l[e]=[]),this._l[e].push(t),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},y._trigger=function(e,t){if(this._l[e]){var n=this._l[e];setTimeout(function(){var e,o;for(e=0;e<n.length;e++)(o=n[e])(t)},0),delete this._l[e]}},Modernizr._q.push(function(){y.addTest=s});var S=y._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];y._prefixes=S;var b=function(){function e(e,t){var r;return e?(t&&"string"!=typeof t||(t=l(t||"div")),e="on"+e,r=e in t,!r&&o&&(t.setAttribute||(t=l("div")),t.setAttribute(e,""),r="function"==typeof t[e],t[e]!==n&&(t[e]=n),t.removeAttribute(e)),r):!1}var o=!("onblur"in t.documentElement);return e}();y.hasEvent=b;var T=y.testStyles=c;Modernizr.addTest("touchevents",function(){var n;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)n=!0;else{var o=["@media (",S.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");T(o,function(e){n=9===e.offsetTop})}return n});var x="Moz O ms Webkit",E=y._config.usePrefixes?x.toLowerCase().split(" "):[];y._domPrefixes=E,Modernizr.addTest("pointerevents",function(){var e=!1,t=E.length;for(e=Modernizr.hasEvent("pointerdown");t--&&!e;)b(E[t]+"pointerdown")&&(e=!0);return e});var z={elem:l("modernizr")};Modernizr._q.push(function(){delete z.elem});var N={style:z.elem.style};Modernizr._q.unshift(function(){delete N.style});var P=(y.testProp=function(e,t,o){return h([e],n,t,o)},{}.toString);Modernizr.addTest("smil",function(){return!!t.createElementNS&&/SVGAnimate/.test(P.call(t.createElementNS("http://www.w3.org/2000/svg","animate")))}),r(),i(v),delete y.addTest,delete y.addAsyncTest;for(var j=0;j<Modernizr._q.length;j++)Modernizr._q[j]();e.Modernizr=Modernizr}(window,document);

/***/ }),
/* 215 */
/***/ (function(module, exports) {

(function(Modernizr){
  // FROM: http://codepen.io/shshaw/pen/yyOaqW
  // Here are all the values we will test. If you want to use just one or two, comment out the lines of test you don't need.
  var tests = [
    // { name: 'svg', value: 'url(#test)' }, // False positive in IE, supports SVG clip-path, but not on HTML element
    { name: 'inset', value: 'inset(10px 20px 30px 40px)' },
    // { name: 'circle', value: 'circle(60px at center)' },
    // { name: 'ellipse', value: 'ellipse(50% 50% at 50% 50%)' },
    // { name: 'polygon', value: 'polygon(50% 0%, 0% 100%, 100% 100%)' }
    ];

    var t = 0,
    name, value, prop;

    for (; t < tests.length; t++) {
      name = tests[t].name;
      value = tests[t].value;
      Modernizr.addTest('cssclippath' + name, function(){
      // Try using window.CSS.supports
      if ( 'CSS' in window && 'supports' in window.CSS ) {
        for (var i = 0; i < Modernizr._prefixes.length; i++) {
          prop = Modernizr._prefixes[i] + 'clip-path';

          if ( window.CSS.supports(prop,value) ) { return true; }
        }
        return false;
      }
      // Otherwise, use Modernizr.testStyles and examine the property manually
      return Modernizr.testStyles('#modernizr { '+Modernizr._prefixes.join('clip-path:'+value+'; ')+' }',function(elem, rule) {
        var style = getComputedStyle(elem),
        clip = style.clipPath;

        if ( !clip || clip == "none" ) {
          clip = false;

          for (var i = 0; i < Modernizr._domPrefixes.length; i++) {
            test = Modernizr._domPrefixes[i] + 'ClipPath';
            if ( style[test] && style[test] !== "none" ) {
              clip = true;
              break;
            }
          }
        }

        return Modernizr.testProp('clipPath') && clip;
      });
    });
  }
})(Modernizr);

if (Modernizr.cssclippathsvg) {
  document.documentElement.className += ' cssclippathsvg';
}

if (Modernizr.cssclippathinset) {
  document.documentElement.className += ' cssclippathinset';
}

if (Modernizr.cssclippathcircle) {
  document.documentElement.className += ' cssclippathcircle';
}

if (Modernizr.cssclippathellipse) {
  document.documentElement.className += ' cssclippathellipse';
}

if (Modernizr.cssclippathpolygon) {
  document.documentElement.className += ' cssclippathpolygon';
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ee7fa1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ee7fa1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getHoverEvent: function getHoverEvent(state) {
    return state.hoverEvent;
  },

  getBtnAnimation: function getBtnAnimation(state) {
    return state.btnAnimation;
  },

  getCtxButtons: function getCtxButtons(state) {
    return state.ctxButtons;
  },

  getMouseDown: function getMouseDown(state) {
    return state.mouseDown;
  },

  getWeatherData: function getWeatherData(state) {
    return state.weatherData;
  },

  getRouteName: function getRouteName(state) {
    return state.route.name;
  },

  // getDayPart: state => state.dayPart,

  getLang: function getLang(state) {
    return state.lang;
  },

  getChangeLang: function getChangeLang(state) {
    return state.changeLang;
  },

  getEventsList: function getEventsList(state) {
    return state.eventsList;
  },

  getEventData: function getEventData(state) {
    return state.currentEventData;
  },

  getEventName: function getEventName(state) {
    return state.currentEvent;
  },

  getPageLoaded: function getPageLoaded(state) {
    return state.allLoaded;
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_whatwg_fetch__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dayjs__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dayjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_data_data_json__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_data_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_data_data_json__);







function weatherData() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
    var city = '3175447'; // Iseo
    var appid = 'bed3dee8334be571f5c81e3ae0408786';
    var link = 'https://api.openweathermap.org/data/2.5/weather?id=' + city + '&APPID=' + appid;

    return fetch(link).then(function (res) {
      return res.json();
    }).then(function (response) {
      resolve({
        cachedtime: __WEBPACK_IMPORTED_MODULE_4_dayjs___default()().add(12, 'hour').unix(),
        id: response.weather[0].id,
        sunrise: response.sys.sunrise,
        sunset: response.sys.sunset
      });
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  // async FETCH_EVENTSLIST({ commit }) {
  //   let res = true;

  //   await fetchEventsList()
  //     .then(list => commit('SET_EVENTSLIST', list))
  //     .catch(() => { res = false; });

  //   return res;
  // },

  // async FETCH_EVENT({ commit, state }, id) {
  //   let res = true;

  //   await fetchEvent(id, state.lang)
  //     .then(event => commit('ADD_EVENT', event))
  //     .catch(() => { res = false; });

  //   return res;
  // },

  // async FETCH_WEATHER({ commit }) {
  //   await fetchWeather().then(weather => commit('SET_WEATHERDATA', weather));
  // },

  FETCH_EVENTSLIST: function FETCH_EVENTSLIST(_ref) {
    var commit = _ref.commit;

    var res = true;

    commit('SET_EVENTSLIST', __WEBPACK_IMPORTED_MODULE_5__assets_data_data_json___default.a.index);

    return res;
  },
  FETCH_EVENT: function FETCH_EVENT(_ref2, id) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var res = true;

    commit('ADD_EVENT', __WEBPACK_IMPORTED_MODULE_5__assets_data_data_json___default.a.events[state.lang][id]);

    return res;
  },
  FETCH_WEATHER: function FETCH_WEATHER(_ref3) {
    var _this = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return weatherData().then(function (res) {
                return commit('SET_WEATHERDATA', res);
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, exports) {

module.exports = {"events":{"en":{"exclusive-horizontal-tasting-of-blanc-de-blancs":{"artwork":"event02","id":"exclusive-horizontal-tasting-of-blanc-de-blancs","info":{"0_when":"September Saturday 15th 2018;","1_time":"At 11 am and 5 pm;","2_price":"€ 20 per person; Advanced payment required;","4_language":"Please check availability for the English version;.","5_note":"Limited availability; Reservation is required."},"paragraphs":["In a <b>dedicated</b> <b>tasting</b> <b>room</b>, you will be led by the chef du cave to an <b>exclusive</b> <b>tasting</b> <b>of</b> <b>4 glassed</b> <b>of</b> <b>the</b> <b>Winery</b> <b>beloved</b> <b>and</b> <b>famous</b> <b>Blanc</b> <b>de</b> <b>Blancs</b> <b>Franciacorta</b> <b>Anniversario.</b>","A <b>unique</b> <b>experience</b> to understand the <b>different</b> <b>quality</b> <b>residing</b> <b>in</b> <b>4 different</b> <b>size</b> <b>bottles.</b> <b>All</b> <b>wine</b> <b>bottle</b> <b>sizes</b> <b>have</b> <b>their</b> <b>own,</b> <b>unique</b> <b>taste.</b>","<b>Get</b> <b>inspired</b> <b>and</b> <b>book</b> <b>this</b> <b>exclusive</b> <b>experience</b>. 4 glassed from <b>Demì</b> (0,375 lt.), <b>Tradition</b> (0,75 lt.), <b>Magnum</b> (1,5 lt.) and <b>Jeroboam</b> (3 lt.). <b>Blanc</b> <b>de</b> <b>Blancs</b> <b>is</b> <b>the</b> <b>first</b> <b>Franciacorta</b> produced by the Winery Bersi Serlini in <b>1970.</b>"],"title":"Exclusive Horizontal Tasting </br>with Blanc de Blancs","translate":"esclusiva-degustazione-orizzontale-blanc-de-blancs"},"exclusive-vertical-tasting-with-combinations-of-chef-mainardi":{"artwork":"event07","id":"exclusive-vertical-tasting-with-combinations-of-chef-mainardi","info":{"0_when":"September Sunday 16th 2018;","1_time":"At 11 am and 2 pm;","2_price":"€45 per person; Advanced payment required;","5_note":"Reservation is required; Limited availability."},"paragraphs":["In a dedicated room we offer the opportunity to <b>taste</b> <b>3</b> <b>vintage</b> <b>Cuvèe</b> <b>N°4</b> <b>Millesimè</b> <b>Wines</b> <b>from</b> <b>3 different</b> <b>vintage</b> <b>years</b> paired exclusively by the most <b>amazing</b> <b>‘Atomic</b> <b>Chef’</b> <b>Andrea</b> <b>Mainardi</b> <b>who</b> <b>will</b> <b>prepare</b> <b>3ccourses</b> <b>live.</b>","A tasting explosion. Both fun and engaging, you will be taught how to make 3 amazing new recipes.","<b>A</b> <b>live</b> <b>show</b> <b>not</b> <b>to</b> <b>be</b> <b>missed</b>. Andrea Mainardi is a champion of contemporary cuisine and our Cuvèe N°4 is a joy to pair with his recipes."],"title":"Exclusive Tasting with </br>Combinations of Chef Mainardi","translate":"esclusiva-degustazione-con-abbinamenti-dello-chef-mainardi"},"gala-of-flavours":{"artwork":"event04","id":"gala-of-flavours","info":{"0_when":"September Saturday 15th 2018;","1_time":"From 8 pm till late night;","3_dresscode":"Total black with a yellow accessory;","5_note":"Reservation is necessary; Limited availability."},"paragraphs":["<b>After</b> <b>sunset,</b> <b>The</b> <b>Court</b> <b>dresses</b> <b>up</b> <b>with</b> <b>Gala</b> <b>mega</b> <b>elegance.</b> In the magical Bersi Serlini location, a <b>riot</b> <b>of</b> <b>excellent</b> <b>tasting</b> <b>corners</b>, an explosion of sophistication, design, music, party lights and wine.","Pure pleasure for those who love <b>exotic</b> <b>and</b> <b>gourmet</b> <b>food</b> <b>pairing</b> and want to join us for an <b>exclusive</b> <b>dinnerparty</b>, dance under the stars and celebrate the Franciacorta Festival with in our company."],"title":"Gala of Flavors","translate":"il-gala-dei-sapori"},"nocturnal-visits":{"artwork":"event06","id":"nocturnal-visits","info":{"0_when":"September Saturday 15th 2018;","1_time":"At 9 pm and at 10 pm;","2_price":"€25 per person + €15 deposit for the ‘adventure’ accessories; Advanced payment is required;","5_note":"Not suitable for children; Walking shoes are necessary; Please check availability for English version."},"paragraphs":["For those who love nature, the poetry of the winery <b>from</b> <b>sunset</b> <b>to</b> <b>the</b> <b>star</b> <b>filled</b> <b>night.</b> <b>A</b> <b>walk</b> <b>to</b> <b>the</b> <b>discovery</b> <b>of</b> <b>the</b> <b>different</b> <b>vines</b> <b>within</b> <b>the</b> <b>Winery,</b> Chardonnay, Pinot Blanc and Pinot Noir.","Don’t miss this opportunity to enjoy and learn more of the secret life of vines at night and full moon. <b>Armed</b> <b>with</b> <b>torches,</b> we will make this <b>experience</b> <b>truly</b> <b>adventurous</b>. An <b>exceptional</b> <b>audio</b> <b>guide</b>; a journey from vines to the dark underground cellars. <b>Tasting</b> <b>of</b> <b>3</b> <b>Franciacorta</b> <b>and</b> <b>food</b> <b>pairing</b> <b>is</b> <b>included.</b>"],"title":"Nocturnal visits","translate":"visite-notturne"},"picnic-amongst-the-vines":{"artwork":"event01","id":"picnic-amongst-the-vines","info":{"0_when":"September Saturday 15th and Sunday 16th 2018;","1_time":"Picnic basket collection from 11 am till 2 pm;","2_price":"€30 per person + €10 deposit for Franciacorta glass and pocket; Advanced payment is required;","5_note":"Picnic is also available for kids, and in veggie or gluten-free versions exclusively on request; Reservation is required."},"paragraphs":["Once again we offer the <b>funniest</b> <b>and</b> <b>smartest</b> <b>of</b> <b>all</b> <b>picnics</b>; don’t miss the opportunity to lay on blankets with our picnic baskets.","<b>Bersi</b> <b>Serlini</b> <b>provides</b> <b>you</b> <b>with</b> <b>everything</b> <b>needed:</b> <b>picnic</b> <b>basket,</b> <b>1 bottle</b> <b>of</b> <b>Franciacorta</b> <b>every</b> <b>2 guests,</b> <b>wine</b> <b>glass</b> <b>and</b> <b>glass</b> <b>pocket;</b> <b>a</b> <b>map</b> <b>of</b> <b>the</b> <b>Estate</b> <b>vineyards</b> so that you can pick the nicest spot and enjoy an outdoor tasting of the Bersi Serlini Experience in company of your friends.","<b>In</b> <b>the</b> <b>menu</b> <b>you</b> <b>may</b> <b>find</b> <b>enchanting</b> <b>foodies</b> <b>hand</b> <b>made</b> <b>by</b> <b>the</b> <b>Bersi</b> <b>Serlini</b> <b>Chef</b> <b>Daniele</b> <b>Fabris.</b>"],"title":"Picnic among the vineyards","translate":"picnic-tra-i-vigneti"},"silent-tour-with-tasting":{"artwork":"event00","id":"silent-tour-with-tasting","info":{"0_when":"September Saturday 15th & Sunday 16th;","1_time":"From 10 am till 07 pm;","2_price":"€15 per person + €5 deposit for Franciacorta glass and pocket;","4_language":"Available in Italian, English, French and German and Spanish;","5_note":"Reservation is required."},"paragraphs":["Silent tour with headphones. A <b>great</b> <b>new</b> <b>experience</b> to <b>try</b> something</b> <b>unprecedented</b> within the Winery new activities! A <b>guided</b> <b>vocal</b> <b>tour</b> <b>amongst</b> <b>the</b> <b>vines</b> <b>through</b> <b>the</b> <b>underground</b> <b>cellars</b> <b>light</b> <b>by</b> <b>candles</b> and</b> <b>lights</b> <b>designed</b> <b>to</b> <b>make</b> <b>the</b> <b>experience</b> <b>worthwhile!</b>","<b>2 Franciacorta tastings</b> at the end of the guided tour with <b>surprise</b> <b>pairings</b>. The audio guide is led by Chiara Bersi Serlini, creative director of the Festival programme with special guests. A tour that leaves without words but fills with emotions."],"title":"Silent Tour with Tasting","translate":"silent-tour-dei-vigneti-e-delle-cantine"},"the-courts-of-flavours":{"artwork":"event03","id":"the-courts-of-flavours","info":{"0_when":"September Saturday 15th & Sunday 16th 2018;","1_time":"from 10 am to late evening – see also The Gala of Flavours for Saturday evening –;","2_price":"€ 5 per glass and per plate + €5 deposit for Franciacorta glass & pocket","5_note":"Tokens will be necessary; Veggie, gluten free and kids choice available; This activity is only payable with token you can exchange at the cashier point."},"paragraphs":["<b>Unmissable,</b> <b>unique,</b> <b>mega</b> <b>exciting,</b> <b>La</b> <b>Corte</b> <b>dei</b> <b>Sapori</b> <b>is</b> <b>a</b> <b>renewed</b> <b>food</b> <b>court</b> <b>at</b> <b>every</b> <b>year’s</b> <b>Franciacorta</b> <b>Festival.</b>","Bersi Serlini has a generous location with large space designed for welcoming guests who want to taste and experience a feast of flavours, wine and food parings; food inspired by the Winery Franciacorta bubbles by Chef Daniele Fabris. <b>A <b>unique</b> <b>opportunity</b> <b>to</b> <b>taste</b> <b>terroir</b> <b>recipes</b> <b>with</b> <b>a</b> <b>touch</b> <b>of</b> <b>creativity.</b>","Ask for the Bersi Serlini Court of Flavours Tasting Map."],"title":"The Court of Flavors","translate":"la-corte-dei-sapori"},"the-smallest-restaurant-in-franciacorta":{"artwork":"event05","id":"the-smallest-restaurant-in-franciacorta","info":{"0_when":"September Saturday 15th 2018;","1_time":"Aperitivo will be served at 8 pm and dinner will follow;","2_price":"€ 250 per person all inclusive; Advanced payment is required;","5_note":"Booking is required: only 8 places availables; Please advice us on any dietary restrictions or requirements."},"paragraphs":["<b>One</b> <b>room,</b> <b>one</b> <b>table</b> (2 to 8 seats max), <b>one</b> <b>chef.</b> <b>8 courses</b> <b>menu</b> <b>inspired</b> <b>by</b> <b>Bersi</b> <b>Serlini</b> <b>paired</b> <b>to</b> <b>8</b> <b>Franciacorta</b> <b>exclusive</b> <b>cuvèe.</b>","Intimate and elegant, a classy charming romantic chance to eat in a sophisticated set up. <b>A</b> <b>delirium</b> <b>of</b> <b>the</b> <b>senses.</b>"],"title":"The <bdi>Smallest</bdi> </br>Restaurant in Franciacorta","translate":"il-ristorante-piu-piccolo-della-franciacorta"}},"it":{"esclusiva-degustazione-con-abbinamenti-dello-chef-mainardi":{"artwork":"event07","id":"esclusiva-degustazione-con-abbinamenti-dello-chef-mainardi","info":{"0_when":"Domenica 16 Settembre 2018;","1_time":"Ore 11.00 e ore 14.00;","2_price":"Il prezzo è di € 45 a persona; Pagamento anticipato;","5_note":"Prenotazione obbligatoria; Posti limitati."},"paragraphs":["In una sala dedicata avviene <b>un’esplosione</b> <b>gustativa</b> <b>fra</b> <b>lo</b> <b>chef</b> <b>atomico</b> <b>Andrea</b> <b>Mainardi</b> <b>e</b> <b>il</b> <b>millesimato</b> <b>storico</b> <b>della</b> <b>cantina,</b> <b>la</b> <b>Cuvèe</b> <b>N°4.</b> Degustazione verticale di 3 annate abbinate a 3 piatti, cucinati al momento dal vivo in uno show imperdibile.","Un’occasione di <b>apprezzamento</b> <b>sensoriale</b> della nostra Cuvèe N°4 per mano di un fuoriclasse della cucina contemporanea."],"title":"Esclusiva Degustazione Verticale </br>con Abbinamenti dello Chef Mainardi","translate":"exclusive-vertical-tasting-with-combinations-of-chef-mainardi"},"esclusiva-degustazione-orizzontale-blanc-de-blancs":{"artwork":"event02","id":"esclusiva-degustazione-orizzontale-blanc-de-blancs","info":{"0_when":"Sabato 15 Settembre 2018;","1_time":"Ore 11.00 e ore 17.00;","2_price":"Il prezzo è di € 20 a persona;","5_note":"Prenotazione obbligatoria, Disponibilità limitata."},"paragraphs":["Per conoscere la <b>storia</b> <b>della</b> <b>Cantina</b> raccontata da Maddalena Bersi Serlini che vi condurra’ nella prima orizzontale di <b>4 formati</b> del più amato fra i Franciacorta della Cantina Bersi Serlini, il Blanc de Blancs Anniversario.","Una storia importante. Il <b>primo</b> <b>vino</b> <b>prodotto</b> <b>dalla</b> <b>cantina</b> <b>nel</b> <b>1970</b> declinato in 4 dimensioni: <b>Demì</b> (0,375 lt.), <b>Tradizione</b> (0,75 lt.), <b>Magnum</b> (1,5 lt.) e <b>Jeroboam</b> (3 lt.). Un’occasione irripetibile per percepire la differenza di qualità di un vino elegante e senza tempo."],"title":"Esclusiva Degustazione Orizzontale </br>Blanc de Blancs","translate":"exclusive-horizontal-tasting-of-blanc-de-blancs"},"il-gala-dei-sapori":{"artwork":"event04","id":"il-gala-dei-sapori","info":{"0_when":"Sabato 15 Settembre 2018;","1_time":"Dalle 20.00 fino a tarda notte;","3_dresscode":"Total black con accessorio giallo;","5_note":"Prenotazione obbligatoria; Disponbilità limitata."},"paragraphs":["Dopo il tramonto,<b>la</b> <b>Corte</b> <b>si</b> <b>veste</b> <b>di</b> <b>Gala:</b> <b>mega</b> <b>eleganza.</b> Nella location magica Bersi Serlini con <b>angoli</b> <b>d’assaggio</b>, un <b>tripudio</b> <b>di</b> <b>eccellenze</b>, un’esplosione di <b>gusti sofisticati</b>, al tempo di <b>musica</b>, luci da festa e le nostre <b>immancabili</b> <b>bollicine.</b>","Puro piacere per chi ama abbinamenti esotici e gourmet e vuole unirsi a noi per <b>cenare,</b> <b>ballare</b> e <b>festeggiare</b> il Festival."],"title":"Il Gala dei Sapori","translate":"gala-of-flavours"},"il-ristorante-piu-piccolo-della-franciacorta":{"artwork":"event05","id":"il-ristorante-piu-piccolo-della-franciacorta","info":{"0_when":"Sabato 15 Settembre 2018;","1_time":"Alle ore 20.00 si inizia con un aperitivo, a seguire, cena servita;","2_price":"Il prezzo è di € 250 a persona vini inclusi; Pagamento anticipato;","5_note":"Prenotazione obbligatoria; Solo 8 posti disponibili."},"paragraphs":["Una sola sala, <b>8 posti,</b> <b>un</b> <b>fuoco</b> <b>e</b> <b>uno</b> <b>chef</b> <b>solo</b> <b>per</b> <b>Voi</b>. Intimità ed eleganza, <b>8 portate</b> <b>ispirate</b> <b>a</b> <b>8 nostri</b> <b>Franciacorta</b>. Un delirio dei sensi."],"title":"Il Ristorante più <bdi>Piccolo</bdi> </br>della Franciacorta","translate":"the-smallest-restaurant-in-franciacorta"},"la-corte-dei-sapori":{"artwork":"event03","id":"la-corte-dei-sapori","info":{"0_when":"Sabato 15 e Domenica 16 Settembre 2018;","1_time":"Dalle 10.00 fino a tarda sera;","2_price":"Il prezzo è di € 5 a piatto e di €5 a calice previo acquisto gettone e versamento cauzione di € 5;","5_note":"Prenotazione non necessaria."},"paragraphs":["<b>Immancabile,</b> <b>unica,</b> <b>mega</b> <b>entusiasmante,</b> <b>la</b> <b>Corte</b> <b>dei</b> <b>Sapori</b> <b>si</b> <b>rinnova</b> <b>dei</b> <b>piatti</b> <b>del</b> <b>territorio</b> <b>rivisitati</b> <b>dallo</b> <b>chef</b> <b>Daniele</b> <b>Fabris</b>, patron della ristorazione interna della Cantina, per il connubio perfetto al mood del Festival della Franciacorta: cibo e vino.","Potrete assaggiare tutti i nostri vini e abbinarli seguendo un <b>percorso</b> <b>gustativo</b> <b>studiato</b> <b>per</b> <b>inebriare</b> <b>i</b> <b>Vostri</b> <b>sensi.</b> Banco per bambini e proposte dedicate per veggie e celiaci."],"title":"La Corte dei Sapori","translate":"the-courts-of-flavours"},"picnic-tra-i-vigneti":{"artwork":"event01","id":"picnic-tra-i-vigneti","info":{"0_when":"Sabato 15 e Domenica 16 Settembre 2018;","1_time":"Ritiro picnic dalle 11.00 alle 14.30;","2_price":"Il prezzo è di € 30 a persona + €10 di cauzione, a testa per cassetta e accessori; Pagamento anticipato;","5_note":"Picnic per bambini, in versione veggie o per celiaci disponibili su richiesta; Prenotazione obbligatoria."},"paragraphs":["<b>L'appuntamento</b> <b>più</b> <b>divertente</b> <b>e</b> <b>amato</b> <b>del</b> <b>Festival.</b> Una degustazione unica ed esclusiva per brindare con gli amici. Bersi Serlini fornisce agli ospiti tutto l'occorrente:<b>cassetta</b> <b>da</b> <b>picnic,</b> <b>comodi</b> <b>teli,</b> <b>la</b> <b>piantina</b> <b>dei</b> <b>vigneti</b> <b>dove</b> <b>sostare,</b> <b>calici</b> <b>e</b> <b>bollicine.</b>","E il menù? Nel menu del pic nic solo <b>gustose</b> <b>prelibatezze</b> in abbinamento ad un Franciacorta."],"title":"Picnic tra i Vigneti","translate":"picnic-amongst-the-vines"},"silent-tour-dei-vigneti-e-delle-cantine":{"artwork":"event00","id":"silent-tour-dei-vigneti-e-delle-cantine","info":{"0_when":"Sabato 15 e Domenica 16 Settembre 2018;","1_time":"Dalle ore 10.00 alle 19.00;","2_price":"Il prezzo è di € 15 a persona + €5 di cauzione per calice e porta calice;","4_language":"Disponibile in lingua Inglese, Francese, Tedesca e Spagnola;","5_note":"Prenotazione obbligatoria."},"paragraphs":["Silent tour con auricolari.","Novità assoluta della Cantina,<b>un</b> <b>percorso</b> <b>guidato</b> <b>vocale</b> <b>dai</b> <b>vigneti</b> <b>del</b> <b>cuore</b> <b>alle</b> <b>due</b> <b>cantine</b> <b>interrate</b> <b>illuminate</b> <b>solo</b> <b>a</b> <b>candela</b> <b>con</b> <b>2</b> <b>degustazioni</b> <b>e</b> <b>abbinamenti</b> a sorpresa, condotte con un audio registrato da Chiara Bersi Serlini e ospiti speciali, un tour che lascia senza parole ma riempie di emozioni."],"title":"Silent Tour dei Vigneti </br>e delle Cantine","translate":"silent-tour-with-tasting"},"visite-notturne":{"artwork":"event06","id":"visite-notturne","info":{"0_when":"Sabato 15 Settembre 2018;","1_time":"Partenza ore 21.00 e 22.00;","2_price":"Il prezzo è di € 25 a persona + €15 di cauzione per gli accessori dell’avventura; Pagamento anticipato;","4_language":"Disponibile in lingua Inglese su specifica richiesta;","5_note":"Non adatto ai bambini; Si consiglia d’indossare scarpe comode."},"paragraphs":["Per chi ama la natura, <b>la</b> <b>poesia</b> <b>del</b> <b>paesaggio</b> <b>al</b> <b>tramonto</b> <b>e</b> <b>camminare</b> <b>alla</b> <b>scoperta</b> <b>dei</b> <b>diversi</b> <b>vitigni</b> di proprietà, questa attività è da non perdere. Armati di torce, per rendere veramente avventurosa l’esperienza e di un’audio guida d’eccezione… il gruppo partirà per un <b>viaggio</b> <b>notturno</b> nei filari per poi addentrarsi al buio delle due cantine interrate e <b>degustare</b> nel corso dell’esperienza <b>tre</b> <b>Franciacorta</b> <b>Bersi</b> <b>Serlini</b> <b>con</b> <b>abbinamenti.</b>"],"title":"Visite Notturne","translate":"nocturnal-visits"}}},"index":{"en":[{"id":"event00","link":"silent-tour-with-tasting","order":0,"title":"Silent Tour with Tasting","titleFx":"Silent Tour with Tasting<bdi>—</bdi>"},{"id":"event01","link":"picnic-amongst-the-vines","order":1,"title":"Picnic among the Vines","titleFx":"Picnic among the Vines<bdi>—</bdi>"},{"id":"event02","link":"exclusive-horizontal-tasting-of-blanc-de-blancs","order":2,"title":"Exclusive Horizontal Tasting of Blanc de Blancs","titleFx":"Exclusive Horizontal Tasting of Blanc de Blancs<bdi>—</bdi>"},{"id":"event03","link":"the-courts-of-flavours","order":3,"title":"The Court of Flavours","titleFx":"The Court of Flavours<bdi>—</bdi>"},{"id":"event04","link":"gala-of-flavours","order":4,"title":"Gala of Flavour's","titleFx":"Gala of Flavour's<bdi>—</bdi>"},{"id":"event05","link":"the-smallest-restaurant-in-franciacorta","order":5,"title":"The Smallest Restaurant in Franciacorta","titleFx":"The Smallest Restaurant in Franciacorta<bdi>—</bdi>"},{"id":"event06","link":"nocturnal-visits","order":6,"title":"Nocturnal visits","titleFx":"Nocturnal visits<bdi>—</bdi>"},{"id":"event07","link":"exclusive-vertical-tasting-with-combinations-of-chef-mainardi","order":7,"title":"Exclusive Tasting with combinations of Chef Mainardi","titleFx":"Exclusive Tasting with combinations of Chef Mainardi<bdi>—</bdi>"}],"it":[{"id":"event00","link":"silent-tour-dei-vigneti-e-delle-cantine","order":0,"title":"Silent Tour dei Vigneti e delle Cantine","titleFx":"Silent Tour dei Vigneti e delle Cantine<bdi>—</bdi>"},{"id":"event01","link":"picnic-tra-i-vigneti","order":1,"title":"Picnic tra i Vigneti","titleFx":"Picnic tra i Vigneti<bdi>—</bdi>"},{"id":"event02","link":"esclusiva-degustazione-orizzontale-blanc-de-blancs","order":2,"title":"Esclusiva Degustazione Orizzontale Blanc de Blancs","titleFx":"Esclusiva Degustazione Orizzontale Blanc de Blancs<bdi>—</bdi>"},{"id":"event03","link":"la-corte-dei-sapori","order":3,"title":"La Corte dei Sapori","titleFx":"La Corte dei Sapori<bdi>—</bdi>"},{"id":"event04","link":"il-gala-dei-sapori","order":4,"title":"Il Gala dei Sapori","titleFx":"Il Gala dei Sapori<bdi>—</bdi>"},{"id":"event05","link":"il-ristorante-piu-piccolo-della-franciacorta","order":5,"title":"Il Ristorante Più Piccolo della Franciacorta","titleFx":"Il Ristorante Più Piccolo della Franciacorta<bdi>—</bdi>"},{"id":"event06","link":"visite-notturne","order":6,"title":"Visite Notturne","titleFx":"Visite Notturne<bdi>—</bdi>"},{"id":"event07","link":"esclusiva-degustazione-con-abbinamenti-dello-chef-mainardi","order":7,"title":"Esclusiva Degustazione con abbinamenti dello Chef Mainardi","titleFx":"Esclusiva Degustazione con abbinamenti dello Chef Mainardi<bdi>—</bdi>"}]},"weather":{"cachedtime":1658348781,"id":800,"sunrise":1658288973,"sunset":1658343740}}

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_HOVEREVENT: function SET_HOVEREVENT(state, payload) {
    state.hoverEvent = payload; // eslint-disable-line
  },
  SET_BTNANIMATION: function SET_BTNANIMATION(state, payload) {
    state.btnAnimation = payload; // eslint-disable-line
  },
  TOGGLE_MOUSEDOWN: function TOGGLE_MOUSEDOWN(state, payload) {
    state.mouseDown = payload; // eslint-disable-line
  },
  ADD_BUTTONS: function ADD_BUTTONS(state, payload) {
    state.ctxButtons = payload; // eslint-disable-line
  },
  SET_WEATHERDATA: function SET_WEATHERDATA(state, payload) {
    state.weatherData = payload; // eslint-disable-line
  },
  SET_EVENTSLIST: function SET_EVENTSLIST(state, payload) {
    state.eventsList = payload; // eslint-disable-line
  },
  ADD_EVENT: function ADD_EVENT(state, payload) {
    state.events.push(payload); // eslint-disable-line

    state.currentEvent = payload.id; // eslint-disable-line
    state.currentEventData = payload; // eslint-disable-line
  },
  SET_EVENT: function SET_EVENT(state, payload) {
    state.currentEvent = payload.id; // eslint-disable-line
    state.currentEventData = payload; // eslint-disable-line
  },
  CHANGE_LANG: function CHANGE_LANG(state, payload) {
    state.lang = payload; // eslint-disable-line
  },
  IS_CHANGING_LANG: function IS_CHANGING_LANG(state, payload) {
    state.changeLang = payload; // eslint-disable-line
  },
  ALL_LOADED: function ALL_LOADED(state, payload) {
    state.allLoaded = payload; // eslint-disable-line
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // btnAnimation: '',
  mouseDown: false,
  // ctxButtons: null,
  weatherData: false,
  // dayPart: 'day',
  currentEvent: '',

  currentEventData: {},

  events: [],

  eventsList: null,

  lang: 'it',

  changeLang: false,

  hoverEvent: false,

  ctxButtons: null,

  allLoaded: false
});

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5068ecb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(300);
function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5068ecb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5068ecb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_colors_json__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_data_colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(26);






var DragImage = function () {
  function DragImage() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DragImage);

    this.images = [];

    this.isHolding = false;

    this.currentImage = null;
    this.slices = {
      width: 0,
      numberOf: 0,
      sectors: []
    };

    this.handleMouseMove = null;
    this.handleMouseDown = null;
    this.handleMouseUp = null;

    this.currentIndex = null;
    this.prevIndex = -1;

    this.cursor = document.querySelector('.cursor-hover');
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DragImage, [{
    key: 'init',
    value: function init(ctx) {
      var _this = this;

      this.ctx = ctx;
      this.images = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('.image-fade'));
      this.slices.numberOf = this.images.length;
      this.slices.width = Math.round(window.innerWidth / this.slices.numberOf);

      var prevNumber = 0;
      this.images.forEach(function (el, index) {
        var end = _this.slices.width * (index + 1);

        _this.slices.sectors.push({ start: prevNumber, end: end });

        prevNumber = end + 1;
      });

      this.images[0].style.zIndex = this.images.length;
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this2 = this;

      this.handleMouseMove = function (event) {
        return _this2.dragging(event);
      };
      this.isHolding = true;

      window.addEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      window.removeEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'dragging',
    value: function dragging(event) {
      if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.mouseDown) return;

      var mouseX = event.clientX;

      var index = this.slices.sectors.findIndex(function (el) {
        return el.start <= mouseX && mouseX <= el.end;
      });

      if (index === -1 && mouseX < 0) {
        index = 0;
      } else if (index === -1 && mouseX > window.innerWidth) {
        index = this.images.length - 1;
      }

      this.currentIndex = index;

      if (this.currentIndex !== this.prevIndex) {
        this.setImage();
        this.setColorMouse();
      }
    }
  }, {
    key: 'setImage',
    value: function setImage() {
      if (this.images[this.currentIndex] !== undefined) {
        this.images[this.currentIndex].style.opacity = 1;
        this.images[this.currentIndex].style.zIndex = this.images.length;
      }

      if (this.prevIndex > -1 && this.images[this.prevIndex] !== undefined) {
        this.images[this.prevIndex].style.opacity = 1;
        this.images[this.prevIndex].style.zIndex = 0;
      }

      this.prevIndex = this.currentIndex;
    }
  }, {
    key: 'setColorMouse',
    value: function setColorMouse() {
      this.cursor.style.fill = __WEBPACK_IMPORTED_MODULE_3__assets_data_colors_json___default.a[this.currentIndex];
      this.cursor.style.stroke = __WEBPACK_IMPORTED_MODULE_3__assets_data_colors_json___default.a[this.currentIndex];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _this3 = this;

      this.isHolding = false;
      this.prevIndex = -1;

      this.images.forEach(function (el, index) {
        el.style.opacity = 1; // eslint-disable-line
        el.style.zIndex = index === 0 ? _this3.images.length : 0; // eslint-disable-line
        _this3.cursor.style.fill = '#ffd300';
        _this3.cursor.style.stroke = '#ffd300';
      });
    }
  }]);

  return DragImage;
}();

/* harmony default export */ __webpack_exports__["a"] = (DragImage);

/***/ }),
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, exports) {

module.exports = ["#fcce21","#faca1e","#f9c61d","#f9c21d","#f8be1c","#f8ba1b","#f6b418","#f6af19","#f5a918","#f4a417","#f29e17","#e69b24","#dc9930","#cd9741","#c89448","#bc9353","#ad9066","#9e8d79","#988c7e","#888892","#7886a3","#6882b3","#597fc6","#4670bc","#4067b4","#3a5fad","#345aa3","#2f539d","#2d4d96","#294a91","#21468c","#1e4087","#1e4185","#1e3f84","#1f3d85"]

/***/ }),
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_utils__ = __webpack_require__(4);




var addAnimation = function addAnimation(line) {
  var width = line.parentNode.getBoundingClientRect().width;
  var speed = Math.min(Math.max(width / 1000, 0.4), 0.7);

  var animation = __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["i" /* TweenLite */].to(line, speed, {
    webkitClipPath: 'inset(0% 0% 0% 0%)',
    clipPath: 'inset(0% 0% 0% 0%)',
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Expo */].easeOut
  });

  return animation;
};

var hover = function hover(el) {
  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({
    paused: true
  });

  var lines = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('[data-line]', el);

  lines.forEach(function (line, index) {
    var animation = addAnimation(line);
    tl.add(animation, index * 0.3);
  });

  return tl;
};

/* harmony default export */ __webpack_exports__["a"] = (hover);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(9);


// import { qs } from '@/scripts/utils';

var canvasHover = function canvasHover(el, dmap, delay) {
  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({
    paused: true
  });

  var elAnimation = __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["i" /* TweenLite */].to(el, 0.75, {
    alpha: 1,
    y: 0,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Expo */].easeOut
  });

  __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["i" /* TweenLite */].set(el, { y: 35 });

  tl.add('start').fromTo(dmap.scale, 0.4, {
    x: 200,
    y: 70
  }, {
    y: 0,
    x: 0,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["e" /* Power2 */].easeInOut
  }, 0);
  tl.add(elAnimation, 'start+=' + delay);

  return tl;
};

/* harmony default export */ __webpack_exports__["a"] = (canvasHover);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TimelineLite__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_timelines_logo__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_timelines_museletTransitions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_utils__ = __webpack_require__(4);








var loaderAnimation = function loaderAnimation(el) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TimelineLite__["a" /* TimelineLite */]();

  var musletTl = function musletTl() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__scripts_timelines_museletTransitions__["b" /* museletLoaderIn */])(el);
  }; // eslint-disable-line
  var logoTl = function logoTl() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__scripts_timelines_logo__["a" /* default */])(el).play().timeScale(1.3);
  }; // eslint-disable-line
  var logoTlReverse = function logoTlReverse() {
    var fun = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_timelines_logo__["a" /* default */])(el);

    fun.eventCallback('onReverseComplete', function () {
      var logo = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["f" /* qs */])('.logo', el);
      var primaryText = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["f" /* qs */])('[js-introTextPrimary]', logo);
      var primaryLetters = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["g" /* qsa */])('[data-letter]', primaryText);
      var SecondaryText = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["f" /* qs */])('[js-introTextSecondary]', logo);
      var secondaryLetters = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["g" /* qsa */])('[data-letter]', SecondaryText);
      var paths = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_utils__["g" /* qsa */])('.cls-2', el);

      __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite__["i" /* TweenLite */].set(logo, { autoAlpha: 0 });
      __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite__["i" /* TweenLite */].set(primaryLetters, { clearProps: 'all' });
      __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite__["i" /* TweenLite */].set(secondaryLetters, { clearProps: 'all' });
      __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite__["i" /* TweenLite */].set(paths, { clearProps: 'all' });
      __WEBPACK_IMPORTED_MODULE_1_gsap_TweenLite__["i" /* TweenLite */].set(paths, { stroke: '#272727', strokeWidth: 15 });
      callback();
    });
    fun.progress(1, false).timeScale(1.3).reverse();
  };

  tl.add(musletTl).add(logoTl, 1.4).add(logoTlReverse, 2.9);
};

/* harmony default export */ __webpack_exports__["a"] = (loaderAnimation);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_utils__ = __webpack_require__(4);



var logoIn = function logoIn(el) {
  var logo = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.logo', el);
  var primaryText = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('[js-introTextPrimary]', el);
  var primaryLetters = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('[data-letter]', primaryText);
  var SecondaryText = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('[js-introTextSecondary]', el);
  var secondaryLetters = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('[data-letter]', SecondaryText);
  var paths = Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('.cls-2', el);

  paths.forEach(function (element) {
    element.style.strokeDasharray = element.style.strokeDashoffset = element.getTotalLength(); // eslint-disable-line
  });

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["h" /* TimelineMax */]({ paused: true });

  tl.add('start').set(logo, { autoAlpha: 1 }).staggerFromTo(primaryLetters, 1.2, {
    yPercent: 100,
    skewX: -20,
    autoAlpha: 0,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1)
  }, {
    yPercent: 0,
    skewX: 0,
    autoAlpha: 1,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1)
  }, 0.08, 'start').staggerFromTo(secondaryLetters, 1.2, {
    yPercent: 100,
    skewX: -20,
    autoAlpha: 0,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1)
  }, {
    yPercent: 0,
    skewX: 0,
    autoAlpha: 1,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1)
  }, 0.08, 'start+=0.2').staggerTo(paths, 0.4, {
    strokeDashoffset: 0,
    stroke: '#454545',
    strokeWidth: 15,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Expo */].Linear
  }, 0.15, 'start+=0.5');

  return tl;
};

/* harmony default export */ __webpack_exports__["a"] = (logoIn);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TimelineLite__ = __webpack_require__(30);


var cursor = function cursor(el) {
  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TimelineLite__["a" /* TimelineLite */]({ paused: true });

  tl.add('start').fromTo(el, 0.1, {
    scale: 0,
    transformOrigin: '50% 50%'
  }, {
    transformOrigin: '50% 50%',
    scale: 1
  }).to(el, 2, {
    transformOrigin: '50% 50%',
    scale: 0,
    fillOpacity: 1
  });

  return tl;
};

/* harmony default export */ __webpack_exports__["a"] = (cursor);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventList_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc70a5c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventList_vue__ = __webpack_require__(296);
function injectStyle (ssrContext) {
  __webpack_require__(291)
  __webpack_require__(292)
  __webpack_require__(293)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc70a5c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc70a5c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{domProps:{"innerHTML":_vm._s(_vm.text)}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"event",style:({ opacity: _vm.hoverStatus }),attrs:{"to":("/" + _vm.lang + "/" + (_vm.event.link)),"js-anim":"eventsList"},nativeOn:{"mouseenter":function($event){return _vm.setHover($event)},"mouseleave":function($event){return _vm.setHover($event)}}},[_c('Title',{staticClass:"event__title",attrs:{"text":_vm.event.titleFx}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.btn.external)?_c('div',[_c('a',{staticClass:"btn__wrapper",attrs:{"href":_vm.btn.link,"target":"_blank","rel":"noopener"}},[(_vm.btn[_vm.lang].textPrimary)?_c('div',{staticClass:"btn__wrapper__text"},[_c('bdi',[_vm._v(_vm._s(_vm.btn[_vm.lang].textPrimary))])]):_vm._e(),_vm._v(" "),(_vm.btn.symbol)?_c('div',{staticClass:"btn",attrs:{"data-mouse":"","data-mouse-attractionstate":"active","data-mouse-attractionval":"20","data-mouse-magnetism":"5","data-hover-type":"zoom"}},[_c('img',{staticClass:"btn__img",attrs:{"src":("/static/img/btns/" + (_vm.btn.symbol) + ".svg"),"alt":"button icon"}}),_vm._v(" "),_c('div',{staticClass:"btn__border"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 44"}},[_c('path',{attrs:{"d":"M18.5.6c1.5 0 7.9.1 9.5.2 2.2.2 4.8 1.2 6.2 1.8 7.4 3.2 9.6 12.1 9.6 20.3 0 1.7-.3 3.2-.6 4.8-.5 2.5-1.7 4.8-3 7.1-1.2 2-3.2 4.2-5.2 5.5-3.4 2.2-7.9 3.2-12.3 3.2s-7.9-1.5-11.3-3.7c-2.8-1.8-5.1-4-6.8-6.8-1.6-2.9-3.2-6.2-3.2-9.7 0-4.4.5-10.2 3-13.5 1.2-1.8 3-4.1 5-5.4 1.1-.8 2.7-1.7 3.6-2.1 1.2-.6 2.5-1.4 3.8-1.8","fill":"none","stroke":"#000","stroke-width":".85","stroke-linecap":"round","stroke-miterlimit":"10"}})])])]):_vm._e(),_vm._v(" "),(_vm.btn[_vm.lang].textAlt)?_c('div',{staticClass:"btn__wrapper__text"},[_c('bdi',[_vm._v(_vm._s(_vm.btn[_vm.lang].textAlt))])]):_vm._e()])]):_c('div',[_c('router-link',{staticClass:"btn__wrapper",attrs:{"to":_vm.btn.link}},[(_vm.btn[_vm.lang].textPrimary)?_c('div',{staticClass:"btn__wrapper__text"},[_c('bdi',[_vm._v(_vm._s(_vm.btn[_vm.lang].textPrimary))])]):_vm._e(),_vm._v(" "),(_vm.btn.symbol)?_c('div',{staticClass:"btn",attrs:{"data-mouse":"","data-mouse-attractionstate":"active","data-mouse-attractionval":"20","data-mouse-magnetism":"5","data-hover-type":"lang"}},[_c('img',{staticClass:"btn__img",attrs:{"src":("/static/img/btns/" + (_vm.btn.symbol) + ".svg"),"alt":"button icon"}}),_vm._v(" "),_c('div',{staticClass:"btn__border"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 44"}},[_c('path',{attrs:{"d":"M18.5.6c1.5 0 7.9.1 9.5.2 2.2.2 4.8 1.2 6.2 1.8 7.4 3.2 9.6 12.1 9.6 20.3 0 1.7-.3 3.2-.6 4.8-.5 2.5-1.7 4.8-3 7.1-1.2 2-3.2 4.2-5.2 5.5-3.4 2.2-7.9 3.2-12.3 3.2s-7.9-1.5-11.3-3.7c-2.8-1.8-5.1-4-6.8-6.8-1.6-2.9-3.2-6.2-3.2-9.7 0-4.4.5-10.2 3-13.5 1.2-1.8 3-4.1 5-5.4 1.1-.8 2.7-1.7 3.6-2.1 1.2-.6 2.5-1.4 3.8-1.8","fill":"none","stroke":"#000","stroke-width":".85","stroke-linecap":"round","stroke-miterlimit":"10"}})])])]):_vm._e(),_vm._v(" "),(_vm.btn[_vm.lang].textAlt)?_c('div',{staticClass:"btn__wrapper__text"},[_c('bdi',[_vm._v(_vm._s(_vm.btn[_vm.lang].textAlt))])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index",attrs:{"js-page":"index"}},[_c('div',{staticClass:"index__hover-sec",attrs:{"js-position":"left"},on:{"mousemove":_vm.hoverSections,"mouseleave":_vm.removeClass}}),_vm._v(" "),_c('div',{staticClass:"index__hover-sec",attrs:{"js-position":"right"},on:{"mousemove":_vm.hoverSections,"mouseleave":_vm.removeClass}}),_vm._v(" "),_c('div',{staticClass:"events"},_vm._l((_vm.eventsList[_vm.lang]),function(event,index){return _c('EventList',{key:event.id,class:index === _vm.eventsList[_vm.lang].length - 1 ? 'last' : false,attrs:{"event":event}})})),_vm._v(" "),_c('Cta',{staticClass:"btn-js btn--download",attrs:{"btn":_vm.btn,"js-refPage":"index"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_839f51e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__ = __webpack_require__(312);
function injectStyle (ssrContext) {
  __webpack_require__(302)
  __webpack_require__(303)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-839f51e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_839f51e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__ = __webpack_require__(137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a372f6f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__(308);
function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a372f6f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details",class:("details--" + _vm.title)},[_c('p',{staticClass:"details__title"},[_c('strong',[_vm._v(_vm._s(_vm.titleFix)+":")])]),_vm._v(" "),_c('p',{staticClass:"details__text",class:_vm.title === '6_extra' ? 'details__extra' : false,domProps:{"innerHTML":_vm._s(_vm.info)}},[_vm._v(_vm._s(_vm.info)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Number_vue__ = __webpack_require__(138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038e4997_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Number_vue__ = __webpack_require__(311);
function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-038e4997"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Number_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038e4997_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Number_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}},[_c('path',{attrs:{"d":_vm.svg[_vm.data].d0,"js-path":"d0","fill":"none","stroke":"#FFD300","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"d":_vm.svg[_vm.data].dn,"js-path":"dn","fill":"none","stroke":"#FFD300","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"d":_vm.svg[_vm.data].n0,"js-path":"n0","fill":"none","stroke":"none","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"d":_vm.svg[_vm.data].nn,"js-path":"nn","fill":"none","stroke":"none","stroke-width":"3"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"event",attrs:{"js-page":"event"}},[_c('div',{staticClass:"event__wrapper"},[_c('Number',{attrs:{"data":_vm.eventData.artwork}}),_vm._v(" "),_c('Title',{staticClass:"event__title",attrs:{"text":_vm.eventData.title}}),_vm._v(" "),_c('div',{staticClass:"event__details event__container"},_vm._l((_vm.eventData.paragraphs),function(paragraph,index){return _c('Paragraph',{key:index,attrs:{"text":paragraph}})})),_vm._v(" "),_c('div',{staticClass:"event__info event__container"},[_vm._l((_vm.eventData.info),function(info,key){return _c('Details',{key:key,attrs:{"info":info,"title":key}})}),_vm._v(" "),_c('div',{staticClass:"details details__mobile"},[_c('p',{staticClass:"details__title"},[_c('strong',[_vm._v(_vm._s(_vm.label[_vm.lang].info))])]),_c('br'),_vm._v(" "),_c('p',{staticClass:"details__text"},[_vm._v("\n          "+_vm._s(_vm.label[_vm.lang].phone)+": "),_c('a',{attrs:{"href":"tel:+390309823338"}},[_vm._v("+39 030 9823338")]),_c('br'),_vm._v("\n          "+_vm._s(_vm.label[_vm.lang].mail)+": "),_c('a',{attrs:{"href":"mailto:festival@bersiserlini.it"}},[_vm._v("festival@bersiserlini.it")])])])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b27f774e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(333);
function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b27f774e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b27f774e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Weather_vue__ = __webpack_require__(144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4527c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Weather_vue__ = __webpack_require__(326);
function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f4527c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Weather_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4527c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Weather_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anim__wrapper"},[_c('Paragraph',{attrs:{"text":_vm.text,"data-anim":_vm.isMobile() ? false : ''},domProps:{"innerHTML":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Social_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5247d5bb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Social_vue__ = __webpack_require__(329);
function injectStyle (ssrContext) {
  __webpack_require__(328)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5247d5bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Social_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5247d5bb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Social_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anim__wrapper"},[_c('div',{staticClass:"socials"},_vm._l((_vm.socials),function(social){return _c('a',{key:social.name,attrs:{"href":social.url,"target":"_blank","rel":"noopener","data-mouse":"","data-mouse-attractionstate":"active","data-mouse-attractionval":"20","data-mouse-magnetism":"5","data-hover-type":"zoom"}},[_c('img',{attrs:{"src":("/static/vector/" + (social.name) + ".svg"),"alt":social.alt}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SwitchLang_vue__ = __webpack_require__(146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa445862_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SwitchLang_vue__ = __webpack_require__(332);
function injectStyle (ssrContext) {
  __webpack_require__(331)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa445862"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SwitchLang_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa445862_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SwitchLang_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-selector",attrs:{"js-noremove":""}},[_c('div',{staticClass:"language",attrs:{"data-anim":_vm.isMobile() ? false : ''}},[_c('a',{class:['language__link', ("language__link--" + (_vm.languages[_vm.active].slug))],attrs:{"href":"#!","data-mouse":"","data-mouse-attractionstate":"active","data-mouse-attractionval":"20","data-mouse-magnetism":"5","data-hover-type":"lang"},on:{"click":function($event){$event.preventDefault();_vm.switchLang(_vm.languages[_vm.active].slug)}}},[_c('img',{staticClass:"lang",attrs:{"src":("/static/img/lang/" + (_vm.languages[_vm.active].slug) + ".svg"),"alt":((_vm.languages[_vm.active].name) + " icon link")}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",attrs:{"js-noremove":""}},[_c('div',{staticClass:"header__wrapper",class:this.bg ? 'bg-hide' : false},[_c('Weather'),_vm._v(" "),_c('div',{staticClass:"header__nav"},[_c('Social'),_vm._v(" "),_c('SwitchLang')],1)],1),_vm._v(" "),_c('Cta',{staticClass:"btn-js btn--back",class:_vm.$route.name !== 'event' ? 'hide': false,attrs:{"btn":_vm.btn,"js-refPage":"event"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Muselet_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d442c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Muselet_vue__ = __webpack_require__(350);
function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55d442c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Muselet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d442c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Muselet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__ = __webpack_require__(150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0193afed_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__ = __webpack_require__(349);
function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0193afed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0193afed_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",attrs:{"itemprop":"name"}},[_c('svg',{attrs:{"id":"Livello_1","data-name":"Livello 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 -40 1078.16 353.12","js-introTextContainer":""}},[_c('defs',[_c('clipPath',{attrs:{"id":"mask__festival"}},[_c('rect',{attrs:{"x":"-20","y":"-20","width":"604.7","height":"163"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"mask__franciacorta"}},[_c('rect',{attrs:{"x":"103.2","y":"170","width":"994.8","height":"163"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"mask_2"}},[_c('path',{staticClass:"cls-3",attrs:{"d":"M674.14,144.39A59.54,59.54,0,0,1,677.65,131a46.35,46.35,0,0,1,6.59-11.61,41.69,41.69,0,0,1,9.6-9,43.87,43.87,0,0,1,12.54-5.73q3.43-6.3,6.58-13.25a114.84,114.84,0,0,0,5.38-14.25,84.42,84.42,0,0,0,3.08-14.83,59.29,59.29,0,0,0-.15-14.83L701.36,64.89h-4.87V60l22.35-22.49c1.81-1.81,3.51-2.67,5.08-2.57A6.43,6.43,0,0,1,728,36.66a9.83,9.83,0,0,1,2.58,4A10.56,10.56,0,0,1,731.3,45c-.19,1.15-.4,2.68-.64,4.59s-.48,3.79-.72,5.66-.48,3.51-.72,4.94-.35,2.19-.35,2.29c-.39,1.43-1.15,3.92-2.3,7.45s-2.38,7.28-3.72,11.24-2.6,7.72-3.8,11.25-2.07,6-2.65,7.31q-2.14,2.14-1.29,3.58a5.94,5.94,0,0,0,2.87,2.29,24.38,24.38,0,0,0,5.87,1.57,33.87,33.87,0,0,0,7.52-.28q4.23-.57,8.74-1.58c3-.67,6-1.38,9-2.15s5.8-1.45,8.38-2.07,4.82-1.08,6.73-1.36a10.45,10.45,0,0,1,4.3,0,6.14,6.14,0,0,1,1.72,1.21c.66.62.9,1,.71,1.22l-4.87,7.59c-.19.29-1.29.82-3.29,1.58s-4.32,1.53-7,2.29-5.3,1.51-8,2.22a49.42,49.42,0,0,1-6.52,1.36,55.18,55.18,0,0,1-6.45.36q-4.57.07-9.81.07t-9.81-.07a55.18,55.18,0,0,1-6.45-.36q-.85,1.44-3.29,5l-5.16,7.52q-2.73,3.93-5.3,7.45t-3.58,4.8q-1.15,1.42-2.94,3.72a30.22,30.22,0,0,1-4,4.23,13.74,13.74,0,0,1-4.94,2.79,6.57,6.57,0,0,1-5.45-.72c0-.28,0-.78-.07-1.5S674,149,674,148.19s0-1.58.07-2.3S674.14,144.68,674.14,144.39Zm7.45-1.15c-.67,0-1,.43-1,1.29s.33,1.29,1,1.29.86-.43.86-1.29S682.17,143.24,681.59,143.24Zm2.44-8.73a12.07,12.07,0,0,0-.15,2.43,14.76,14.76,0,0,0,.15,2.58h2.58l14.75-22.35h-2.43c-.58,0-1.6.65-3.08,1.94a58.17,58.17,0,0,0-4.66,4.58,51.83,51.83,0,0,0-4.51,5.66A17.31,17.31,0,0,0,684,134.51Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"mask_0"}},[_c('path',{staticClass:"cls-3",attrs:{"d":"M787.31,152a13,13,0,0,1-3.29-2.86,33.6,33.6,0,0,1-2.87-3.94,30.71,30.71,0,0,1-2.22-4.3c-.62-1.48-1.12-2.79-1.5-3.94a49.17,49.17,0,0,1-.79-11.67,118.49,118.49,0,0,1,1.58-15.47,157.27,157.27,0,0,1,3.86-17.34,142.57,142.57,0,0,1,6.09-17.33,106.2,106.2,0,0,1,8.17-15.55,53.49,53.49,0,0,1,10.1-11.89,28.7,28.7,0,0,1,12-6.3,23,23,0,0,1,13.75,1.15,18.66,18.66,0,0,1,9.31,7A58.94,58.94,0,0,1,847.05,60c0,1.06,0,3,.07,5.81s.07,5.82.07,9,0,6.21-.07,9-.07,4.75-.07,5.8q-.28,3.72-3.08,10.89a121.81,121.81,0,0,1-7.38,15.32,150.68,150.68,0,0,1-10.53,16.19,83,83,0,0,1-12.53,13.68,38.78,38.78,0,0,1-13.32,7.81A15,15,0,0,1,787.31,152Zm2.58-10q5.45,3.72,10.17,2.72a22.19,22.19,0,0,0,9.6-5.16,92.55,92.55,0,0,0,16.47-18.05A85.93,85.93,0,0,0,836,102.63a71.54,71.54,0,0,0,4.23-18.12,64.78,64.78,0,0,0-.36-15.9A37.12,37.12,0,0,0,836,56.43q-2.79-5-6.59-6.87a9.92,9.92,0,0,0-8.24-.15q-4.44,1.73-8.88,8-2.15,3.15-5.09,6.73t-5.73,7.3q-2.79,3.73-5.3,7.74a35.92,35.92,0,0,0-3.79,8c-.48,1.44-1.22,3.58-2.22,6.45s-2,6.06-3,9.6-1.86,7.23-2.58,11.1a65.81,65.81,0,0,0-1.15,11.1,30,30,0,0,0,1.36,9.67A12.63,12.63,0,0,0,789.89,142Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"mask_1"}},[_c('path',{staticClass:"cls-3",attrs:{"d":"M870,150.69q.85-16.32,1.29-30.22t1.15-27.22q.71-13.32,2.14-27t4.3-29.59a29.72,29.72,0,0,1-3.22,3.3,22.81,22.81,0,0,1-4.3,3,15.63,15.63,0,0,1-4.94,1.72,9.1,9.1,0,0,1-5-.58q-.14-.57,1.44-3.15t4.29-6.16q2.73-3.59,6.16-7.73t7-7.81q3.51-3.66,6.59-6.38A20.57,20.57,0,0,1,892,9.3c1.38-.57,2.27-.33,2.65.72s.1,3.25-.86,6.59c-.29.86-.76,2.36-1.43,4.51s-1.41,4.42-2.22,6.81-1.58,4.63-2.29,6.73-1.27,3.58-1.65,4.44q-.28,2.58-.86,8t-1.36,12.32q-.8,6.89-1.58,14.47c-.52,5.06-1,9.88-1.5,14.47l-1.29,12.32q-.57,5.44-.72,8c-.28,3.82-.43,6.18-.43,7.09s0,1.2.07.86.12-1,.22-1.86.14-1.31.14-1.22q-.14,2.86-.36,8t-.43,10.67q-.21,5.59-.35,10.68t-.29,7.8a6,6,0,0,1-.65,2.73,6.33,6.33,0,0,1-1.71,2.14,4.6,4.6,0,0,1-2.44,1,3.63,3.63,0,0,1-2.65-.86Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"mask_3"}},[_c('path',{staticClass:"cls-3",attrs:{"d":"M905.93,152a8.31,8.31,0,0,1-3.16-6.44,33.49,33.49,0,0,1,.65-8.89,47.21,47.21,0,0,1,2.58-8.59c1.1-2.67,1.93-4.63,2.51-5.87q.71-1.57,2.79-5.52c1.38-2.63,2.86-5.39,4.44-8.31s3.1-5.66,4.58-8.23,2.51-4.4,3.08-5.45a21.21,21.21,0,0,0,0-11Q922,78.07,920,72.12T916.38,60A28.93,28.93,0,0,1,916,47.55c.67-.38,1.56-.86,2.65-1.43s2.25-1.1,3.44-1.58,2.37-.9,3.51-1.29a16.47,16.47,0,0,1,2.72-.71c1.44-.1,3.27-.17,5.52-.22s4.42-.07,6.52-.07,3.91,0,5.44.07a9.15,9.15,0,0,1,2.44.22l7.45,9.88q.29.28-.72,1.29A5.63,5.63,0,0,1,953.2,55a3.2,3.2,0,0,1-1.22.14,3.24,3.24,0,0,1-1.22-.14c-.19-.09-.66-.41-1.43-.93S947.78,53,947,52.42l-2.37-1.65a4.29,4.29,0,0,0-1.43-.78,34.11,34.11,0,0,0-3.44-.22c-1.62-.05-3.36-.07-5.22-.07s-3.61,0-5.23.07a34.11,34.11,0,0,0-3.44.22,4.6,4.6,0,0,0-2.51,3.58,16.29,16.29,0,0,0,.14,5.23A42.1,42.1,0,0,0,924.76,64c.53,1.62.89,2.77,1.08,3.43.29,1.05.71,2.42,1.29,4.09s1.1,3.29,1.57,4.87.91,2.93,1.29,4.08l.72,1.72h2.58L973.11,45q3-2.72,4.66-2.58a2.2,2.2,0,0,1,2.07,1.87,8.85,8.85,0,0,1-.14,4.15,11,11,0,0,1-1.72,4,17.69,17.69,0,0,1-3.58,3.44c-1.53,1.15-3.15,2.24-4.87,3.3s-3.39,2.05-5,3a23.93,23.93,0,0,0-3.87,2.73q-1.86,1.71-4.44,4.22t-5.37,5.16c-1.87,1.77-3.68,3.56-5.45,5.37l-4.8,4.94c-1.43,1.48-2.6,2.68-3.51,3.58a8.76,8.76,0,0,0-1.36,1.51v42.26a16.73,16.73,0,0,1-3.15,9.09,32.59,32.59,0,0,1-7.73,8.24,25.46,25.46,0,0,1-9.75,4.59A10.7,10.7,0,0,1,905.93,152Zm5-10q.72,3.15,3.51,3.22a12.18,12.18,0,0,0,5.87-1.51,19.33,19.33,0,0,0,5.52-4.22q2.43-2.65,2.43-4.94V107.14l-2.43-5q-2.87,3.72-6,8.6A78.11,78.11,0,0,0,914.45,121a54.49,54.49,0,0,0-3.51,10.81A23,23,0,0,0,910.94,142Z","transform":"translate(-0.5 -0.38)"}})])]),_vm._v(" "),_c('g',{staticClass:"logo__primaryText",attrs:{"clip-path":"url(#mask__festival)","data-text":"festival","js-introTextPrimary":""}},[_c('path',{staticClass:"cls-1",attrs:{"data-letter":"f","d":"M87.83,12.48q-1.14,13-1.14,23.27a109.6,109.6,0,0,0,.49,11.63H83.45Q80.19,30.09,73.71,23T55.53,16H50.17a24.65,24.65,0,0,0-7.3.77,4.72,4.72,0,0,0-3.08,3A22.57,22.57,0,0,0,39,26.87V65.44h5.68q8.6,0,13.06-6A36.1,36.1,0,0,0,64,45.24H67.7q-.48,6.42-.48,14.39V67q0,7.82,1,21.74H64.46Q61,68.51,44.66,68.5H39v35.21q0,6.12,1.38,9a7.09,7.09,0,0,0,4.86,3.75,52.35,52.35,0,0,0,11.12,1.07v3.37q-20-.47-29.7-.46-8.12,0-20.45.3L1,120.86V117.8a30,30,0,0,0,7.87-1.23,5.42,5.42,0,0,0,3.41-3.52,28.23,28.23,0,0,0,.89-8.42V28.71a28.23,28.23,0,0,0-.89-8.42,5.42,5.42,0,0,0-3.41-3.52A29.61,29.61,0,0,0,1,15.54V12.48q17.54.46,52.91.46Q77.76,12.94,87.83,12.48Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('g',{attrs:{"data-letter":"e"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M139.11,110.45q13.32,0,21.43-12.25l2.92.92A36.35,36.35,0,0,1,151.85,116q-8.35,7-20.85,7-17.2,0-27.35-10.33T93.51,82.13q0-20.67,10.87-31.61t28.89-11q30.51,0,30.51,34h-45.6q-.17,2.3-.17,7.19,0,10.11,3,16.84t7.79,9.8a18.76,18.76,0,0,0,10.3,3.06Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M132.3,42.79q-5.85,0-9.66,6.81t-4.79,21.05h25.48q.33-12.09-2.51-20t-8.52-7.88Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"data-letter":"s","d":"M205.33,39.58A42,42,0,0,1,216.69,41a28.75,28.75,0,0,1,7.95,3.29,5.5,5.5,0,0,0,2.92,1.07,3,3,0,0,0,2.52-1.45,9.06,9.06,0,0,0,1.38-4.21h3.41q-.66,7.8-.65,26.94h-3.41a37.35,37.35,0,0,0-6.41-16.92q-5-6.81-14.36-6.81a12.27,12.27,0,0,0-8,2.6,8.82,8.82,0,0,0-3.16,7.2,12.23,12.23,0,0,0,3.73,8.95,80.74,80.74,0,0,0,11.69,9.11L219,74q9.9,7,14.61,12.55a20.45,20.45,0,0,1,4.71,13.78,18.67,18.67,0,0,1-4.14,11.94,26.13,26.13,0,0,1-11.12,8A41.77,41.77,0,0,1,207.6,123a33.38,33.38,0,0,1-15.25-3.21,79.5,79.5,0,0,0-7.47-3.22,2.59,2.59,0,0,0-2.84,1,10.38,10.38,0,0,0-1.87,4.36h-3.4q.64-8.73.65-30.62h3.4q3.26,28.17,21.91,28.17a12.4,12.4,0,0,0,8-2.68q3.31-2.67,3.32-8.19a14.44,14.44,0,0,0-2-7.65A23.77,23.77,0,0,0,207,95q-3.07-2.61-9.25-7.2-7.3-5.51-11.12-8.87a32.37,32.37,0,0,1-6.49-8,20.06,20.06,0,0,1-2.68-10.26,17.88,17.88,0,0,1,8.12-15.46q8.11-5.67,19.8-5.66Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"data-letter":"t","d":"M281.12,41.72h19.15v3.06H281.12v61.84q0,4.59,1.71,6.51t5.43,1.91q7,0,11-9.18l2.76,1.37Q295.9,123,279.82,123q-10.71,0-16.23-5.21a16.23,16.23,0,0,1-4.62-8,56.67,56.67,0,0,1-1.22-13.24V44.78H244.12V41.72h13.63V21.51q13.47,0,23.37-4.9V41.72Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('g',{attrs:{"data-letter":"i"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M326.4,2.22q6.83,0,10.79,3.14a10.42,10.42,0,0,1,4,8.65,10.42,10.42,0,0,1-4,8.65q-4,3.14-10.79,3.14t-10.79-3.14a10.42,10.42,0,0,1-4-8.65,10.42,10.42,0,0,1,4-8.65q4-3.14,10.79-3.14Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M339.06,106.62q0,6.28,2.35,8.65t8,2.37v3.22q-16.23-.61-21.59-.61-5,0-22.56.61v-3.22c3.9,0,6.6-.79,8.12-2.37s2.27-4.46,2.27-8.65V58.4q0-7-2.27-10.25c-1.52-2.15-4.22-3.22-8.12-3.22V41.72c3.47.3,6.82.46,10.06.46q14.44,0,23.7-2.15Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"data-letter":"v","d":"M421.67,42.18q8.28,0,12.49-.46v3.06a12.45,12.45,0,0,0-6.08,3.9A30.6,30.6,0,0,0,423,57.94l-23.7,63.22c-1.19-.1-3-.15-5.35-.15s-4,0-5.2.15L359.83,53.5q-2.26-5.2-4.62-6.88a8.13,8.13,0,0,0-4.79-1.69V41.72q11.35.77,23.05.76,10.21,0,21.09-.76v3.21a31.32,31.32,0,0,0-7.87.69q-2.35.69-2.35,3.75a14.62,14.62,0,0,0,.81,3.83l18.5,46.38,11.69-30.31a37.49,37.49,0,0,0,2.59-12.4q0-11.17-11.84-12.09V41.72q7.46.45,15.58.46Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('g',{attrs:{"data-letter":"a"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M470.36,112.13q6.33,0,11-6.27V74.48q-2,3.06-8.28,6.73a38.77,38.77,0,0,0-9.57,7.65q-3.24,3.84-3.25,11,0,6.27,2.76,9.26A9.48,9.48,0,0,0,470.36,112.13Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M457.86,121.93q-10.39,0-15.5-5.05t-5.11-13.32a17.07,17.07,0,0,1,3.81-11.4,25.85,25.85,0,0,1,9.25-7A141.09,141.09,0,0,1,464.19,80a74.84,74.84,0,0,0,13.06-5.28q4.14-2.38,4.14-6.51V56.26q0-6.43-3.16-10t-9.82-3.59c-5.2,0-9.14,1.22-11.85,3.67a15.12,15.12,0,0,1,7.06,4.59,11,11,0,0,1,2.52,7.2,10.12,10.12,0,0,1-3.74,8.26,13.85,13.85,0,0,1-9.08,3.06q-5.69,0-8.77-3.36a12,12,0,0,1-3.08-8.42,11.94,11.94,0,0,1,2.19-7.27,21.27,21.27,0,0,1,6.73-5.59A39,39,0,0,1,461.19,41a66.7,66.7,0,0,1,14-1.37A54.92,54.92,0,0,1,489,41.11a22.07,22.07,0,0,1,9.74,5.2,16.62,16.62,0,0,1,4.78,8.27,57,57,0,0,1,1.22,13.31v41.64a13.26,13.26,0,0,0,.73,5.2,2.85,2.85,0,0,0,2.84,1.53c1.63,0,3.57-.86,5.85-2.6l1.62,2.61q-7.3,5.66-17.85,5.66-8.93,0-12.5-3.37a12.33,12.33,0,0,1-3.73-9q-8.12,12.41-23.86,12.4Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"data-letter":"l","d":"M553.61,106.62q0,6.28,2.27,8.65c1.52,1.58,4.22,2.37,8.12,2.37v3.22q-16.87-.61-21.75-.61-5.52,0-22.39.61v-3.22q5.67,0,8-2.37t2.35-8.65V19.37q0-7-2.35-10.26t-8-3.21V2.68q5.19.47,10.06.46A110.55,110.55,0,0,0,553.61,1Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('g',{attrs:{"clip-path":"url(#mask__franciacorta)","js-introTextSecondary":""}},[_c('path',{staticClass:"cls-1",attrs:{"data-letter":"f","d":"M210.82,202.27q-1.14,13-1.14,23.31a110.1,110.1,0,0,0,.49,11.66h-3.74q-3.24-17.33-9.73-24.38t-18.18-7.06h-5.35a25,25,0,0,0-7.3.77,4.73,4.73,0,0,0-3.09,3,22.64,22.64,0,0,0-.81,7.13v38.65h5.68q8.61,0,13.06-6A36.22,36.22,0,0,0,187,235.09h3.73q-.48,6.45-.48,14.42v7.36q0,7.81,1,21.78h-3.73q-3.4-20.25-19.8-20.25H162v35.28q0,6.13,1.38,9a7.1,7.1,0,0,0,4.87,3.76,52.27,52.27,0,0,0,11.12,1.07v3.37q-20-.45-29.7-.46-8.12,0-20.45.31l-5.19.15v-3.06a30,30,0,0,0,7.87-1.23,5.43,5.43,0,0,0,3.41-3.53,28.7,28.7,0,0,0,.89-8.43V218.53a28.65,28.65,0,0,0-.89-8.43,5.43,5.43,0,0,0-3.41-3.53,30,30,0,0,0-7.87-1.23v-3.06q17.52.45,52.9.46,23.85,0,33.92-.46Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"data-letter":"r","d":"M274.26,229.42q7.31,0,11,4.14a14.35,14.35,0,0,1,3.73,10,12.79,12.79,0,0,1-3.49,9.28,12.18,12.18,0,0,1-9.17,3.6c-3.67,0-6.6-.89-8.76-2.68a8.8,8.8,0,0,1-3.24-7.13q0-7.36,7.14-12a9.45,9.45,0,0,0-1.95-.15,8.74,8.74,0,0,0-2.6.31q-6.16.92-10.47,7.05a21.72,21.72,0,0,0-4.3,12.58v40.64q0,7.05,3.66,9.81t11.6,2.76v3.22c-1.52,0-2.76-.05-3.73-.15q-16.56-.46-22.07-.46-4.38,0-20,.46a29.21,29.21,0,0,1-3.25.15v-3.22c3.9,0,6.6-.79,8.12-2.38s2.27-4.47,2.27-8.66V248.28q0-7-2.27-10.27c-1.52-2.15-4.22-3.22-8.12-3.22v-3.22c3.46.3,6.82.46,10.06.46q14.44,0,23.7-2.15v14.26a26.34,26.34,0,0,1,8.92-10.66,22.46,22.46,0,0,1,13.14-4.06Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('g',{attrs:{"data-letter":"a"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M328.14,302.11q6.33,0,11-6.29V264.39q-1.94,3.06-8.27,6.74a39.05,39.05,0,0,0-9.58,7.67q-3.24,3.84-3.24,11,0,6.29,2.76,9.28a9.47,9.47,0,0,0,7.3,3Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M315.64,311.93q-10.38,0-15.49-5.06T295,293.52a17.1,17.1,0,0,1,3.81-11.42,25.79,25.79,0,0,1,9.25-7A143.11,143.11,0,0,1,322,269.91,75.16,75.16,0,0,0,335,264.62q4.14-2.39,4.14-6.52v-12q0-6.45-3.16-10t-9.82-3.6q-7.79,0-11.84,3.68a15,15,0,0,1,7,4.6,11,11,0,0,1,2.52,7.21,10.16,10.16,0,0,1-3.73,8.28,13.88,13.88,0,0,1-9.09,3.06q-5.69,0-8.76-3.37a13.13,13.13,0,0,1-.9-15.72,21.46,21.46,0,0,1,6.74-5.6A39,39,0,0,1,319,230.8a66.71,66.71,0,0,1,14-1.38A54.83,54.83,0,0,1,346.8,231a22.1,22.1,0,0,1,9.74,5.22,16.65,16.65,0,0,1,4.78,8.28,57.86,57.86,0,0,1,1.22,13.34V299.5a13.16,13.16,0,0,0,.73,5.22,2.84,2.84,0,0,0,2.84,1.53q2.43,0,5.84-2.6l1.62,2.6q-7.29,5.69-17.85,5.68-8.93,0-12.49-3.38a12.38,12.38,0,0,1-3.73-9.05q-8.12,12.44-23.86,12.43Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"data-letter":"n","d":"M438.65,229.42q12.33,0,17.85,6a16.42,16.42,0,0,1,3.89,7.51,53.83,53.83,0,0,1,1.14,12.43v41.25q0,6.29,2.35,8.67t8,2.37v3.22q-16.23-.62-21.42-.61-4.86,0-21.09.61v-3.22q4.86,0,6.81-2.37t2-8.67V248.9c0-4.2-.73-7.36-2.19-9.51s-4.09-3.22-7.87-3.22a14.84,14.84,0,0,0-11.36,5.14A18,18,0,0,0,412,254v42.63q0,6.29,2,8.67t6.82,2.37v3.22q-14.94-.62-20.13-.61-4.86,0-22.39.61v-3.22q5.85,0,8.11-2.37t2.28-8.67V248.28q0-7-2.28-10.27c-1.51-2.15-4.22-3.22-8.11-3.22v-3.22c3.46.3,6.82.46,10.06.46q14.45,0,23.69-2.15v13.8q7.31-14.27,26.62-14.26Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"data-letter":"c","d":"M520.11,229.42a50.65,50.65,0,0,1,11.36,1.23,30.33,30.33,0,0,1,8.92,3.37,18.63,18.63,0,0,1,6.57,6.21,15.18,15.18,0,0,1,2.36,8.21,11.73,11.73,0,0,1-3.57,8.81,12.77,12.77,0,0,1-9.25,3.45,13.09,13.09,0,0,1-9.09-3.06,10.61,10.61,0,0,1-3.41-8.28,11.43,11.43,0,0,1,3.09-8,15.58,15.58,0,0,1,7.62-4.6,8.65,8.65,0,0,0-4-2.68,16.3,16.3,0,0,0-5.76-1q-9.75,0-15.18,10t-5.43,26.31q0,16.41,6.16,23.61A19.45,19.45,0,0,0,526,300.27a25,25,0,0,0,11.12-2.76q5.59-2.76,10.14-9.66l2.76.92a38.16,38.16,0,0,1-11.36,17.1Q530.5,313,517.67,313q-16.71,0-27.26-10.43t-10.55-31q0-13.48,5.2-23a34.51,34.51,0,0,1,14.28-14.34,43.55,43.55,0,0,1,20.77-4.83Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('g',{attrs:{"data-letter":"i"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M579.5,192q6.81,0,10.79,3.14a11.42,11.42,0,0,1,0,17.33q-4,3.15-10.79,3.15t-10.79-3.15a11.42,11.42,0,0,1,0-17.33q4-3.13,10.79-3.14Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M592.16,296.59q0,6.29,2.35,8.67t8,2.37v3.22q-16.23-.62-21.58-.61-5,0-22.56.61v-3.22c3.9,0,6.6-.79,8.12-2.37s2.27-4.48,2.27-8.67V248.28q0-7-2.27-10.27c-1.52-2.15-4.22-3.22-8.12-3.22v-3.22c3.47.3,6.82.46,10.06.46q14.44,0,23.7-2.15v66.71Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('g',{attrs:{"data-letter":"a"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M643.43,302.11q6.33,0,11-6.29V264.39q-2,3.06-8.28,6.74a38.79,38.79,0,0,0-9.57,7.67q-3.24,3.84-3.25,11,0,6.29,2.76,9.28a9.48,9.48,0,0,0,7.3,3Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M630.94,311.93q-10.38,0-15.5-5.06t-5.11-13.35a17.1,17.1,0,0,1,3.81-11.42,26,26,0,0,1,9.25-7,143.42,143.42,0,0,1,13.88-5.21,75.5,75.5,0,0,0,13.06-5.29q4.14-2.39,4.14-6.52v-12q0-6.45-3.17-10t-9.81-3.6c-5.2,0-9.14,1.22-11.85,3.68a15.06,15.06,0,0,1,7.06,4.6,11,11,0,0,1,2.52,7.21,10.17,10.17,0,0,1-3.74,8.28,13.83,13.83,0,0,1-9.08,3.06q-5.68,0-8.77-3.37a13.15,13.15,0,0,1-.89-15.72,21.46,21.46,0,0,1,6.74-5.6,38.91,38.91,0,0,1,10.79-3.83,66.68,66.68,0,0,1,14-1.38A55,55,0,0,1,662.1,231a22,22,0,0,1,9.73,5.22,16.66,16.66,0,0,1,4.79,8.28,57.86,57.86,0,0,1,1.22,13.34V299.5a13.16,13.16,0,0,0,.73,5.22,2.83,2.83,0,0,0,2.84,1.53q2.43,0,5.84-2.6l1.62,2.6q-7.3,5.69-17.85,5.68-8.92,0-12.49-3.38a12.38,12.38,0,0,1-3.74-9.05q-8.12,12.44-23.85,12.43Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"data-letter":"c","d":"M735.77,229.42a50.65,50.65,0,0,1,11.36,1.23,30.33,30.33,0,0,1,8.92,3.37,18.63,18.63,0,0,1,6.57,6.21,15.18,15.18,0,0,1,2.36,8.21,11.73,11.73,0,0,1-3.57,8.81,12.77,12.77,0,0,1-9.25,3.45,13.09,13.09,0,0,1-9.09-3.06,10.61,10.61,0,0,1-3.41-8.28,11.43,11.43,0,0,1,3.09-8,15.58,15.58,0,0,1,7.62-4.6,8.65,8.65,0,0,0-4-2.68,16.3,16.3,0,0,0-5.76-1q-9.74,0-15.18,10T720,269.45q0,16.41,6.16,23.61a19.45,19.45,0,0,0,15.42,7.21,25,25,0,0,0,11.12-2.76q5.6-2.76,10.14-9.66l2.76.92a38.16,38.16,0,0,1-11.36,17.1Q746.16,313,733.33,313q-16.71,0-27.26-10.43t-10.55-31q0-13.48,5.2-23A34.51,34.51,0,0,1,715,234.25a43.58,43.58,0,0,1,20.77-4.83Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('g',{attrs:{"data-letter":"o"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M815.93,229.42q18.66,0,29.21,10t10.55,31.83q0,21.76-10.55,31.74t-29.21,10q-18.49,0-29.13-10t-10.63-31.74q0-21.78,10.63-31.82t29.13-10.05Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M815.93,232.49q-7,0-11.12,9.58t-4.13,29.22q0,19.62,4.13,29.14t11.12,9.5q7.14,0,11.2-9.43t4-29.21q0-19.78-4.13-29.29t-11.12-9.51Z","transform":"translate(-0.5 -0.38)"}})]),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"data-letter":"r","d":"M921.57,229.42q7.3,0,11,4.14a14.36,14.36,0,0,1,3.74,10,12.83,12.83,0,0,1-3.49,9.28,12.21,12.21,0,0,1-9.17,3.6q-5.52,0-8.76-2.68a8.78,8.78,0,0,1-3.25-7.13q0-7.36,7.14-12a9.32,9.32,0,0,0-1.95-.15,8.67,8.67,0,0,0-2.59.31q-6.16.92-10.47,7.05a21.65,21.65,0,0,0-4.3,12.58v40.64q0,7.05,3.65,9.81t11.6,2.76v3.22c-1.51,0-2.75-.05-3.73-.15q-16.54-.46-22.07-.46-4.38,0-20,.46a28.89,28.89,0,0,1-3.24.15v-3.22c3.89,0,6.6-.79,8.11-2.38s2.27-4.47,2.27-8.66V248.28q0-7-2.27-10.27c-1.51-2.15-4.22-3.22-8.11-3.22v-3.22c3.46.3,6.81.46,10.06.46q14.45,0,23.69-2.15v14.26a26.36,26.36,0,0,1,8.93-10.66,22.44,22.44,0,0,1,13.14-4.06Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"data-letter":"t","d":"M974.47,231.57h19.15v3.06H974.47v62q0,4.61,1.7,6.52c1.14,1.28,3,1.91,5.44,1.91q7,0,11-9.2l2.76,1.38Q989.23,313,973.17,313q-10.71,0-16.23-5.21a16.28,16.28,0,0,1-4.62-8.06,56.8,56.8,0,0,1-1.22-13.26V234.63H937.47v-3.06H951.1V211.32q13.47,0,23.37-4.9v25.15Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('g',{attrs:{"data-letter":"a"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M1020.07,311.93q-10.4,0-15.5-5.06t-5.11-13.35a17.1,17.1,0,0,1,3.81-11.42,26,26,0,0,1,9.25-7,143.42,143.42,0,0,1,13.88-5.21,75.5,75.5,0,0,0,13.06-5.29q4.14-2.39,4.14-6.52v-12q0-6.45-3.17-10t-9.81-3.6c-5.2,0-9.14,1.22-11.85,3.68a15.06,15.06,0,0,1,7.06,4.6,11,11,0,0,1,2.51,7.21,10.16,10.16,0,0,1-3.73,8.28,13.88,13.88,0,0,1-9.09,3.06q-5.67,0-8.76-3.37a13.15,13.15,0,0,1-.89-15.72,21.41,21.41,0,0,1,6.73-5.6,39,39,0,0,1,10.79-3.83,66.85,66.85,0,0,1,14-1.38,54.83,54.83,0,0,1,13.79,1.53,22,22,0,0,1,9.74,5.22,16.66,16.66,0,0,1,4.79,8.28,57.94,57.94,0,0,1,1.21,13.34V299.5a13.35,13.35,0,0,0,.73,5.22,2.85,2.85,0,0,0,2.84,1.53c1.63,0,3.57-.87,5.85-2.6l1.62,2.6q-7.3,5.69-17.85,5.68-8.93,0-12.49-3.38a12.38,12.38,0,0,1-3.74-9.05q-8.12,12.44-23.85,12.43Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M1032.56,302.11q6.33,0,11-6.29V264.39q-1.95,3.06-8.28,6.74a38.79,38.79,0,0,0-9.57,7.67q-3.24,3.84-3.25,11,0,6.29,2.76,9.28a9.48,9.48,0,0,0,7.3,3Z","transform":"translate(-0.5 -0.38)"}})])]),_vm._v(" "),_c('g',{attrs:{"js-introTextHand":""}},[_c('path',{staticClass:"cls-2",attrs:{"clip-path":"url(#mask_2)","d":"M696.45,64.75s23.44-24.16,25.89-23.44a4.29,4.29,0,0,1,3.3,3.74c.29,1.43.15,13.23,0,15.82s-21.86,74.06-44.58,87.44c-7.91,4.31-3.16-14.24,5.9-25.46s19.35-13.48,22.14-13.09c8.2,1.15,11.65,5.32,30.93,1.87s28.33-5.89,28.33-5.89","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-2",attrs:{"clip-path":"url(#mask_0)","d":"M824.73,45.19s10.64-.57,15.1,11.22,7.62,35.66-3.31,53.93-28.33,44.07-42.85,39-17.26-17-8.06-55S816,44.18,824.73,45.19Z","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-2",attrs:{"clip-path":"url(#mask_1)","d":"M861.37,44.11s25.27-30.4,24.25-23.78-5.93,33.11-7.55,50.94-5.45,85.3-5.45,85.3","transform":"translate(-0.5 -0.38)"}}),_vm._v(" "),_c('path',{staticClass:"cls-2",attrs:{"clip-path":"url(#mask_3)","d":"M954.92,53.71s-9.2-8.73-15.06-8.58-16.3.65-18.08,3.46-2.88,4.34-2.46,7.14,12.39,39,12.9,48.9,1.27,27.5-.76,31.58-10.19,15.15-19.1,13.81S907,134.17,908,130.6s10.41-28,24.42-42.12,26.49-27.14,29.29-28.67S980,47.33,980,47.33","transform":"translate(-0.5 -0.38)"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"muselet muselet__wrapper"},[_c('div',{ref:"musletdot",staticClass:"muselet__dot"},[_c('svg',{staticClass:"muselet",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 600 600"}},[_c('defs',[_c('filter',{attrs:{"id":"blurred"}},[_c('feGaussianBlur',{attrs:{"in":"SourceGraphic","stdDeviation":"5"}})],1),_vm._v(" "),_c('clipPath',{attrs:{"id":"clip-path__image","clipPathUnits":"userSpaceOnUse"}},[_c('path',{staticClass:"muselet__path muselet__path--first",attrs:{"d":"M189.4,567.8c-77.8-18.6-138.5-79.4-157.2-157.2c-42.2-67.9-42.2-153.9,0-221.8C50.9,111,111.6,50.3,189.4,31.6c67.9-42.2,153.9-42.2,221.8,0C489,50.2,549.8,111,568.4,188.8c42.2,67.9,42.2,153.9,0,221.8c-18.6,77.8-79.4,138.5-157.2,157.2C343.1,609.2,257.5,609.3,189.4,567.8z","fill-rule":"evenodd","fill":"#FFD300","filter":"url(#blurred)"}})])]),_vm._v(" "),_c('path',{staticClass:"muselet__path muselet__path--first",attrs:{"d":"M189.4,567.8c-77.8-18.6-138.5-79.4-157.2-157.2c-42.2-67.9-42.2-153.9,0-221.8C50.9,111,111.6,50.3,189.4,31.6c67.9-42.2,153.9-42.2,221.8,0C489,50.2,549.8,111,568.4,188.8c42.2,67.9,42.2,153.9,0,221.8c-18.6,77.8-79.4,138.5-157.2,157.2C343.1,609.2,257.5,609.3,189.4,567.8z","fill-rule":"evenodd","fill":"#FFD300"}}),_vm._v(" "),_c('path',{staticClass:"muselet__path muselet__path--last",attrs:{"d":"M168 523c-36.8-21.7-65.7-51.3-87.8-87.7-9.6-15.9-17.1-32.8-22.4-50.8-1.3-4.5-3.2-8.7-5.8-12.6-20-30.8-31.3-64.3-32.8-101.2-1.4-36.6 7.3-70.2 27.2-100.9 1.2-1.7 1.7-3.6 2.3-5.5 13.5-53.7 47-89.6 97.5-110.7 12.8-5.4 26.1-9.2 39.9-11.7 9.6-1.7 17.8-7.4 26.9-10.8 43.2-16.1 86.8-17.9 130.7-4 16.9 5.3 32.4 13.5 46.6 23.9 2 1.4 4 2.8 6.5 3.7 45.3 14.8 80.8 42.8 108.7 80.9 15.8 21.7 27.9 45.1 36.2 70.6.5 1.5 1.3 3.1 2.3 4.4 23.6 34.2 36.7 72 37 113.7.3 31.8-6.6 62-22.1 90.1-1.6 3-2.7 6.1-3.4 9.3-12.6 58.7-46.9 99.8-101.4 124.3-10.7 4.8-22.1 7.9-33.6 9.9-3.4.6-6.4 1.8-9.4 3.3-47.6 23.7-96.7 28-147.3 10.5-17.9-6.2-34.5-15.3-49.9-26.5-3.2-2.3-6.5-4.1-10.1-5.3-10-3.4-19.5-8-28.8-12.9-2.1-1.6-4.7-2.5-7-4z","fill-rule":"evenodd","fill":"none"}})]),_vm._v(" "),(_vm.$route.name ==='home' && !_vm.isMobile())?_c('div',{staticClass:"composition-cont",staticStyle:{"opacity":"0"}},_vm._l((35),function(numb,index){return _c('img',{key:index,staticClass:"image-fade",style:({ zIndex: index === 0 ? 35 : 0 }),attrs:{"src":("/static/img/composition/" + index + ".jpg"),"alt":"composition image"}})})):_vm._e(),_vm._v(" "),(!_vm.isMobile())?_c('div',{staticClass:"logo-winary"}):_vm._e()]),_vm._v(" "),_c('Logo',{staticClass:"logo-container"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artwork_vue__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505a5872_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artwork_vue__ = __webpack_require__(455);
function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-505a5872"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artwork_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_505a5872_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artwork_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artwork"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4439a52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(460);
function injectStyle (ssrContext) {
  __webpack_require__(457)
  __webpack_require__(458)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e4439a52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4439a52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




/**
 * MARQUEE 3000 MARQUEE 3000 MARQUEE 3000 MARQUEE 3000 MARQUEE 3000
 * http://github.com/ezekielaquino/marquee3000
 * Marquees for the new millenium v1.0
 * MIT License
 */

var Marquee3k = function () {
  function Marquee3k(element, options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Marquee3k);

    this.element = element;
    this.selector = options.selector;
    this.speed = element.dataset.speed || 0.25;
    this.pausable = element.dataset.pausable;
    this.reverse = element.dataset.reverse;
    this.paused = false;
    this.parent = element.parentElement;
    this.parentProps = this.parent.getBoundingClientRect();
    this.content = element.children[0];
    this.innerContent = this.content.innerHTML;
    this.wrapStyles = '';
    this.offset = 0;

    this._setupWrapper();
    this._setupContent();
    this._setupEvents();

    this.wrapper.appendChild(this.content);
    this.element.appendChild(this.wrapper);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Marquee3k, [{
    key: '_setupWrapper',
    value: function _setupWrapper() {
      this.wrapper = document.createElement('div');
      this.wrapper.classList.add('marquee3k__wrapper');
      this.wrapper.style.whiteSpace = 'nowrap';
    }
  }, {
    key: '_setupContent',
    value: function _setupContent() {
      this.content.classList.add(this.selector + '__copy');
      this.content.style.display = 'inline-block';
      this.contentWidth = this.content.offsetWidth;

      this.requiredReps = this.contentWidth > this.parentProps.width ? 2 : Math.ceil((this.parentProps.width - this.contentWidth) / this.contentWidth) + 1;

      for (var i = 0; i < this.requiredReps; i++) {
        this._createClone();
      }

      if (this.reverse) {
        this.offset = this.contentWidth * -1;
      }

      this.element.classList.add('is-init');
    }
  }, {
    key: '_setupEvents',
    value: function _setupEvents() {
      var _this = this;

      this.element.addEventListener('mouseenter', function () {
        if (_this.pausable) _this.paused = true;
      });

      this.element.addEventListener('mouseleave', function () {
        if (_this.pausable) _this.paused = false;
      });
    }
  }, {
    key: '_createClone',
    value: function _createClone() {
      var clone = this.content.cloneNode(true);
      clone.style.display = 'inline-block';
      clone.classList.add(this.selector + '__copy');
      this.wrapper.appendChild(clone);
    }
  }, {
    key: 'animate',
    value: function animate() {
      if (!this.paused) {
        var isScrolled = this.reverse ? this.offset < 0 : this.offset > this.contentWidth * -1;
        var direction = this.reverse ? -1 : 1;
        var reset = this.reverse ? this.contentWidth * -1 : 0;

        if (isScrolled) this.offset -= this.speed * direction;else this.offset = reset;

        this.wrapper.style.whiteSpace = 'nowrap';
        this.wrapper.style.transform = 'translate(' + this.offset + 'px, 0) translateZ(0)';
      }
    }
  }, {
    key: '_refresh',
    value: function _refresh() {
      this.contentWidth = this.content.offsetWidth;
    }
  }, {
    key: 'repopulate',
    value: function repopulate(difference, isLarger) {
      this.contentWidth = this.content.offsetWidth;

      if (isLarger) {
        var amount = Math.ceil(difference / this.contentWidth) + 1;

        for (var i = 0; i < amount; i++) {
          this._createClone();
        }
      }
    }
  }], [{
    key: 'refresh',
    value: function refresh(index) {
      MARQUEES[index]._refresh();
    }
  }, {
    key: 'refreshAll',
    value: function refreshAll() {
      for (var i = 0; i < MARQUEES.length; i++) {
        MARQUEES[i]._refresh();
      }
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { selector: 'marquee3k' };

      window.MARQUEES = [];
      if (window.animationId) window.cancelAnimationFrame(window.animationId);
      var marquees = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('.' + options.selector));
      var previousWidth = window.innerWidth;
      var timer = void 0;

      for (var i = 0; i < marquees.length; i++) {
        var marquee = marquees[i];
        var instance = new Marquee3k(marquee, options);
        MARQUEES.push(instance);
      }

      animate();

      function animate() {
        for (var _i = 0; _i < MARQUEES.length; _i++) {
          MARQUEES[_i].animate();
        }
        window.animationId = window.requestAnimationFrame(animate);
      }

      window.addEventListener('resize', function () {
        clearTimeout(timer);

        timer = setTimeout(function () {
          var isLarger = previousWidth < window.innerWidth;
          var difference = window.innerWidth - previousWidth;

          for (var _i2 = 0; _i2 < MARQUEES.length; _i2++) {
            MARQUEES[_i2].repopulate(difference, isLarger);
          }

          previousWidth = _this2.innerWidth;
        });
      }, 250);
    }
  }]);

  return Marquee3k;
}();

// return Marquee3k;


/* harmony default export */ __webpack_exports__["a"] = (Marquee3k);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",attrs:{"itemprop":"description"}},[_c('div',{staticClass:"footer__wrapper anim__wrapper"},[_c('div',{staticClass:"svg-container",attrs:{"data-anim":_vm.isMobile() ? false : ''}},[_c('img',{staticClass:"footer__svg",attrs:{"src":"/static/vector/logo.svg","alt":"Bersi Serlini"}}),_vm._v(" "),_c('img',{staticClass:"footer__svg",attrs:{"src":"/static/vector/festival-franciacorta.svg","alt":"Festival Franciacorta"}})]),_vm._v(" "),_c('div',{staticClass:"marquee"},[_c('div',{staticClass:"marquee-cont marquee3k",attrs:{"data-speed":"0.75","data-pausable":"true","data-anim":_vm.isMobile() ? false : '',"js-ref":_vm.hideMobile}}),_vm._v(" "),_c('div',{staticClass:"u-visuallyhidden"},[_c('p',{ref:"it",attrs:{"data-lang":"it"}},[_vm._v("\n          Sabato 15 e Domenica 16 Settembre 2018 dalle 10 alle 2\n          "),_c('a',{attrs:{"href":"https://goo.gl/maps/bEUcaufrqT52","rel":"noopener","target":"_blank","data-mouse":"","data-mouse-attractionstate":"disactive","data-hover-type":"zoom"}},[_vm._v("- Cantine Bersi Serlini: Via Cereto, 7 25050 Provaglio di Iseo (Bs)")]),_vm._v(" "),_c('a',{attrs:{"href":"tel:+390309823338","rel":"noopener","data-mouse":"","data-mouse-attractionstate":"disactive","data-hover-type":"zoom"}},[_vm._v("- Tel: +39 030 9823338")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:festival@bersiserlini.it","rel":"noopener","data-mouse":"","data-mouse-attractionstate":"disactive","data-hover-type":"zoom"}},[_vm._v("\n            - Mail: festival@bersiserlini.it")])]),_vm._v(" "),_c('p',{ref:"en",attrs:{"data-lang":"en"}},[_vm._v("\n          Saturday 15 and Sunday 16 September 2018 from 10am to 2am - Cantine Bersi Serlini:\n          "),_c('a',{attrs:{"href":"https://goo.gl/maps/bEUcaufrqT52","rel":"noopener","target":"_blank","data-mouse":"","data-mouse-attractionstate":"disactive","data-hover-type":"zoom"}},[_vm._v("Via Cereto, 7 - 25050 Provaglio di Iseo (Bs)")]),_vm._v(" "),_c('a',{attrs:{"href":"tel:+390309823338","rel":"noopener","data-mouse":"","data-mouse-attractionstate":"disactive","data-hover-type":"zoom"}},[_vm._v("- Tel: +39 030 9823338")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:visite@bersiserlini.it","rel":"noopener","data-mouse":"","data-mouse-attractionstate":"disactive","data-hover-type":"zoom"}},[_vm._v("Mail: festival@bersiserlini.it")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BgNoise_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3151c6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgNoise_vue__ = __webpack_require__(463);
function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3151c6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BgNoise_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3151c6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgNoise_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"noise",staticClass:"noise"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pointer_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b8b426c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pointer_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(465)
  __webpack_require__(466)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b8b426c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pointer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b8b426c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pointer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pointer",staticClass:"cursor"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 77 77"}},[_c('path',{staticClass:"cursor-hover",attrs:{"d":"M24.6 72.1C14.9 69.8 7.3 62.2 5 52.4-.3 43.9-.3 33.1 5 24.6 7.3 14.9 14.9 7.3 24.6 5 33.1-.3 43.9-.3 52.3 5 62 7.3 69.6 14.9 72 24.7c5.3 8.5 5.3 19.3 0 27.8-2.3 9.7-9.9 17.3-19.7 19.7-8.4 5.1-19.2 5.1-27.7-.1z","fill":"#ffd300","stroke":"#ffd300","stroke-width":"2"}}),_vm._v(" "),_c('path',{ref:"pathmdown",staticClass:"cursor-mdown",attrs:{"d":"M24.6 72.1C14.9 69.8 7.3 62.2 5 52.4-.3 43.9-.3 33.1 5 24.6 7.3 14.9 14.9 7.3 24.6 5 33.1-.3 43.9-.3 52.3 5 62 7.3 69.6 14.9 72 24.7c5.3 8.5 5.3 19.3 0 27.8-2.3 9.7-9.9 17.3-19.7 19.7-8.4 5.1-19.2 5.1-27.7-.1z","fill":"#ffd300","stroke":"#ffd300","stroke-width":"2"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleSwitch_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_937253d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleSwitch_vue__ = __webpack_require__(477);
function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-937253d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleSwitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_937253d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleSwitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"CircleSwitch",staticClass:"el-transition"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 77 77"}},[_c('path',{attrs:{"d":"M24.6 72.1C14.9 69.8 7.3 62.2 5 52.4-.3 43.9-.3 33.1 5 24.6 7.3 14.9 14.9 7.3 24.6 5 33.1-.3 43.9-.3 52.3 5 62 7.3 69.6 14.9 72 24.7c5.3 8.5 5.3 19.3 0 27.8-2.3 9.7-9.9 17.3-19.7 19.7-8.4 5.1-19.2 5.1-27.7-.1z","fill":"#ffd300"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Whistle_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4049eb0f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Whistle_vue__ = __webpack_require__(480);
function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Whistle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4049eb0f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Whistle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timelines_indexTransition__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timelines_eventTransition__ = __webpack_require__(483);




var transition = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

transition.set('index', __WEBPACK_IMPORTED_MODULE_1__timelines_indexTransition__["a" /* default */]);
transition.set('event', __WEBPACK_IMPORTED_MODULE_2__timelines_eventTransition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (transition);

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TimelineLite__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_timelines_eventsListTransitions__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_timelines_buttonsTransitions__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_timelines_museletTransitions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_timelines_uiTransitions__ = __webpack_require__(209);






// import { canvasIn } from '@/scripts/timelines/canvasTransitions';



var indexTransition = function indexTransition(el, dir, prevPage, callback) {
  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TimelineLite__["a" /* TimelineLite */]();

  var eventsListInTl = function eventsListInTl() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__scripts_timelines_eventsListTransitions__["a" /* eventsListIn */])(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('[js-anim="eventsList"]', el)).play();
  };
  var buttonInTl = function buttonInTl() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__scripts_timelines_buttonsTransitions__["a" /* buttonIn */])(el).play();
  }; // eslint-disable-line

  var footerInTl = function footerInTl() {
    var animUiIn = Object(__WEBPACK_IMPORTED_MODULE_5__scripts_timelines_uiTransitions__["a" /* uiIn */])(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('footer'));
    animUiIn.play();
    animUiIn.eventCallback('onComplete', callback);
  };

  var headerInTl = function headerInTl() {
    var animUiIn = Object(__WEBPACK_IMPORTED_MODULE_5__scripts_timelines_uiTransitions__["a" /* uiIn */])(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('header'));
    animUiIn.play();
  };

  var eventsListOutTl = function eventsListOutTl() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__scripts_timelines_eventsListTransitions__["b" /* eventsListOut */])(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["g" /* qsa */])('.js-splittedchars', el)).progress(1, false).timeScale(3).reverse();
  };

  var buttonOutTl = function buttonOutTl() {
    var animButtonOut = Object(__WEBPACK_IMPORTED_MODULE_3__scripts_timelines_buttonsTransitions__["b" /* buttonOut */])(el);
    animButtonOut.play();
    animButtonOut.eventCallback('onComplete', callback);
  };

  var museletInTl = function museletInTl() {
    var animMuseletIn = Object(__WEBPACK_IMPORTED_MODULE_4__scripts_timelines_museletTransitions__["a" /* museletIn */])(document);

    animMuseletIn.play();
    animMuseletIn.eventCallback('onComplete', callback);
  };

  var footerOutTl = function footerOutTl() {
    Object(__WEBPACK_IMPORTED_MODULE_5__scripts_timelines_uiTransitions__["b" /* uiOut */])(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('footer')).play();
  };

  if (dir === 'in') {
    if (prevPage === 'loader') {
      tl.add(eventsListInTl, 0.2).add(buttonInTl, 2).add(headerInTl, 1).add(footerInTl, 1.4);
    } else if (prevPage === 'event') {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["d" /* isMobile */])()) tl.add(footerInTl);
      tl.add(eventsListInTl, 0.2).add(buttonInTl, 2).add(museletInTl, 0);
    }
  } else {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["d" /* isMobile */])()) tl.add(footerOutTl);
    tl.add(eventsListOutTl).add(buttonOutTl, 1);
  }

  return tl;
};

/* harmony default export */ __webpack_exports__["a"] = (indexTransition);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_timelines_eventPageTransitions__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_timelines_buttonsTransitions__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_timelines_museletTransitions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_timelines_uiTransitions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_timelines_numberTransitions__ = __webpack_require__(485);










var eventTransition = function eventTransition(el, dir, prevPage, nextPage, callback) {
  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]();

  var eventInTl = function eventInTl() {
    var animEventIn = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_timelines_eventPageTransitions__["a" /* eventIn */])(el);

    animEventIn.play();

    if (prevPage === 'event') {
      animEventIn.eventCallback('onComplete', function () {
        callback();
      });
    }
  };

  var eventOutTl = function eventOutTl() {
    var animEventOut = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_timelines_eventPageTransitions__["b" /* eventOut */])(el);
    animEventOut.play().timeScale(1.5).eventCallback('onComplete', function () {
      callback();
    });
  };

  var ButtonInTl = function ButtonInTl() {
    var animButtonIn = Object(__WEBPACK_IMPORTED_MODULE_3__scripts_timelines_buttonsTransitions__["a" /* buttonIn */])(el);
    animButtonIn.play();
    if (prevPage === 'index' || prevPage === 'loader') {
      animButtonIn.eventCallback('onComplete', function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.event__btns').classList.remove('avoid');
        callback();
      });
    }
  };

  var buttonOutTl = function buttonOutTl() {
    Object(__WEBPACK_IMPORTED_MODULE_3__scripts_timelines_buttonsTransitions__["b" /* buttonOut */])(el).play().timeScale(2);
  };

  var museletOutTl = function museletOutTl() {
    Object(__WEBPACK_IMPORTED_MODULE_4__scripts_timelines_museletTransitions__["c" /* museletOut */])(document);
  };

  var numberInTl = function numberInTl() {
    Object(__WEBPACK_IMPORTED_MODULE_6__scripts_timelines_numberTransitions__["a" /* numberIn */])(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.number', el)).play();
  };

  var numberOutTl = function numberOutTl() {
    Object(__WEBPACK_IMPORTED_MODULE_6__scripts_timelines_numberTransitions__["b" /* numberOut */])(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.number', el)).play();
  };

  var uiTl = function uiTl() {
    Object(__WEBPACK_IMPORTED_MODULE_5__scripts_timelines_uiTransitions__["a" /* uiIn */])(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('header')).play();
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["d" /* isMobile */])()) {
      Object(__WEBPACK_IMPORTED_MODULE_5__scripts_timelines_uiTransitions__["a" /* uiIn */])(Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('footer')).play();
    }
  };

  if (dir === 'in') {
    if (prevPage === 'loader') {
      tl.add(museletOutTl, 0).add(uiTl, 2).add(eventInTl, 1).add(numberInTl, 1).add(ButtonInTl, 1);
    }
    if (prevPage === 'event') {
      tl.add(numberInTl).add(eventInTl).eventCallback('onComplete', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["f" /* qs */])('.event__btns').classList.remove('avoid');
      });
    }
    if (prevPage === 'index') {
      tl.add(museletOutTl, 0).add(numberInTl, 1).add(eventInTl, 1).add(ButtonInTl, 1);
    }
  } else if (dir === 'out') {
    if (nextPage === 'event') {
      tl.add(numberOutTl).add(eventOutTl);
    } else {
      tl.add(numberOutTl).add(buttonOutTl).add(eventOutTl);
    }
  }

  return tl;
};

/* harmony default export */ __webpack_exports__["a"] = (eventTransition);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_lib_gsap_bonus_SplitText__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_utils__ = __webpack_require__(4);

 //eslint-disable-line



var eventIn = function eventIn(el) {
  var splitTitle = new __WEBPACK_IMPORTED_MODULE_1__assets_lib_gsap_bonus_SplitText__["a" /* default */](Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["f" /* qs */])('.event__title', el), { type: 'lines, chars', linesClass: 'js-splittedlines', wordsClass: 'js-splittedwords', charsClass: 'js-splittedchars' });

  var title = splitTitle.chars;
  var details = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["g" /* qsa */])('.event__details p', el);
  var info = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["g" /* qsa */])('.event__info .details', el);

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({ paused: true });
  tl.add('start').set(el, { autoAlpha: 1 }).staggerFrom(title, 1.2, {
    yPercent: 100,
    autoAlpha: 0,
    skewX: -20,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1)
  }, 0.017).staggerFrom(details, 2.2, {
    y: 10,
    autoAlpha: 0,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(1.2, 0.8)
  }, 0.1, 'start+=0.5').staggerFrom(info, 2, {
    y: 10,
    autoAlpha: 0,
    skewX: -20,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(1.2, 0.8)
  }, 0.05, 'start+=1');

  return tl;
};

var eventOut = function eventOut(el) {
  var title = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["g" /* qsa */])('.event__title', el);
  var details = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["g" /* qsa */])('.event__details p', el);
  var info = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["g" /* qsa */])('.event__info .details', el);

  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({ paused: true });
  tl.add('start').staggerTo(title, 1, {
    yPercent: -10,
    autoAlpha: 0,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(0.8, 1)
  }, 0.017, 'start').staggerTo(details, 1.2, {
    y: -10,
    autoAlpha: 0,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(1.2, 0.8)
  }, 0.1, 'start+=0.15').staggerTo(info, 1.2, {
    y: -10,
    autoAlpha: 0,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["a" /* Elastic */].easeOut.config(1.2, 0.8)
  }, 0.05, 'start+=0.3');

  return tl;
};

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return numberIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return numberOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_lib_gsap_bonus_MorphSVGPlugin__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_utils__ = __webpack_require__(4);

 //eslint-disable-line



var numberIn = function numberIn(el) {
  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({ paused: true });

  var d0 = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["f" /* qs */])('[js-path="d0"]', el);
  var dn = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["f" /* qs */])('[js-path="dn"]', el);
  var n0 = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["f" /* qs */])('[js-path="n0"]', el);
  var nn = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["f" /* qs */])('[js-path="nn"]', el);

  tl.set(el, { autoAlpha: 1 }).set(d0, { autoAlpha: 0.1 }).set(dn, { autoAlpha: 0.1 }).to(d0, 1.5, {
    morphSVG: n0,
    autoAlpha: 1,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Expo */].easeOut
  }, 0).to(dn, 1.5, {
    morphSVG: nn,
    autoAlpha: 1,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Expo */].easeOut
  }, 0);

  return tl;
};

var numberOut = function numberOut(el) {
  var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["g" /* TimelineLite */]({ paused: true });

  tl.to(el, 1, {
    autoAlpha: 0,
    ease: __WEBPACK_IMPORTED_MODULE_0_gsap_TweenMax__["b" /* Expo */].easeOut
  });

  return tl;
};

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","js-view":_vm.$route.name}},[_c('div',{staticClass:"app__wrapper"},[_c('Header'),_vm._v(" "),_c('transition',{attrs:{"css":false,"mode":"out-in","name":"total"},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('main',{attrs:{"js-pagecontainer":""}},[_c('Muselet'),_vm._v(" "),_c('transition',{attrs:{"css":false,"mode":"out-in","name":"routerView"},on:{"enter":_vm.enter,"leave":_vm.leave}},[(!_vm.loading)?_c('router-view',{key:_vm.path}):_vm._e()],1),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"event__btns",class:_vm.$route.name !== 'event' ? 'hide': false},_vm._l((_vm.buttons),function(btn,index){return _c('Cta',{key:index,class:("btn-js btn--" + (btn.symbol)),attrs:{"btn":btn,"js-refPage":"event"},nativeOn:{"click":function($event){return _vm.avoidInteractions($event)}}})})):_vm._e(),_vm._v(" "),_c('Artwork')],1)]),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('BgNoise'),_vm._v(" "),(!_vm.isDevice())?_c('Pointer'):_vm._e(),_vm._v(" "),_c('Whistle'),_vm._v(" "),_c('CircleSwitch')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[210]);


// WEBPACK FOOTER //
// static/js/app.294e9ad3b56eb04f6a15.js